<template>
  <v-row class="fill-height">
    <v-col>
      <v-container v-if="alertState">
        <v-row>
          <v-col cols="12">
            <v-alert
              outlined
              text
              :type="alertType"
            >
              {{ alertText }}
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog
        v-model="alertDefaultPwd"
        persistent
        max-width="500"
      >
        <v-card
          dark
          color="warning"
        >
          <v-card-title>
            <span>
              <v-icon>mdi-alert-circle</v-icon> Change the default password
            </span>
          </v-card-title>
          <v-card-text>
            Your password is still using the default by system, please change
            it.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="closeAlertDefaultPwd"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="closeAndShow"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="changeDefaultPwd"
        max-width="500px"
        persistent
      >
        <v-card outlined>
          <v-toolbar
            light
            flat
          >
            <v-spacer />
            <div class="pt-3">
              <p class="text-center headline">
                <v-icon
                  color="#00ACDC"
                  class="mx-2"
                >
                  mdi-lock-reset
                </v-icon>Change the default password
              </p>
            </div>
            <div class="flex-grow-1" />
          </v-toolbar>
          <v-card-text class="my-0">
            <v-form
              ref="form_change_password"
              v-model="valid"
              lazy-validation
            >
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                  >
                    <v-text-field
                      outlined
                      color="success"
                      label="Default password"
                      v-model="defaultPassword"
                      :rules="defaultPasswordRules"
                      required
                      type="password"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                  >
                    <v-text-field
                      outlined
                      color="success"
                      label="New password"
                      v-model="newPassword"
                      :rules="passwordRules"
                      required
                      type="password"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                  >
                    <v-text-field
                      outlined
                      color="success"
                      label="Confirm new password"
                      v-model="confirmNewPassword"
                      :rules="confirmPasswordRules"
                      required
                      type="password"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeAlertChangePwd"
              type="submit"
              color="error"
            >
              Cancel
            </v-btn>
            <v-btn
              @click="updatePassword"
              color="success"
              :loading="loadingUpdate"
              :disable="loadingUpdate"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="successDialog"
        persistent
        max-width="500"
      >
        <v-card
          dark
          color="success"
        >
          <v-card-title>
            <span>
              <v-icon>mdi-check-circle</v-icon> Success to update password!
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="successDialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card
        class="mx-2"
        elevation="4"
        shaped
        outlined
        v-show="!overlay"
      >
        <v-card-title
          v-if="page === 'form'"
          class="headline"
        >
          Create Booking
        </v-card-title>
        <!-- <v-card-text class="mb-0 pb-0">
          <div class="font-weight-bold"> Search Available Schedule</div>
        </v-card-text> -->
        <v-card-text
          v-if="page === 'booking'"
          style="overflow:auto;"
        >
          <v-container
            v-if="page === 'booking'"
            style="overflow:auto;"
          >
            <v-row>
              <v-col class="py-0">
                <v-form
                  ref="form"
                  v-model="form"
                  lazy-validation
                >
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-combobox
                          :items="assetTypes"
                          item-text="name"
                          item-value="id"
                          v-model="selectedAssetType"
                          outlined
                          append-icon="mdi-car"
                          hide-details
                          required
                          :rules="rules"
                          @change="updateListAssetGroup"
                        >
                          <template #label>
                            <span>Asset Type</span>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-autocomplete
                          :items="getOrigin"
                          :item-text="origin => `${origin.name}`"
                          :item-value="origin => `${origin.Id}`"
                          label="Select Origin"
                          append-icon="mdi-map-marker"
                          outlined
                          v-model="origin_id"
                          required
                          hide-details
                          :rules="rules"
                        >
                          <template #no-data>
                            <p class="my-0 px-3 pt-1 font-weight-light">
                              No data Origin available. You can create on
                              <b><router-link
                                to="/geofence"
                              >Geofence page</router-link></b>
                            </p>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-menu
                          v-model="dateBooking"
                          :close-on-content-click="true"
                          max-width="290"
                        >
                          <template #activator="{ on, attrs }">
                            <v-text-field
                              :value="computedDateFormattedMomentjs"
                              clearable
                              label="Date"
                              append-icon="mdi-calendar"
                              outlined
                              v-bind="attrs"
                              v-on="on"
                              @click:clear="date = null"
                              required
                              :rules="rules"
                            />
                          </template>
                          <v-date-picker
                            v-model="dateToday"
                          />
                        </v-menu>
                      </v-col>
                    </v-row>
                    <div
                      class="borderDestination pa-4"
                      v-if="isTypeVehicle && (!isHideBookingDestination || !isHideSearchAddress)"
                    >
                      <v-card-title
                        class="pa-1 black--text"
                        v-if="isTypeVehicle && !isHideBookingDestination && dataPopular.length"
                      >
                        {{ isHideBookingDestination || dataPopular.length == 0 ? '' : 'Select a Destination' }}
                        <v-tooltip
                          bottom
                          v-if="selectedPopId"
                        >
                          <template #activator="{ on, attrs }">
                            <v-btn
                              small
                              icon
                              color="red"
                              v-bind="attrs"
                              v-on="on"
                              @click="clearSelected()"
                            >
                              <v-icon>mdi-delete-circle</v-icon>
                            </v-btn>
                          </template>
                          <span>Clear selected Destination</span>
                        </v-tooltip>
                      </v-card-title>
                      <v-row
                        no-gutters
                        v-if="isTypeVehicle && !isHideBookingDestination && dataPopular.length"
                      >
                        <v-radio-group
                          v-model="selectedPopId"
                          row
                        >
                          <v-radio
                            v-for="popular in dataPopular"
                            :key="popular.id"
                            :label="popular.address"
                            :disabled="popDisabled"
                            :value="popular.id"
                          />
                        </v-radio-group>
                        <!-- </v-col> -->
                      </v-row>
                      <v-card-title
                        class="pa-1 black--text mb-2"
                        v-if="isTypeVehicle && !isHideSearchAddress"
                      >
                        {{ isHideBookingDestination || dataPopular.length == 0 ? 'Enter a destination address' : 'Or enter a destination address' }}
                      </v-card-title>
                      <v-row
                        no-gutters
                        v-if="isTypeVehicle && !isHideSearchAddress"
                      >
                        <v-col
                          cols="12"
                          md="12"
                        >
                          <v-autocomplete
                            v-model="destination.selected"
                            :items="destination.locations"
                            :loading="destination.loading"
                            :no-filter="true"
                            :search-input.sync="destination.search"
                            hide-selected
                            hide-no-data
                            clearable
                            :disabled="destDisabled"
                            item-text="address"
                            item-value="address"
                            label="Destination"
                            outlined
                            return-object
                            hide-details
                            append-icon=""
                          />
                        </v-col>
                      </v-row>
                      <v-card-title
                        class="pa-1 black--text"
                        v-if="isTypeVehicle && !isHideSearchAddress"
                      >
                        <v-radio-group
                          row
                          v-model="selectedVariousLocation"
                          hide-details
                        >
                          <v-radio
                            label="Select Various Destinations"
                            value="1"
                            :disabled="varDisabled"
                          />
                        </v-radio-group>
                      </v-card-title>
                      <v-text-field
                        v-if="selectedVariousLocation && !hasStructuredVariousDestination"
                        clearable
                        filled
                        placeholder="Input Destination"
                        v-model="variousDestination"
                        class="mt-4 mb-2"
                        hide-details
                      />
                      <template v-if="selectedVariousLocation && hasStructuredVariousDestination">
                        <v-autocomplete
                          v-model="variousDestinationSearch.selected"
                          :items="variousDestinationSearch.locations"
                          :loading="variousDestinationSearch.loading"
                          :no-filter="true"
                          :search-input.sync="variousDestinationSearch.search"
                          hide-selected
                          hide-no-data
                          clearable
                          item-text="address"
                          item-value="address"
                          label="Search and add a destination"
                          outlined
                          return-object
                          hide-details
                          append-icon=""
                          class="mt-4"
                        />
                        <v-chip
                          v-for="(dest, idx) in variousDestinationList"
                          :key="idx"
                          close
                          class="mt-2 mr-2"
                          @click:close="removeVariousDestination(idx)"
                        >
                          {{ dest.address }}
                        </v-chip>
                      </template>
                    </div>
                    <v-card-title
                      class="pa-1 black--text mt-3"
                      v-show="selectedAssetType"
                    >
                      Select Asset Group
                    </v-card-title>
                    <v-checkbox
                      v-model="bookingOtherUser"
                      label="Booking for other user"
                      hide-details
                      v-if="hasAccessBookingOther"
                      dense
                      class="mb-3 mt-0"
                    />
                    <v-row
                      no-gutters
                      v-show="bookingOtherUser"
                    >
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-autocomplete
                          :items="dataAllUser"
                          :item-text="
                            item => `${item.first_name}${item.last_name ? ' ' + item.last_name : ''}`
                          "
                          :item-value="item => `${item.id}`"
                          v-model="selectedOtherUser"
                          outlined
                          label="Select User"
                        >
                          <template #no-data>
                            <p class="my-0 px-3 pt-1 font-weight-light">
                              No User matching founds
                            </p>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        md="12"
                        v-if="isAdmin"
                        v-show="selectedAssetType"
                      >
                        <v-combobox
                          :items="vehicleGroups"
                          item-text="name"
                          item-value="id"
                          v-model="selectedVehicleGroup"
                          outlined
                          required
                          :rules="rules"
                          hide-details
                        >
                          <template #label>
                            <span>Asset Group</span>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                        v-else
                      >
                        <v-combobox
                          class="mt-2"
                          :items="vehicleGroups"
                          item-text="group_name"
                          item-value="group_id"
                          v-model="selectedVehicleGroup"
                          outlined
                          required
                          :rules="rules"
                          hide-details
                        >
                          <template #label>
                            <span>Asset Group</span>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>
                    <v-card-title
                      class="pa-1 black--text mt-3"
                      v-show="(isWSP || isIntimap) && selectedAssetType"
                    >
                      Select Vehicle Accessories
                    </v-card-title>
                    <v-row
                      no-gutters
                      v-show="(isWSP || isIntimap) && selectedAssetType"
                    >
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-combobox
                          :items="filteredAccessories"
                          v-model="selectedAccessory"
                          item-text="name"
                          item-value="name"
                          outlined
                          required
                          hide-details
                          multiple
                          chips
                        >
                          <template #label>
                            <span>Accessories</span>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>
                    <v-card-title class="pa-1 black--text mt-3 mb-2">
                      Select View
                    </v-card-title>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-combobox
                          :items="views"
                          v-model="selectedView"
                          item-text="label"
                          item-value="value"
                          outlined
                          required
                          hide-details
                        >
                          <template #label>
                            <span>View</span>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>
                    <v-btn
                      @click="handleClickSearch"
                      color="#00ACDC"
                      class="mt-4"
                      large
                      block
                      dark
                      ref="handleSearch"
                    >
                      Search
                    </v-btn>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
            <v-row
              v-if="isShowLineCalendar"
              class="fill-height"
            >
              <v-col class="pt-0">
                <div
                  v-if="isLoadingCalendar"
                  class="text-center mb-2 mt-5"
                >
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  />
                </div>
                <v-sheet
                  v-else-if="isFinishLoadingCalendar"
                  :height="heightCalendar"
                  min-width="1300"
                >
                  <component
                    :is="calendarComponent"
                    :key="calendarKey"
                    ref="calendars"
                    color="primary"
                    :events="filteredEvents"
                    :interval-width="60"
                    type="category"
                    :category-days="categoryDays"
                    :category-show-all="categoryShowAll"
                    :category-hide-dynamic="categoryHideDynamic"
                    :event-color="getEventColor"
                    :event-ripple="false"
                    v-model="focus"
                    :categories="categories"
                    :start="startCalendar"
                    @click:event="showEvent"
                    @mousedown:event="startDrag"
                    @mousedown:time-category="startTime"
                    @mousemove:time="mouseMove"
                    @mouseup:time="endDrag"
                    @mouseleave.native="cancelDrag"
                    @mouseup:event="endEventSelected"
                    @mousemove:time-category="hoverTooSeeTime"
                    @mouseleave:time-category="removeHover"
                    v-if="isShowCalendar"
                  >
                    <template #event="{ event, timed }">
                      <div
                        v-if="timed"
                        class="v-event-drag-bottom"
                        @mousedown.stop="extendBottom(event)"
                      />
                      <!-- <span class="mx-2">{{ event.name }}</span> <br> -->
                      <span
                        class="mx-2"
                      >{{ event.details.start }} -
                        {{ event.details.end }}</span>
                      <p
                        class="mx-2"
                        v-if="event.title"
                      >
                        {{ event.title }}
                      </p>
                      <br>
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="white"
                            v-if="event.details.detail && event.details.detail.recurring == '1'"
                            class="float-right mr-2 float-bottom"
                          >
                            mdi-sync
                          </v-icon>
                        </template>
                        <span>Recurring</span>
                      </v-tooltip>
                      <v-tooltip
                        bottom
                        v-if="event.color == 'purple'"
                      >
                        <template #activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="white"
                            class="float-right mr-2"
                          >
                            mdi-card-text
                          </v-icon>
                        </template>
                        <span>Myke Card</span>
                      </v-tooltip>
                      <v-tooltip
                        bottom
                        v-if="event.color == 'pink'"
                      >
                        <template #activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="white"
                            class="float-right mr-2"
                          >
                            mdi-bike
                          </v-icon>
                        </template>
                        <span>E-Bike</span>
                      </v-tooltip>
                    </template>
                    <template #day-label-header="{ day, date }">
                      <div>{{ handleDay(date) }}</div>
                      <br>
                      <v-btn
                        x-small
                        color="primary"
                        outlined
                        v-if="isMore"
                        @click="moreVehicle(day, date)"
                      >
                        {{ textMore }}
                      </v-btn>
                      <v-btn
                        small
                        color="primary"
                        outlined
                        v-if="isBack && selectedView.value === 'week'"
                        @click="defaultCalendar(day, date)"
                      >
                        Back
                      </v-btn>
                    </template>
                    <template #category="{ category }">
                      <div
                        class="text-center pa-1"
                        style="font-size:12px;border-top: #e0e0e0 1px solid;"
                      >
                        <span
                          class="name-category"
                          v-if="!isDarwin"
                          :id="`category-${category}`"
                        >
                          {{ getCategoryNames(category)[0] }}
                          <br>
                        </span>
                        <span v-if="isTypeVehicle && !isDarwin">
                          {{
                            `${getCategoryNames(category)[1]} ${
                              getCategoryNames(category)[2]
                            }`
                          }}
                        </span>
                        <div
                          class="d-flex justify-center"
                          v-if="isYarra"
                          :id="`category-${category}`"
                        >
                          <v-icon
                            v-if="getCategoryNames(category)[3]"
                            dense
                            title="Roof Rack"
                          >
                            mdi-code-blocks-brackets
                          </v-icon>
                          <v-icon
                            v-if="getCategoryNames(category)[4]"
                            dense
                            title="Baby Seat"
                          >
                            mdi-car-child-seat
                          </v-icon>
                          <v-icon
                            v-if="getCategoryNames(category)[5]"
                            dense
                            title="Roof Child Capsule"
                          >
                            mdi-cradle
                          </v-icon>
                        </div>
                        <span v-if="isTypeVehicle && isDarwin">
                          <span
                            v-for="categoryName in getCategoryNames(category)"
                            :key="categoryName"
                            :id="`category-${category}`"
                          >
                            {{ categoryName }}
                            <br>
                          </span>
                        </span>
                      </div>
                    </template>
                  </component>
                  <v-dialog
                    v-model="selectedOpen"
                    :close-on-content-click="false"
                    :activator="selectedElement"
                    offset-x
                    max-width="fit-content"
                    scrollable
                    class="ma-5"
                  >
                    <v-card
                      color="white lighten-4"
                      elevation="4"
                      flat
                      max-height="800"
                      max-width="500"
                    >
                      <v-toolbar
                        color="grey lighten-3"
                        dense
                        elevation="0"
                        max-width="500"
                      >
                        <v-toolbar-title>
                          <div v-html="selectedEvent.name" />
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-card-text style="padding: 0px;">
                        <v-form
                          ref="create_booking"
                          v-model="create"
                          lazy-validation
                        >
                          <v-list style="padding: 15px; padding-bottom: 0px;">
                            <v-list-item class="px-0">
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-map-marker
                                </v-icon>
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title
                                  style="font-size: 14px; font-weight: 400;"
                                >
                                  From <b>{{ getOriginName(origin_id) }}</b>
                                  <br>
                                  <a
                                    class="black--text"
                                    v-if="isTypeVehicle"
                                  >
                                    To
                                    <b>{{
                                      getDestinationAddrs(
                                        destination.selected,
                                        selectedPopularData
                                      )
                                    }}</b>
                                  </a>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-calendar
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content class="mx-0">
                                <v-list-item-title
                                  style="font-size: 14px; font-weight: 400;"
                                >
                                  Start Date
                                </v-list-item-title>
                                <v-menu
                                  ref="start_date"
                                  v-model="startBookingDate"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="auto"
                                >
                                  <template #activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="startDateFormatted"
                                      persistent-hint
                                      prepend-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                    />
                                  </template>
                                  <v-date-picker
                                    v-model="booking.date"
                                    no-title
                                    @input="startBookingDate = false"
                                    :min="getMinDate('start')"
                                    :max="getMaxDate()"
                                    @change="listenStartTime"
                                  />
                                </v-menu>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-calendar
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content class="mx-0">
                                <v-list-item-title
                                  style="font-size: 14px; font-weight: 400;"
                                >
                                  End Date
                                </v-list-item-title>
                                <v-menu
                                  ref="end_date"
                                  v-model="endBookingDate"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="auto"
                                >
                                  <template #activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="endDateFormatted"
                                      persistent-hint
                                      prepend-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                    />
                                  </template>
                                  <v-date-picker
                                    v-model="booking.end_date"
                                    no-title
                                    @input="endBookingDate = false"
                                    :min="getMinDate('end')"
                                    :max="getMaxDate('end')"
                                    @change="listenStartTime"
                                  />
                                </v-menu>
                                <v-list-item-subtitle
                                  v-if="maxBookingDurationLabel"
                                  class="text-wrap"
                                >
                                  {{ maxBookingDurationLabel }} To book beyond that, create a new booking.
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-if="isVehicle && booking.date == booking.end_date && isAllowRecurring">
                                  <v-row>
                                    <v-col
                                      sm="4"
                                      md="4"
                                      class="py-0 mr-8"
                                    >
                                      <v-checkbox
                                        v-model="isRecurring"
                                        label="Recurring Bookings"
                                        hide-details
                                        dense
                                      />
                                    </v-col>
                                    <v-col
                                      sm="6"
                                      md="6"
                                      v-if="isRecurring"
                                    >
                                      <v-menu
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        max-width="290"
                                      >
                                        <template #activator="{ on, attrs }">
                                          <v-text-field
                                            v-if="isRecurring"
                                            clearable
                                            filled
                                            placeholder="End Date"
                                            :value="handleEndDateValue"
                                            dense
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            @click:clear="
                                              isRecurring = false
                                            "
                                            required
                                            :rules="rules"
                                          />
                                        </template>
                                        <v-date-picker
                                          v-model="booking.end_date"
                                          :min="booking.date"
                                          @change="menu1 = false"
                                        />
                                      </v-menu>
                                    </v-col>
                                  </v-row>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                  v-if="isVehicle && isRecurring && booking.date == booking.end_date && isAllowRecurring"
                                >
                                  <v-select
                                    :items="recurringItems"
                                    v-model="booking.recurring"
                                    filled
                                    hide-details
                                    :rules="rules"
                                    label="Select recurring frequency"
                                    dense
                                  />
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                  <v-radio-group
                                    v-model="radios"
                                    v-if="isVehicle && isRecurring && booking.date == booking.end_date && isAllowRecurring"
                                    class="mt-0 pt-0"
                                  >
                                    <v-radio
                                      value="endAfter"
                                      class="mt-0 pt-0"
                                    >
                                      <template #label>
                                        <v-row>
                                          <v-col
                                            cols="3"
                                            md="3"
                                            class="mt-3"
                                          >
                                            <span>End After:</span>
                                          </v-col>
                                          <v-col
                                            cols="6"
                                            md="6"
                                            class="pt-0"
                                          >
                                            <v-text-field
                                              v-if="isVehicle && isRecurring && booking.date == booking.end_date && isAllowRecurring"
                                              hide-details="auto"
                                              label="End After"
                                              v-model="booking.recurring_end"
                                              outlined
                                              dense
                                              type="number"
                                              min="0"
                                              class="mt-4"
                                              @change="handleChangeEndAfter"
                                              @keyup="handleChangeEndAfter"
                                            />
                                          </v-col>
                                        </v-row>
                                      </template>
                                    </v-radio>
                                    <v-radio value="endBy">
                                      <template #label>
                                        <v-row class="mt-0 pt-0">
                                          <v-col
                                            cols="3"
                                            md="3"
                                            class="mt-3"
                                          >
                                            <span>End By:</span>
                                          </v-col>
                                          <v-col
                                            cols="6"
                                            md="6"
                                            class="pt-0"
                                          >
                                            <v-menu
                                              v-model="menu2"
                                              :close-on-content-click="false"
                                              :nudge-right="40"
                                              transition="scale-transition"
                                              offset-y
                                              min-width="auto"
                                            >
                                              <template
                                                #activator="{ on, attrs }"
                                              >
                                                <v-text-field
                                                  v-model="booking.recurring_endBy"
                                                  class="mt-1"
                                                  hide-details
                                                  outlined
                                                  label="End By"
                                                  dense
                                                  append-icon="mdi-calendar"
                                                  readonly
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  @click="handleClickCalendar('recurringCalendar1')"
                                                />
                                              </template>
                                              <v-date-picker
                                                ref="recurringCalendar1"
                                                v-model="
                                                  booking.recurring_endBy
                                                "
                                                position="absolute"
                                                @input="menu2 = false"
                                                :min="`${booking.date}`"
                                                :max="max"
                                              />
                                            </v-menu>
                                          </v-col>
                                        </v-row>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-clock-time-four-outline
                                </v-icon>
                              </v-list-item-icon>
                              <div style="z-index: 9999">
                                <v-row>
                                  <v-col
                                    cols="3"
                                    md="3"
                                    class="pt-0"
                                  >
                                    <div>
                                      <label
                                        for="pickstartTime"
                                        style="font-size: 14px; font-weight: 400;"
                                      >Start time</label>
                                      <br>
                                      <vue-timepicker
                                        id="pickstartTime"
                                        v-model="create_start_time"
                                        @change="listenStartTime"
                                        :hour-range="[time_range]"
                                        hour-label="hour"
                                        minute-label="minute"
                                        input-width="100%"
                                        input-height="100%"
                                        :minute-interval="minuteInterval"
                                        close-on-complete
                                        auto-scroll
                                      />
                                    </div>
                                  </v-col>
                                  <v-col
                                    cols="3"
                                    md="3"
                                    class="pt-0"
                                  >
                                    <div>
                                      <label for="pickendTime">End time</label>
                                      <br>
                                      <vue-timepicker
                                        id="pickendTime"
                                        v-model="create_end_time"
                                        @change="listenStartTime"
                                        :hour-range="[time_range_end]"
                                        hour-label="hour"
                                        minute-label="minute"
                                        input-width="100%"
                                        :minute-interval="minuteInterval"
                                        close-on-complete
                                        auto-scroll
                                      />
                                      <br>
                                    </div>
                                  </v-col>
                                </v-row>
                              </div>
                              <!-- </v-list-item-content> -->
                            </v-list-item>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-car
                                </v-icon>
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title
                                  style="font-size: 14px; font-weight: 400;"
                                >
                                  {{ selectedGroupName }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-car-side
                                </v-icon>
                              </v-list-item-icon>

                              <v-list-item-content class="mx-0">
                                <v-list-item-title
                                  style="font-size: 14px; font-weight: 400;"
                                >
                                  {{ selectedAssetTypeName }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ selectedVehBook }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              class="px-0"
                              v-show="getMaxSeatCount !== 0 && isVehicle"
                            >
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-account-multiple
                                </v-icon>
                              </v-list-item-icon>

                              <v-list-item-content class="mx-0">
                                <v-list-item-title
                                  style="font-size: 14px; font-weight: 400;"
                                >
                                  <v-row class="pa-0">
                                    <v-col
                                      sm="3"
                                      md="3"
                                      class="py-0"
                                    >
                                      <v-select
                                        filled
                                        dense
                                        type="number"
                                        hide-details
                                        v-model="optionPassengerCount"
                                        :items="optionPassenger"
                                        :rules="[rulesPassenger.counter]"
                                      />
                                    </v-col>
                                    <v-col>
                                      Passenger
                                    </v-col>
                                  </v-row>
                                  <v-row
                                    class="pa-0"
                                    v-if="isIntimap || isWSP"
                                  >
                                    <v-col>
                                      <div class="d-flex flex-column">
                                        <v-text-field
                                          v-for="n in optionPassengerCount"
                                          v-model="passengerList[n - 1]"
                                          :key="n"
                                          class="d-flex align-center mt-5"
                                          style="margin-bottom: 5px;"
                                          hide-details
                                          dense
                                          :label="`Passenger Name / Email ${n}`"
                                          clearable
                                        />
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              class="px-0"
                              v-if="isDarwin || isVictrack"
                            >
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-currency-usd
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-text-field
                                  dense
                                  label="Cost Code"
                                  v-model="costCode"
                                  filled
                                  required
                                  :rules="costCodeRule"
                                  type="number"
                                />
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              class="px-0"
                              v-if="isWSP || isIntimap"
                            >
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                
                                  color="indigo"
                                  dense
                                >
                                  mdi-order-alphabetical-ascending
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content class="pt-0">
                                <v-row>
                                  <v-col cols="10">
                                    <v-autocomplete
                                      v-model="workOrder"
                                      :items="workOrders"
                                      :search-input.sync="searchWorkOrder"
                                      :loading="isLoadingWorkOrder"
                                      hide-selected
                                      hide-no-data
                                      clearable
                                      :item-text="getWorkOrderText"
                                      item-value="code"
                                      label="Work Order"
                                      outlined
                                      hide-details
                                      return-object
                                      dense
                                      required
                                      :rules="workOrderRule"
                                      placeholder="Search Work Orders"
                                    />
                                  </v-col>
                                  <v-col
                                    cols="2"
                                    class="text-center"
                                  >
                                    <v-btn
                                      color="primary"
                                      dense
                                      small
                                      style="height: 38px; width: 40px;"
                                      title="Add Second Work Order"
                                      @click="handleSecondWorkOrder"
                                      v-if="!isSecondWorkOrder && !isRecurring"
                                    >
                                      <v-icon
                                        dense
                                      >
                                        mdi-plus
                                      </v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                            <div
                              class="second-work-order ml-10 px-3"
                              v-if="isSecondWorkOrder"
                            >
                              <p class="my-3">
                                Second Work Order
                              </p>
                              <v-list-item
                                class="px-0"
                              >
                                <v-list-item-content class="pt-0">
                                  <v-row>
                                    <v-col cols="10">
                                      <v-autocomplete
                                        v-model="workOrder2"
                                        :items="workOrders2"
                                        :search-input.sync="searchWorkOrder2"
                                        :loading="isLoadingWorkOrder2"
                                        hide-selected
                                        hide-no-data
                                        clearable
                                        :item-text="getWorkOrderText"
                                        item-value="code"
                                        label="Work Order"
                                        outlined
                                        hide-details
                                        return-object
                                        dense
                                        required
                                        :rules="workOrderRule2"
                                        placeholder="Search Work Orders"
                                      />
                                    </v-col>
                                    <v-col
                                      cols="2"
                                      class="text-center pl-0"
                                    >
                                      <v-btn
                                        color="primary"
                                        dense
                                        small
                                        style="height: 38px; width: 40px;"
                                        title="Remove Second Work Order"
                                        @click="handleSecondWorkOrder"
                                      >
                                        <v-icon
                                          dense
                                        >
                                          mdi-minus
                                        </v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item
                                class="px-0"
                              >
                                <div style="z-index: 9999">
                                  <v-row>
                                    <v-col
                                      cols="5"
                                      md="5"
                                      class="pt-0"
                                    >
                                      <div>
                                        <label
                                          for="pickstartTime"
                                          style="font-size: 14px; font-weight: 400;"
                                        >
                                          Start time
                                        </label>
                                        <br>
                                        <vue-timepicker
                                          id="pickstartTime"
                                          v-model="create_start_time2"
                                          :hour-range="[time_range2]"
                                          hour-label="hour"
                                          minute-label="minute"
                                          input-width="100%"
                                          input-height="100%"
                                          :minute-interval="minuteInterval"
                                          close-on-complete
                                          auto-scroll
                                        />
                                      </div>
                                    </v-col>
                                    <v-col
                                      cols="5"
                                      md="5"
                                      class="pt-0"
                                    >
                                      <div>
                                        <label for="pickendTime">End time</label>
                                        <br>
                                        <vue-timepicker
                                          id="pickendTime"
                                          v-model="create_end_time2"
                                          :hour-range="[time_range_end2]"
                                          hour-label="hour"
                                          minute-label="minute"
                                          input-width="100%"
                                          :minute-interval="minuteInterval"
                                          close-on-complete
                                          auto-scroll
                                        />
                                        <br>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-list-item>
                            </div>
                            <v-list-item
                              class="px-0"
                              v-if="isWSP || isIntimap"
                            >
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-tag-text-outline
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-autocomplete
                                  v-model="purposeOfTrip"
                                  :items="purposeOfTrips"
                                  hide-selected
                                  clearable
                                  label="Purpose of Trip"
                                  outlined
                                  hide-details
                                  dense
                                  return-object
                                  required
                                  :rules="purposeOfTripRule"
                                />
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              class="px-0"
                              v-if="(isWSP || isIntimap) && isMoreThanOneDay"
                            >
                              <v-list-item-content
                                class="px-3 py-3 mt-3"
                                style="background-color: #e0e0e0;"
                              >
                                <h3 class="mb-2">
                                  Fringe Benefit Days
                                </h3>
                                <p>For FBT (fringe benefit tax) purposes, will the vehicle be parked at <strong>a personal residence overnight?</strong></p>
                                <v-radio-group
                                  v-model="isFBT"
                                  class="mt-2 pt-0"
                                  row
                                >
                                  <v-radio
                                    label="Yes"
                                    :value="true"
                                  />
                                  <v-radio
                                    label="No"
                                    :value="false"
                                  />
                                </v-radio-group>
                                <p
                                  v-if="isFBT"
                                >
                                  Which night will the vehicle be parked your personal residence?
                                </p>
                                <div
                                  v-if="isFBT"
                                >
                                  <v-checkbox
                                    v-model="checkAllFbt"
                                    label="Check All"
                                    @click="handleCheckAllFbt"
                                    class="mb-2"
                                    hide-details
                                    dense
                                    color="primary"
                                  />
                                  <div
                                    class="d-flex flex-column"
                                    style="max-height: 200px; overflow-y: auto;"
                                  >
                                    <v-checkbox
                                      v-for="(date, index) in fbtDates"
                                      :key="index"
                                      :label="formatDate(date, 'DD MMMM YYYY')"
                                      v-model="fbtSelectedDates"
                                      hide-details
                                      :value="date"
                                    />
                                  </div>
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              class="px-0"
                              v-if="isVictrack"
                            >
                              <v-list-item-icon class="pa-0 mr-4">
                                <v-icon
                                  color="indigo"
                                  dense
                                >
                                  mdi-account-star
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-text-field
                                  dense
                                  label="Client Name"
                                  v-model="clientName"
                                  filled
                                  required
                                  :rules="clientNameRule"
                                  type="text"
                                />
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              class="px-0"
                              v-show="canShare"
                            >
                              <v-list-item-content>
                                <v-checkbox
                                  hide-details
                                  dense
                                  label="Allow Share Ride"
                                  color="blue"
                                  v-model="sharedVehicle"
                                />
                              </v-list-item-content>
                            </v-list-item>
                            <!-- <v-list-item
                              class="justify-end py-3 px-0"
                            >
                              <v-btn
                                text
                                color="secondary"
                                @click="handleClickBack(true)"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                @click="handleLicenseDialog"
                                color="primary"
                                :disabled="saveDisabled"
                              >
                                Save
                              </v-btn>
                            </v-list-item> -->
                          </v-list>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          text
                          color="secondary"
                          @click="handleClickBack(true)"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          @click="handleLicenseDialog"
                          color="primary"
                          :disabled="saveDisabled"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-calendar
                    ref="calendar"
                    color="primary"
                    type="week"
                    v-show="hideTemp"
                    class="mb-5"
                  />
                </v-sheet>
                <div
                  class="mt-4"
                  v-if="isShowCalendar"
                >
                  <v-card
                    class="d-flex mb-3"
                    color="transparent"
                    flat
                  >
                    <v-card
                      v-for="legend in legendItems"
                      :key="legend.color"
                      tile
                      elevation="0"
                      class="d-flex pa-2"
                    >
                      <v-sheet
                        :color="legend.color"
                        width="15"
                        class="mx-2 mt-1"
                        height="15"
                      />
                      <span
                        class="m1-1"
                        style="font-size: 12px"
                      >{{
                        legend.text
                      }}</span>
                    </v-card>
                  </v-card>
                </div>
                <!-- <v-row v-if="!isShowCalendar" class="mx-2">
                  <v-col cols="12">
                    <v-alert outlined text type="error">
                      There is no available vehicle. Please select another group
                    </v-alert>
                  </v-col>
                </v-row> -->
              </v-col>
            </v-row>
            <v-row v-if="isShowCategoryCalendar">
              <v-col class="pt-0">
                <v-toolbar
                  class="toolbar--category"
                  flat
                >
                  <v-btn
                    outlined
                    class="mr-4 btn--calendar"
                    @click.prevent="handleClickBack"
                  >
                    Back
                  </v-btn>
                </v-toolbar>
                <v-sheet height="650">
                  <v-calendar
                    ref="category"
                    color="primary"
                    type="category"
                    :now="calendar.date"
                    :categories="calendar.categories"
                    :events="calendar.events"
                    :focus="calendar.focus"
                    v-model="calendar.value"
                    category-show-all
                  >
                    <template #category="{ category }">
                      <v-list-item
                        three-line
                        class="text-center pointer"
                        @click="handleClickCategory(category)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ getCategoryName(category)[0] }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ getCategoryName(category)[1] }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            {{
                              `${getCategoryName(category)[2]} ${
                                getCategoryName(category)[3]
                              }`
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template #event="{ event }">
                      <v-container
                        class="pa-3"
                        @click="handleClickEvent(event)"
                      >
                        <v-row>
                          <v-col>
                            <p class="text-center text--event">
                              {{ event.name }}
                            </p>
                            <p class="text-center text--event">
                              {{
                                `${formatDate(
                                  event.start,
                                  "HH:mm"
                                )} - ${formatDate(event.end, "HH:mm")}`
                              }}
                            </p>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                  </v-calendar>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-dialog
        v-model="dialog.open"
        persistent
        max-width="600px"
        @click:outside="handleClickDialogOutside"
      >
        <v-card>
          <v-toolbar
            dark
            :color="dialog.color"
            flat
          >
            <v-toolbar-title> {{ handleColorInfo(dialog) }}</v-toolbar-title>
            <v-spacer />
            <v-btn
              icon
              color="white"
              @click="dialog.open = false"
            >
              <v-icon>mdi-close-box</v-icon>
            </v-btn>
            <template #extension>
              <v-tabs
                v-model="tabs"
                centered
              >
                <v-tab>
                  Booking Details
                </v-tab>
                <v-tab v-if="dialog.data.detail.status === '2' && isVehicle">
                  Passenger Information
                </v-tab>
              </v-tabs>
            </template>
          </v-toolbar>

          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card-text v-if="dialog.data.detail">
                <v-container>
                  <v-row>
                    <v-col>
                      <v-simple-table>
                        <template #default>
                          <tbody>
                            <tr>
                              <td class=" mx-0">
                                <span>
                                  <v-icon>
                                    mdi-car
                                  </v-icon>
                                </span>
                              </td>
                              <td>{{ isVehicle ? "Vehicle" : "Asset" }}</td>
                              <td>
                                {{ handleDeviceName(dialog.data.detail) }}
                              </td>
                            </tr>
                            <tr v-if="isVehicle">
                              <td class=" mx-0">
                                <span>
                                  <v-icon />
                                </span>
                              </td>
                              <td>Car brand and model</td>
                              <td>
                                {{ handleDeviceMake(dialog.data.detail) }}
                                {{ handleDeviceModel(dialog.data.detail) }}
                              </td>
                            </tr>
                            <tr>
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-calendar
                                </v-icon>
                              </td>
                              <td>Date</td>
                              <td>
                                {{
                                  formatDate(
                                    dialog.data.detail.start_datetime,
                                    "DD MMMM YYYY"
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-timer-sand
                                </v-icon>
                              </td>
                              <td>Period</td>
                              <td>
                                {{ getPeriodDisplay(dialog.data) }}
                              </td>
                            </tr>
                            <tr>
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-map-marker
                                </v-icon>
                              </td>
                              <td>Origin</td>
                              <td>
                                {{
                                  getOriginName(
                                    dialog.data.detail.start_geofence_id
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-map-marker
                                </v-icon>
                              </td>
                              <td>Destination</td>
                              <td>{{ getDestination(dialog.data.detail) }}</td>
                            </tr>
                            <tr v-if="!isVehicle">
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-account
                                </v-icon>
                              </td>
                              <td>Booking Owner</td>
                              <td>
                                {{
                                  `${
                                    dialog.data.detail.passenger[0][
                                      "first_name"
                                    ]
                                  } ${
                                    dialog.data.detail.passenger[0]["last_name"]
                                  }`
                                }}
                              </td>
                            </tr>
                            <tr v-if="isVictrack || isDarwin">
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-currency-usd
                                </v-icon>
                              </td>
                              <td>Cost Code</td>
                              <td>{{ getCostCode(dialog.data.detail) }}</td>
                            </tr>
                            <tr v-if="isWSP || isIntimap">
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-order-alphabetical-ascending
                                </v-icon>
                              </td>
                              <td>Work Order</td>
                              <td>{{ getWorkOrder(dialog.data.detail) }}</td>
                            </tr>
                            <tr v-if="(isWSP || isIntimap) && getSecondWorkOrder(dialog.data.detail) !== '-'">
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-order-alphabetical-ascending
                                </v-icon>
                              </td>
                              <td>Second Work Order</td>
                              <td>
                                {{ getSecondWorkOrder(dialog.data.detail) }}
                                <template v-if="getSecondWorkOrderPeriod(dialog.data.detail)">
                                  ({{ getSecondWorkOrderPeriod(dialog.data.detail) }})
                                </template>
                              </td>
                            </tr>
                            <tr v-if="isWSP || isIntimap">
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-tag-text-outline
                                </v-icon>
                              </td>
                              <td>Purpose of Trip</td>
                              <td>{{ getPurposeOfTrip(dialog.data.detail) }}</td>
                            </tr>
                            <tr>
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-account-star
                                </v-icon>
                              </td>
                              <td>Client Name</td>
                              <td>{{ getClientName(dialog.data.detail) }}</td>
                            </tr>
                            <tr v-if="isVehicle">
                              <td class=" mx-0">
                                <v-icon>
                                  mdi-sync
                                </v-icon>
                              </td>
                              <td>Recurring</td>
                              <td>{{ getRecurring(dialog.data.detail) }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card
                flat
                class="pa-4"
              >
                <v-row v-if="isVehicle">
                  <v-col>
                    <v-form
                      ref="join_booking"
                      v-model="join_book"
                      lazy-validation
                    >
                      <v-simple-table class="ma-5 blue lighten-5">
                        <template #default>
                          <thead>
                            <tr>
                              <th>No</th>
                              <th>Booked By</th>
                              <th>No of Occupants</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(passenger, i) in dialog.data.detail
                                .passenger"
                              :key="i"
                            >
                              <td>{{ i + 1 }}</td>
                              <td>
                                {{
                                  `${passenger.first_name}${
                                    passenger.last_name ?
                                      ` ${passenger.last_name}` :
                                      ""
                                  }`
                                }}
                                <v-chip
                                  x-small
                                  class="ma-2"
                                  color="primary"
                                  dark
                                  v-if="passenger.is_owner"
                                >
                                  Owner
                                </v-chip>
                              </td>
                              <td v-if="isIntimap || isWSP">
                                <v-tooltip
                                  bottom
                                  :open-delay="500"
                                >
                                  <template #activator="{ on, attrs }">
                                    <v-chip
                                      class="ma-1"
                                      color="primary"
                                      dark
                                      style="font-size: 0.75rem;"
                                      v-on="on"
                                      v-bind="attrs"
                                    >
                                      {{ passenger.passenger_count }} Passenger
                                    </v-chip>
                                  </template>
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <p
                                            v-for="pName in getPassengerList(passenger)"
                                            :key="pName"
                                          >
                                            {{ pName }}
                                          </p>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </v-tooltip>
                              </td>
                              <td v-else>
                                {{ passenger.passenger_count }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <!-- <v-row>
                        <v-col> </v-col>

                        <v-spacer></v-spacer>

                        <v-col>
                          <v-btn
                            class="px-4 my-4"
                            outlined
                            color="green"
                            @click="isShowTable"
                            dark
                            v-if="isSharedDialog(dialog.data.detail) && isShared"
                          >
                            Request To Share The Ride
                          </v-btn>
                        </v-col>
                      </v-row> -->

                      <v-row
                        class="d-flex"
                        v-if="isSharedDialog(dialog.data.detail)"
                      >
                        <v-col
                          cols="12"
                          md="12"
                          class="mx-0 pa-0"
                        >
                          <v-card-subtitle>
                            Available Seat : {{ availableSeat }}
                          </v-card-subtitle>
                        </v-col>
                        <v-col
                          cols="6"
                          md="6"
                          class="order-1 order-md-0 pb-2"
                        >
                          <v-text-field
                            label="Requested By"
                            outlined
                            hide-details
                            required
                            disabled
                            :value="
                              `${$store.state.user.user.first_name} ${
                                $store.state.user.user.last_name
                              }`
                            "
                            min="1"
                            max="5"
                          />
                        </v-col>
                        <v-col
                          cols="6"
                          md="6"
                          class="order-1 order-md-0 pb-2"
                        >
                          <v-select
                            label="Number Of Occupants"
                            outlined
                            hide-details
                            :disabled="disableShareRide || isPickPastTime"
                            v-model="selectedSharePassenger"
                            :items="optionsSharePassenger"
                            :rules="[rulesJoinPassenger.counter]"
                          />
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="selectedSharePassenger >= 1 && isSharedDialog(dialog.data.detail) && !disableShareRide && !isPickPastTime"
                      >
                        <v-col
                          cols="12"
                          class="pb-0 pt-2"
                          v-if="isIntimap || isWSP"
                        >
                          <v-subheader class="pl-0 pb-0">
                            Passenger
                          </v-subheader>
                        </v-col>
                        <v-col
                          cols="12"
                          class="pt-0"
                          v-if="isIntimap || isWSP"
                        >
                          <div class="d-flex flex-column">
                            <v-text-field
                              v-for="n in optionSharePassengerCount"
                              v-model="sharePassengerList[n - 1]"
                              :key="n"
                              class="d-flex align-center mt-5"
                              style="margin-bottom: 5px;"
                              hide-details
                              dense
                              :label="`Passenger Name / Email ${n}`"
                              clearable
                            />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col />

                        <v-spacer />
                        <v-col>
                          <v-btn
                            block
                            @click="submitJoin(dialog.data)"
                            color="success"
                            dark
                            v-if="isSharedDialog(dialog.data.detail)"
                            v-show="!disableShareRide && !isPickPastTime"
                          >
                            Send Request
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogs.open"
        style="overflow:hidden"
        max-width="600px"
        @click:outside="handleClickDialogOutside"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Create Booking</span>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="create_booking"
              v-model="create"
              lazy-validation
            >
              <v-container class="py-0">
                <v-container>
                  <v-select
                    :items="getOrigin"
                    :item-text="origin => `${origin.name}`"
                    :item-value="origin => `${origin.Id}`"
                    label="Select Origin"
                    outlined
                    v-model="origin_id"
                    disabled
                    :rules="rules"
                  >
                    <template #label>
                      <span>Origin</span>
                    </template>
                  </v-select>
                  <v-select
                    :items="assetTypes"
                    v-model="selectedAssetType"
                    outlined
                    required
                    disabled
                    :rules="rules"
                  >
                    <template #label>
                      <span>Asset Type</span>
                    </template>
                  </v-select>
                  <v-select
                    v-if="isVehicle"
                    :items="vehicleTypes"
                    v-model="selectedVehicleType"
                    outlined
                    required
                    disabled
                    :rules="rules"
                  >
                    <template #label>
                      <span>Vehicle Type</span>
                    </template>
                  </v-select>
                  <v-text-field
                    :value="selectedVehBook"
                    label="Vehicle"
                    outlined
                    readonly
                  />
                  <v-select
                    v-if="!isVehicle"
                    :items="booking.assetOptions"
                    v-model="booking.asset"
                    item-text="number"
                    item-value="id"
                    outlined
                    required
                    :disabled="booking.disabledSelection"
                    :rules="rules"
                  >
                    <template #label>
                      <span>Asset</span>
                    </template>
                  </v-select>
                  <v-checkbox
                    v-model="isRecurring"
                    label="Recurring Booking"
                  />
                  <date-picker
                    v-model="booking.date"
                    :masks="datePicker.masks"
                    :min-date="datePicker.minimum"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <v-text-field
                        :value="inputValue"
                        label="Start Date"
                        v-on="inputEvents"
                        outlined
                        required
                        disabled
                        hide-details=""
                        :rules="rules"
                      />
                    </template>
                  </date-picker>
                  <date-picker
                    v-model="booking.end_date"
                    :masks="datePicker.masks"
                    v-if="isRecurring"
                    :min-date="booking.date"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <v-text-field
                        :value="inputValue"
                        label="End Date"
                        v-on="inputEvents"
                        outlined
                        required
                        hide-details
                        :rules="rules"
                      />
                    </template>
                  </date-picker>
                  <v-row
                    class="mb-6"
                    v-if="!isPeriod"
                  >
                    <v-col
                      cols="6"
                      md="6"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="start_time"
                        label="Start Time"
                        outlined
                        required
                        disabled
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      md="6"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="end_time"
                        label="End Time"
                        outlined
                        required
                        disabled
                      />
                    </v-col>
                  </v-row>
                  <v-select
                    v-if="isVehicle && isRecurring"
                    :items="recurringItems"
                    v-model="booking.recurring"
                    outlined
                    required
                    hide-details
                    :rules="rules"
                  >
                    <template #label>
                      <span>Recurring Booking</span>
                    </template>
                  </v-select>
                  <v-radio-group
                    v-model="radios"
                    v-if="isVehicle && isRecurring"
                    class="mt-0 pt-0"
                  >
                    <v-radio
                      value="endAfter"
                      class="mt-0 pt-0"
                    >
                      <template #label>
                        <v-row>
                          <v-col
                            cols="3"
                            md="3"
                            class="mt-3"
                          >
                            <span>End After:</span>
                          </v-col>
                          <v-col
                            cols="6"
                            md="6"
                            class="pt-0"
                          >
                            <v-text-field
                              v-if="isVehicle && isRecurring"
                              hide-details="auto"
                              label="End After"
                              v-model="booking.recurring_end"
                              outlined
                              dense
                              type="number"
                              min="0"
                              class="mt-4"
                              @change="handleChangeEndAfter"
                              @keyup="handleChangeEndAfter"
                            />
                          </v-col>
                          <v-col
                            cols="3"
                            md="3"
                            class="mt-6"
                          >
                            <strong>occurance(s)</strong>
                          </v-col>
                        </v-row>
                      </template>
                    </v-radio>
                    <v-radio
                      value="endBy"
                      class="mt-0 pt-0"
                    >
                      <template #label>
                        <v-row class="mt-0 pt-0">
                          <v-col
                            cols="3"
                            md="3"
                            class="mt-1"
                          >
                            <span>End By:</span>
                          </v-col>
                          <v-col
                            cols="6"
                            md="6"
                            class="pt-0"
                          >
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template #activator="{ on, attrs }">
                                <v-text-field
                                  v-model="booking.recurring_endBy"
                                  class="mt-1"
                                  outlined
                                  hide-details
                                  label="End By"
                                  dense
                                  append-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="handleClickCalendar('recurringCalendar')"
                                />
                              </template>
                              <v-date-picker
                                ref="recurringCalendar"
                                v-model="booking.recurring_endBy"
                                @input="menu2 = false"
                                :min="`${booking.date}`"
                                :max="max"
                              />
                            </v-menu>
                          </v-col>
                        </v-row>
                      </template>
                    </v-radio>
                  </v-radio-group>

                  <v-row
                    class="mb-6"
                    v-if="isPeriod"
                  >
                    <v-col
                      cols="6"
                      md="6"
                      class="pt-0"
                    >
                      <div>
                        <label for="startTime">Start time</label>
                        <br>
                        <vue-timepicker
                          id="startTime"
                          v-model="start_time"
                          hour-label="hour"
                          :hour-range="[time_range]"
                          minute-label="minute"
                          input-width="100%"
                          :minute-interval="minuteInterval"
                          manual-input
                          close-on-complete
                        />
                        <br>
                        <div
                          class="v-messages theme--light error--text mt-1"
                          v-if="startTimeRequired"
                        >
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              Please Complete Field
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                      md="6"
                      class="pt-0"
                    >
                      <div>
                        <label for="endTime">End time</label>
                        <br>
                        <vue-timepicker
                          id="endTime"
                          v-model="end_time"
                          hour-label="hour"
                          minute-label="minute"
                          :hour-range="[time_range_end]"
                          input-width="100%"
                          :minute-interval="minuteInterval"
                          manual-input
                          close-on-complete
                        />
                        <br>
                        <div
                          class="v-messages theme--light error--text mt-1"
                          v-if="endTimeRequired"
                        >
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              Please Complete Field
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-text-field
                    v-show="canShare && getMaxSeatCount !== 0"
                    label="Number Of Passenger"
                    outlined
                    v-model="passengerCount"
                    value="0"
                    min="0"
                    type="number"
                    :max="getMaxSeatCount"
                    counter
                    :rules="[rulesPassenger.counter]"
                  />
                  <v-autocomplete
                    v-model="destination.selected"
                    :items="destination.locations"
                    :loading="destination.loading"
                    :search-input.sync="destination.search"
                    hide-selected
                    clearable
                    item-text="address"
                    item-value="address"
                    label="Destination"
                    outlined
                    hide-details
                    return-object
                    required
                    disabled
                    :rules="rules"
                    append-icon=""
                  />
                  <v-checkbox
                    label="Share Ride"
                    color="green"
                    v-model="sharedVehicle"
                    readonly
                    v-show="canShare"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      lg="6"
                      class="py-0"
                    >
                      <v-btn
                        @click="handleClickBack"
                        color="warning"
                        block
                      >
                        Back
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      class="py-0"
                    >
                      <v-btn
                        @click="handleLicenseDialog"
                        color="success"
                        block
                      >
                        Create
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="videoDialog"
        persistent
        max-width="600"
      >
        <v-card
          dark
          color="primary"
        >
          <v-card-title>
            Kia Niro Electric Vehicles (EV) and Regenerative Braking
          </v-card-title>
          <v-card-text>
            <b>Kia Niro Electric Vehicles: Energy Efficiency and Reduced Emissions</b>
            <br>
            Our Kia Niro Electric Vehicles (EV) contribute to a cleaner environment in the City of Darwin by being energy efficient and generating fewer emissions. One key feature of EVs is their regenerative braking system.
            <br>
            <br>
            <b>Regenerative Braking: An Overview</b>
            <br>
            Regenerative braking allows your car to convert kinetic energy into electricity for recharging its battery and enhancing efficiency. This system is different from traditional braking in petrol/diesel vehicles, which use hydraulic fluid to push brake pads against brake discs on each wheel. This friction-based process slows the car down, producing heat and causing wear to the brake pads and discs, necessitating regular replacement.
            <br>
            <br>
            <b>Energy Conservation through Regenerative Braking</b>
            <br>
            With regenerative braking, the energy that is typically wasted during the braking process is captured and utilized for recharging the car's batteries. This means that instead of solely losing energy through heat and friction, some of it can be repurposed in an electric vehicle.
            <br>
            <br>
            <b>Learn More About Regenerative Braking</b>
            <br>
            To gain a better understanding of regenerative braking, we recommend watching
            <a
              style="color: #000;"
              href="https://www.youtube.com/watch?v=fzNWtYhlyBY"
              target="_blank"
            >this video</a>. If you have any further questions or need assistance, please contact our customer service supervisor or fleet advisor.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="videoDialog = false; videoConfirm = false"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="showBookingOverview"
            >
              Yes, I have watched the video.
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="licenseDialog"
        persistent
        max-width="600"
      >
        <v-card
          dark
          color="warning"
        >
          <v-card-title v-if="!isElectricWollongong">
            <span>
              <v-icon>mdi-alert-circle</v-icon> Do you hold a valid licence?
            </span>
          </v-card-title>
          <v-card-title v-else>
            <p class="mb-0">
              <v-icon>mdi-alert-circle</v-icon> You have booked an electric vehicle, please return the vehicle back to charge if there is an available charging station.
            </p>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="licenseDialog = false"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="showBookingOverview"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="bookingOverview"
        persistent
        max-width="600"
      >
        <v-card>
          <v-card-title class="green--text">
            Booking Overview:
          </v-card-title>
          <v-card-text>
            <div>
              <v-icon
                color="green"
                left
              >
                mdi-map-marker
              </v-icon>
              <span>From <b>{{ getOriginName(origin_id) }}</b>
                <a
                  class="black--text"
                  v-if="isTypeVehicle"
                >
                  To
                  <b>{{
                    getDestinationAddrs(
                      destination.selected,
                      selectedPopularData
                    )
                  }}</b>
                </a>
              </span>
            </div>
            <div
              class="my-5"
              v-if="isVehicle"
            >
              <v-icon
                color="green"
                left
              >
                mdi-car
              </v-icon>
              <span>{{ getVehicleName(booking) }}</span>
            </div>
            <div
              class="my-5"
              v-if="!isVehicle && bookingOverview"
            >
              <v-icon
                color="green"
                left
              >
                mdi-car
              </v-icon>
              <span>{{ selectedVehBook }}</span>
            </div>
            <div class="my-5">
              <v-icon
                color="green"
                left
              >
                mdi-calendar
              </v-icon>
              <span>{{ getDate(booking.date) }}</span>
            </div>
            <div class="my-5">
              <v-icon
                color="green"
                left
              >
                mdi-clock-time-three-outline
              </v-icon>
              <span>{{ getDuration() }}</span>
            </div>
            <div
              class="my-5"
              v-if="isNotEmptyCostCode"
            >
              <v-icon
                color="green"
                left
              >
                mdi-currency-usd
              </v-icon>
              <span>{{ this.costCode }}</span>
            </div>
            <div
              class="my-5"
              v-if="isWSP || isIntimap"
            >
              <v-icon
                color="green"
                left
              >
                mdi-order-alphabetical-ascending
              </v-icon>
              <span>{{ getWorkOrderText(this.workOrder) }}</span>
            </div>
            <div
              class="my-5"
              v-if="(isWSP || isIntimap) && isSecondWorkOrder && workOrder2 && workOrder2.code"
            >
              <v-icon
                color="green"
                left
              >
                mdi-order-alphabetical-ascending
              </v-icon>
              <span>
                Second Work Order: {{ getWorkOrderText(this.workOrder2) }}
                <template v-if="create_start_time2 && create_end_time2">
                  ({{ create_start_time2 }} — {{ create_end_time2 }})
                </template>
              </span>
            </div>
            <div
              class="my-5"
              v-if="isWSP || isIntimap"
            >
              <v-icon
                color="green"
                left
              >
                mdi-tag-text-outline
              </v-icon>
              <span>Purpose of Trip: {{ this.purposeOfTrip }}</span>
            </div>
            <div
              class="my-5"
              v-if="isNotEmptyClientName"
            >
              <v-icon
                color="green"
                left
              >
                mdi-account-star
              </v-icon>
              <span>{{ this.clientName }}</span>
            </div>
            <div class="my-5">
              <v-icon
                color="green"
                left
              >
                mdi-map
              </v-icon>
              Car Park Location: {{ getCarParkLocation() }}
            </div>
            <div class="my-5 ">
              <v-icon
                color="green"
                left
              >
                mdi-key
              </v-icon>
              Key Cabinet Location: {{ getKeCabinetLocation() }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error"
              text
              @click="bookingOverview = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="success"
              @click="handleClickSave()"
            >
              Confirm Booking
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-row>
</template>
<script>
/* eslint-disable no-console */
import qs from "qs";
import moment from "moment";
import momentTz from "moment-timezone";
import isUndefined from "lodash/isUndefined";
import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import get from "lodash/get";
import sum from "lodash/sum";
import debounce from "lodash/debounce";
import uniq from "lodash/uniq";
import { gmapApi } from "vue2-google-maps";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import { VCalendar } from "vuetify/lib";
import md5 from "md5";
import { getBookingDestinationText, DESTINATION_SEPARATOR } from "@/plugins/destination";

export default {
  components: { VueTimepicker, VCalendar },
  name: "Book",
  created() {
    const payloadGeofence = {};
    if (this.isIntimap || this.isWSP) {
      payloadGeofence.timezone = 1;
    }
    this.$store.dispatch("GET_GEOFENCES", payloadGeofence).then(() => {
      if (this.getOrigin && this.getOrigin.length == 1) {
        this.origin_id = this.getOrigin[0].Id;
      }
    });
    this.$store.commit("CLEAR_VEHICLE_TYPES_DATA");
    this.$store.dispatch("LOAD_TIMEZONES").then(() => {
      this.datePicker.minimum = new Date(this.timezoneDate);
    });
    this.$store.dispatch("LOAD_POOL_DATA");
    this.getAssetTypes();
    this.getDataAssets();
    this.getDataPopular();

    const { book_id } = this.$route.params;

    const self = this
    self.overlay = true;

    if (book_id) {
      this.editedBookId = book_id;
    }

    Promise.all([
      this.$store.dispatch("LOAD_VEHICLE_TYPE"),
      this.$store.dispatch("LOAD_VEHICLE_TYPES"),
      this.getDataUsers(),
      this.getDataVehicleGroups(),
      this.getDataVehicleGroupsUser(),
      this.fetchWorkOrders()
    ])
    .then(() => {
      this.loadVehicleGroupsUsersAdmin();
      this.loadVehicleGroupsUsers();
      setTimeout(() => {
        self.getDataVehicleAccessories();
        if (!book_id) self.overlay = false;
        self.initEditData(book_id);
      }, 1e3)
    });
  },
  data() {
    return {
      isFirstEdit: false,
      isFBT: false,
      checkAllFbt: false,
      fbtSelectedDates: [],
      listenStartTimeTimeout: 0,
      listenStartTimeTimeout2: 0,
      calendarKey: 0,
      calendarComponent: 'v-calendar',
      editedBookId: null,
      isInitDataEdit: false,
      saveDisabled: false,
      dateToday: moment(new Date()).format("YYYY-MM-DD"),
      timeoutDrag: 0,
      selectedOtherUser: "",
      popDisabled: false,
      bookingOtherUser: false,
      dataVehicleGroups: [],
      selectedVehicleGroup: null,
      selectedPopId: "",
      selectedVariousLocation: "",
      variousDestination: "",
      selectedEvent: {},
      datess: "2021-04-06",
      menu1: false,
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      selectedElement: null,
      selectedOpen: false,
      keepSilent: false,
      handleSilent: null,
      value: "",
      startCalendar: "2021-04-12",
      events: [],
      filteredEvents: [],
      colors: [
        "#2196F3",
        "#3F51B5",
        "#673AB7",
        "#00BCD4",
        "#4CAF50",
        "#FF9800",
        "#757575"
      ],
      names: [
        "Meeting",
        "Holiday",
        "PTO",
        "Travel",
        "Event",
        "Birthday",
        "Conference",
        "Party"
      ],
      categories: [],
      categoryShowAll: true,
      categoryHideDynamic: false,
      categoryDays: 7,
      dragEvent: null,
      tampilTable: false,
      dragStart: null,
      createEvent: null,
      createStart: null,
      createEnd: null,
      extendOriginal: null,
      selectedVehBook: "",
      hideTemp: false,
      menu2: false,
      radios: "endAfter",
      arrayDates: ["2021-03-31", "2021-04-05", "2021-04-08", "2021-04-10"],
      isRecurring: false,
      origin_id: "",
      isShow: true,
      start_time: "",
      time_range: [],
      time_range_end: [],
      isPeriod: false,
      end_time: "",
      timeValue: "",
      date: false,
      pages: "",
      date2: false,
      time: "",
      passengerCount: 1,
      optionPassengerCount: 1,
      passengerList: [],
      sharePassengerList: [],
      costCode: "",
      workOrder: {},
      purposeOfTrip: "",
      clientName: "",
      tabs: null,
      sharedVehicle: true,
      form: true,
      create: true,
      join_book: true,
      search: false,
      selectedAssetType: "",
      selectedView: {
        label: "Weekly",
        value: "week"
      },
      selectedAccessory: [],
      views: [
        {
          label: "Single Day",
          value: "day"
        },
        {
          label: "Weekly",
          value: "week"
        },
      ],
      selectedVehicleType: null,
      selectedVehicleModel: null,
      map: {
        style: "width: 100; height: 400px",
        center: {
          lat: -23.8511901,
          lng: 131.2038283
        },
        zoom: 4,
        options: {
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false
        },
        marker: {},
        oriId: "",
        oriPosition: {},
        destId: "",
        destPosition: {}
      },
      datePicker: {
        masks: {
          input: "DD MMMM YYYY"
        },
        selectedDate: new Date().toISOString().substr(0, 10),
        minimum: new Date()
      },
      destination: {
        search: null,
        timeout: null,
        loading: false,
        locations: [],
        selected: {}
      },
      variousDestinationList: [],
      variousDestinationSearch: {
        search: null,
        timeout: null,
        loading: false,
        locations: [],
        selected: null
      },
      rules: [v => !!v || "Please Complete Field"],
      rulesPassenger: {
        required: value => value < 0 || "Required.",
        counter: value =>
          value <= this.getMaxSeatCount ||
          `Can not more than Available Seat ( ${this.getMaxSeatCount} )`
      },
      rulesJoinPassenger: {
        required: value => !!value || "Required.",
        counter: value =>
          value <= this.availableSeat ||
          `Can not more than Available Seat ( ${this.availableSeat} )`
      },
      calendar: {
        events: [],
        categories: [],
        loading: false,
        start: null,
        end: null,
        page: "line",
        date: null,
        focus: "",
        value: ""
      },
      focus: "",
      dialog: {
        open: false,
        data: {}
      },
      dialogs: {
        open: false,
        data: {}
      },
      status: {},
      max: "2021-04-30",
      end_date: "2021-04-04",
      start_date: "2021-04-04",
      arraytest: [],
      isShared: false,
      showNewPass: false,
      is_already_join: false,
      page: "booking",
      booking: {
        vehicle: "",
        origin_id: "",
        vehicleOptions: [],
        asset: "",
        recurring: "",
        recurring_end: "",
        recurring_endBy: "",
        assetOptions: [],
        date: "",
        end_date: new Date(),
        time: "",
        disabledSelection: false,
        isGreen: false
      },
      startTimeRequired: false,
      endTimeRequired: false,
      passengerValidation: false,
      destinationRequired: false,
      defaultPwd: false,
      alertDefaultPwd: false,
      changeDefaultPwd: false,
      newPassword: "",
      confirmNewPassword: "",
      defaultPassword: "",
      passwordRules: [
        value => !!value || "Please type password.",
        value => (value && value.length >= 6) || "Minimum 6 characters."
      ],
      confirmPasswordRules: [
        value => !!value || "Please type confirm password.",
        value =>
          value === this.newPassword ||
          "The password confirmation does'nt match."
      ],
      defaultPasswordRules: [
        value => !!value || "Please type default password."
      ],
      valid: true,
      successDialog: false,
      recurringItems: ["Daily", "Weekly", "Monthly"],
      recurringEnds: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      getVehiclePeriod: "",
      videoConfirm: false,
      videoDialog: false,
      licenseDialog: false,
      bookingOverview: false,
      end_by: [],
      canShare: false,
      userManageData: [],
      setUser: "",
      isManager: false,
      vehicleTypes: [],
      dataPopular: [],
      selectedPopularData: "",
      destDisabled: false,
      varDisabled: false,
      dataVehicleGroupsUser: [],
      dataAllUser: [],
      dataAllUsers: [],
      type: "number",
      number: 9999,
      duration: 500,
      offset: -115,
      easing: "easeInCubic",
      dataAssets: [],
      assetTypes: [],
      categoriesAll: [],
      isMore: false,
      isBack: false,
      categoriesFour: [],
      loadingUpdate: false,
      loader: null,
      isTypeVehicle: false,
      alertText: "",
      alertState: false,
      alertType: "success",
      dateBooking: false,
      startBookingDate: false,
      endBookingDate: false,
      overlay: false,
      availableSeat: "",
      optionPassenger: [],
      selectedSharePassenger: 1,
      optionsSharePassenger: [],
      disableShareRide: false,
      isShowCalendar: false,
      dataEdit: [],
      completelyNoData: true,
      paramDraw: {},
      isHover: false,
      hoverCategory: "",
      create_start_time: "",
      create_end_time: "",
      create_start_time2: "",
      create_end_time2: "",
      isBusySearch: false,
      costCodeRule: [
        v => !!v || "Cost Code is required",
        v => (v && v.toString().length == 6) || "Cost Code Needs to be 6 Digits",
      ],
      workOrderRule: [
        v => !isEmpty(v) || "Work Order is required"
      ],
      purposeOfTripRule: [
        v => !!v || "Purpose of Trip is required"
      ],
      clientNameRule: [
        v => !!v || "Client Name is required",
        v => (v && v.toString().length >= 3) || "Client Name Needs to be 3 Characters",
      ],
      legendItems: [
        {
          text: "Waiting For Approval",
          color: "orange"
        },
        {
          text: "My Booking",
          color: "green"
        },
        {
          text: "Ride Sharing (Rider)",
          color: "blue"
        },
        {
          text: "Ride Sharing (Owner)",
          color: "cyan"
        },
        {
          text: "Other User Booking",
          color: "light-green"
        },
        {
          text: "Booking E-bike",
          color: "pink"
        },
        {
          text: "Booking Other Asset",
          color: "#914f07"
        },
        {
          text: 'Vehicle Service',
          color: '#2c3e50'
        }
      ],
      heightCalendar: 0,
      isLoadingAssetGroups: false,
      listWorkingDays: [
        { name: "Sunday", value: 0 },
        { name: "Monday", value: 1 },
        { name: "Tuesday", value: 2 },
        { name: "Wednesday", value: 3 },
        { name: "Thursday", value: 4 },
        { name: "Friday", value: 5 },
        { name: "Saturday", value: 6 }
      ],
      last_create_start_time: "",
      last_create_end_time: "",
      swal: null,
      busyMouse: false,
      blockCodes: {},
      minuteInterval: 30,
      isPickPastTime: false,
      services: [],
      workOrders: [],
      searchWorkOrder: '',
      isLoadingWorkOrder: false,
      purposeOfTrips: [
        'Business',
        'Client Meeting',
        'Maintenance',
        'Personal',
        'Site Visit',
      ],
      dataVehicleAccessories: [],
      submitBooking: false,
      vehicleGroupsUsersAdmin: [],
      vehicleGroupsUsers: [],
      workOrder2: {},
      workOrders2: [],
      searchWorkOrder2: '',
      isLoadingWorkOrder2: false,
      workOrderRule2: [
        v => !isEmpty(v) || "Work Order is required"
      ],
      isSecondWorkOrder: false,
    }
  },
  watch: {
    'booking.date'(value) {
       const timeRange = this.getLimitTimeRange();
      if (timeRange.length > 0) {
        this.time_range = timeRange;
      }
      
      // Reset FBT selected dates when start date changes (only if not in edit mode)
      if (this.isFBT && !this.isFirstEdit) {
        this.fbtSelectedDates = [];
        this.checkAllFbt = false;
        this.isFBT = false;this.fbtSelectedDates = [];
      }
    },
    'booking.end_date'(value) {
      // Reset FBT selected dates when end date changes (only if not in edit mode)
      if (this.isFBT && !this.isFirstEdit) {
        this.fbtSelectedDates = [];
        this.checkAllFbt = false;
        this.isFBT = false;
      }
    },
    isFBT(value) {
      if (!value && this.fbtSelectedDates.length) {
        this.fbtSelectedDates = [];
      }
    },
    events(value) {
      const currentEventId = [];
      this.filteredEvents = value.filter((event) => {
        if (this.isMore) {
          return this.categoriesFour.includes(event.category);
        }
        return true;
      });
    },
    vehicleGroups(value) {
      if (this.isFirstEdit) return
      if (value.length == 0 && this.selectedVehicleGroup) {
        this.selectedVehicleGroup = null;
      } else {
        if (this.selectedVehicleGroup) {
          const filter = value.find(
            item => item.id === this.selectedVehicleGroup.id
          );
          if (!filter) {
            this.selectedVehicleGroup = null;
          }
        }
        
        // Auto-select first asset group if only one is available
        if (value.length === 1 && !this.selectedVehicleGroup) {
          this.selectedVehicleGroup = value[0];
        }
      }
    },
    filteredAccessories(value) {
      if (this.isFirstEdit) return
      if (value.length == 0 && this.selectedAccessory.length) {
        this.selectedAccessory = [];
      } else {
        if (this.selectedAccessory.length) {
          const selectedIds = this.selectedAccessory.map(i => i);
          const filteredIds = value.map(i => i);
          const diff = selectedIds.filter(id => !filteredIds.includes(id));
          if (diff.length) {
            this.selectedAccessory = this.selectedAccessory.filter(i =>
              filteredIds.includes(i)
            );
          }
        }
      }
    },
    optionPassengerCount(value) {
      if (value < this.passengerList.length) {
        this.passengerList = this.passengerList.slice(0, value);
      }
    },
    selectedSharePassenger(value) {
      const requiredLength = Math.max(0, value); // Include all passengers including the main requester
      if (requiredLength < this.sharePassengerList.length) {
        this.sharePassengerList = this.sharePassengerList.slice(0, requiredLength);
      } else {
        while (this.sharePassengerList.length < requiredLength) {
          this.sharePassengerList.push('');
        }
      }
    },
    selectedView(selectedView) {
      if (this.categoriesAll.length) {
        if (selectedView.value == 'week') {
          this.defaultCalendar(null, null);
        } else {
          this.moreVehicle(null, this.dateToday);
        }
      }
    },
    selectedAssetType(value) {
      let filter = this.assetTypes.find(a => a.id === value.id);
      if (!isEmpty(filter)) {
        if (filter.is_vehicle == "1") {
          this.isTypeVehicle = true;
        } else {
          this.isTypeVehicle = false;
        }
      }
    },
    selectedPopId(value) {
      if (value.length) {
        this.selectedPopularData = this.dataPopular.find(
          item => item.id == value
        );
        this.varDisabled = true;
        this.destDisabled = true;
        if (!this.isFirstEdit) {
          this.selectedVariousLocation = "";
        }
      }
    },
    selectedVehicleType(value) {
      const item = this.vehicleTypes.find(d => d.id == value);
      if (!item) return;
      item.ride_share =
        typeof item.ride_share === "string"
          ? parseInt(item.ride_share)
          : item.ride_share;
      if (item.ride_share == 1) {
        this.canShare = true;
        this.sharedVehicle = true;
      }
    },
    searchWorkOrder: {
      handler: debounce(function (val) {
        if (this.workOrder) {
          if (this.workOrder.code == val) {
            return;
          }
        }
        this.fetchWorkOrders(val);
      }, 500),
      immediate: false,
    },
    searchWorkOrder2: {
      handler: debounce(function (val) {
        if (this.workOrder2) {
          if (this.workOrder2.code == val) {
            return;
          }
        }
        this.fetchWorkOrders2(val);
      }, 500),
      immediate: false,
    },
    "destination.search"(value) {
      if (!isNull(value)) {
        this.popDisabled = true;
      } else {
        this.popDisabled = false;
      }
      clearTimeout(this.destination.timeout);
      if (this.destination.selected) {
        if (this.destination.search == this.destination.selected.address)
          return;
      }
      if (!this.destination.search) {
        this.destination.locations = [];
        this.destination.loading = false;
        return;
      }
      if (!isNull(this.destination.search)) {
        this.destinationRequired = false;
      }
      if (!this.isFirstEdit) {
        this.selectedVariousLocation = "";
      }
      this.destination.timeout = setTimeout(() => {
        this.handleSearchDestination(this.destination.search, this);
      }, 2e3);
    },
    "variousDestinationSearch.search"(value) {
      clearTimeout(this.variousDestinationSearch.timeout);
      if (!value) {
        this.variousDestinationSearch.locations = [];
        this.variousDestinationSearch.loading = false;
        return;
      }
      this.variousDestinationSearch.timeout = setTimeout(() => {
        this.handleSearchDestination(value, this, "variousDestinationSearch");
      }, 2e3);
    },
    "variousDestinationSearch.selected"(value) {
      if (!value || !value.address) return;
      const alreadyAdded = this.variousDestinationList.some(
        dest => dest.address === value.address
      );
      if (!alreadyAdded) {
        this.variousDestinationList.push({
          address: value.address,
          latitude: value.latitude,
          longitude: value.longitude
        });
      }
      this.$nextTick(() => {
        this.variousDestinationSearch.selected = null;
        this.variousDestinationSearch.search = null;
        this.variousDestinationSearch.locations = [];
      });
    },
    variousDestinationList(value) {
      if (!this.hasStructuredVariousDestination) return;
      if (!value.length) {
        this.destination.selected = {};
        this.destination.search = null;
        return;
      }
      const first = value[0];
      this.destination.selected = {
        address: value.map(dest => dest.address).join(DESTINATION_SEPARATOR),
        latitude: first.latitude,
        longitude: first.longitude,
        lat: first.latitude,
        lng: first.longitude
      };
    },
    selectedVariousLocation(value) {
      if (!value && this.hasStructuredVariousDestination && this.variousDestinationList.length) {
        this.variousDestinationList = [];
      }
    },
    start_time(value, prev) {
      if (!isEmpty(value)) {
        this.startTimeRequired = false;
      }
    },
    create_start_time(value, prev) {
      this.last_create_start_time = prev;
    },
    passengerCount(value) {
      if (value > this.getMaxSeatCount) {
        this.passengerValidation = true;
      }
    },
    end_time(value) {
      if (!isEmpty(value)) {
        this.endTimeRequired = false;
      }
    },
    create_end_time(value, prev) {
      this.last_create_end_time = prev;
    },
    origin_id(value) {
      if (value == null) return;
      const geo = this.getOrigin.find(origin => origin.Id == value);
      if (!geo) return;
      const lat = (parseFloat(geo.top) + parseFloat(geo.bottom)) / 2;
      const lng = (parseFloat(geo.left) + parseFloat(geo.right)) / 2;
      this.map.oriId = geo.Id;
      this.map.oriPosition = { lat, lng };
      this.map.center = { lat, lng };
      this.map.zoom = 6;
      
      // Auto-select first asset group if only one is available for this origin
      this.$nextTick(() => {
        if (this.vehicleGroups && this.vehicleGroups.length === 1) {
          this.selectedVehicleGroup = this.vehicleGroups[0];
        }
      });
    },
    "destination.selected"(value) {
      const geo = value;

      if (!geo) return;
      if (geo.type == "sd") {
        const lat2 = parseFloat(this.map.oriPosition.lat);
        const lat = parseFloat(geo.lat);
        const lng = parseFloat(geo.lng);
        this.map.destPosition = { lat, lng };
        this.map.center = { lat2, lng };
        this.map.zoom = 4;
      } else if (geo.type == "geofence") {
        const lat2 = parseFloat(this.map.oriPosition.lat);
        const lat = (parseFloat(geo.top) + parseFloat(geo.bottom)) / 2;
        const lng = (parseFloat(geo.left) + parseFloat(geo.right)) / 2;
        this.map.destPosition = { lng, lat };
        this.map.center = { lng, lat2 };
        this.map.zoom = 4;
      } else if (geo.type == "popular_address") {
        const lat2 = parseFloat(this.map.oriPosition.lat);
        const lng = Number(geo.longitude);
        this.map.destPosition = {
          lat: Number(geo.latitude),
          lng: Number(geo.longitude)
        };
        this.map.center = { lng, lat2 };
        this.map.zoom = 4;
      }
    },
    "booking.recurring"(value) {
      if (value === "Daily") {
        this.max = moment(this.booking.date)
          .format("YYYY-12-31");
        this.arraytest = [];
        this.dates(this.booking.date);
      } else if (value === "Weekly") {
        this.max = moment(this.booking.date)
          .add(4, "M")
          .format("YYYY-MM-DD");
        this.arraytest = [];

        this.dates(this.booking.date);
      } else {
        this.max = moment(this.booking.date)
          .add(1, "Y")
          .format("YYYY-MM-DD");
        this.arraytest = [];

        this.dates(this.booking.date);
      }
    },
    // "booking.date"(value) {
    //   if (!isEmpty(value)) {
    //     this.booking.end_date = value;
    //   }
    // },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    bookingOtherUser() {
      this.selectedVehicleGroup = "";
      this.selectedOtherUser = "";
    },
    selectedOtherUser(value) {
      this.selectedVehicleGroup = "";
    }
  },
  mounted() {
    if (this.isYarra || this.isWollongong) {
      this.selectedView = {
        label: "Single Day",
        value: "day"
      };
    }
    if (this.isDarwin) {
      this.minuteInterval = 15;
    }
    if (!this.isWollongong && !this.isIntimap) {
      this.legendItems.push(
      {
        text: "Booking Myki",
        color: "purple"
      })
    }
  },
  computed: {
    optionSharePassengerCount() {
      return this.selectedSharePassenger;
    },
    isTasWater() {
      return this.$store.state.clientid === "GHHHZKDOAAA0";
    },
    isIntellitrac() {
      return this.$store.state.clientid === "ECZ1PXM4JO68";
    },
    hasStructuredVariousDestination() {
      return this.isTasWater || this.isIntimap || this.isIntellitrac;
    },
    time_range2() {
      const timeRange = Object.assign([], this.time_range);
      timeRange[0] = moment(this.create_end_time, "HH:mm").format("HH");
      timeRange[0] = parseInt(timeRange[0], 10);
      if (this.create_end_time.indexOf('30') > -1) {
        timeRange[0] += 1;
      }
      return timeRange;
    },
    time_range_end2() {
      const timeRangeEnd = Object.assign([], this.time_range_end);
      timeRangeEnd[0] = moment(this.create_start_time2, "HH:mm").format("HH");
      timeRangeEnd[0] = parseInt(timeRangeEnd[0], 10);
      return timeRangeEnd;
    },
    fbtDates() {
      if (this.isFBT) {
        const dates = []
        const clonedStartdate = moment(this.booking.date).clone();
        const clonedEndDate = moment(this.booking.end_date).clone();
        while (clonedStartdate.isBefore(clonedEndDate)) {
          dates.push(clonedStartdate.format("YYYY-MM-DD"));
          clonedStartdate.add(1, "d");
        }
        return dates;
      }
      return [];
    },
    isMoreThanOneDay() {
      return this.booking.end_date && this.booking.date &&
        this.booking.end_date != this.booking.date;
    },
    computedDateFormattedMomentjs() {
      return this.dateToday
        ? moment(this.dateToday).format("dddd, MMMM Do YYYY")
        : "";
    },
    handleEndDateValue() {
      return this.booking.end_date
        ? moment(this.booking.end_date).format("dddd, MMMM Do YYYY")
        : "";
    },
    target() {
      const value = this.$refs.handleSearch;
      if (!isNaN(value)) return Number(value);
      else return value;
    },
    isDarwin() {
      return this.$store.state.clientid === "ED73T6OILP78";
    },
    isNotEmptyCostCode() {
      return !isEmpty(this.costCode);
    },
    isNotEmptyWorkOrder() {
      return !isEmpty(this.workOrder);
    },
    isNotEmptyPurposeOfTrip() {
      return !isEmpty(this.purposeOfTrip);
    },
    isNotEmptyClientName() {
      return !isEmpty(this.clientName);
    },
    userWorkingDay() {
      return this.$store.state.user.company.metadata.working_day;
    },
    userStartWorkingTime() {
      return get(this.$store.state, 'user.company.metadata.working_time.start', '');
    },
    userEndWorkingTime() {
      return get(this.$store.state, 'user.company.metadata.working_time.end', '');
    },
    isRestrictedBooking() {
      return this.$store.state.user.company.metadata.restrict_booking == 1;
    },
    isOvernightBooking() {
      return this.$store.state.user.company.metadata.overnight_booking == 1;
    },
    isAdvanceBookingRequireApproval() {
      return get(this.$store.state, 'user.company.metadata.advance_booking_require_approval', 0) == 1;
    },
    advanceBookingHoursThreshold() {
      return parseInt(get(this.$store.state, 'user.company.metadata.advance_booking_hours_threshold', 72));
    },
    maxBookingDays() {
      const configured = parseInt(get(this.$store.state, 'user.company.metadata.max_booking_days', ''), 10);
      if (!isNaN(configured) && configured >= 1) {
        return configured;
      }
      // No company setting, so keep the ceiling this form has always applied
      // rather than opening bookings up to the backend's unlimited default.
      return (this.isWSP || this.isIntimap) ? 28 : 7;
    },
    maxBookingDurationLabel() {
      const days = this.maxBookingDays;
      if (!days) return "";
      // Mirrors how the backend words its rejection: exact multiples of a week
      // read as weeks, everything else as days.
      if (days % 7 === 0) {
        const weeks = days / 7;
        return `Maximum booking duration is ${weeks} ${weeks === 1 ? "week" : "weeks"}.`;
      }
      return `Maximum booking duration is ${days} ${days === 1 ? "day" : "days"}.`;
    },
    isHideBookingDestination() {
      if (!this.$store.state.user.company.metadata) {
        return false;
      }
      return this.getValueAsBoolean(
        this.$store.state.user.company.metadata.no_need_destination
      );
    },
    isHideSearchAddress() {
      if (!this.$store.state.user.company.metadata) {
        return false;
      }
      return this.getValueAsBoolean(
        this.$store.state.user.company.metadata.no_need_search_address
      );
    },
    scrollOptions() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      };
    },
    googles: gmapApi,
    hasAccessBookingOther() {
      let metadata = {};

      if (typeof this.$store.state.user.user.metadata == "string") {
        try {
          metadata = JSON.parse(this.$store.state.user.user.metadata);
        } catch (e) {}
      } else {
        metadata = this.$store.state.user.user.metadata;
      }

      if (metadata == null) metadata = {};

      let userhasaccess = false;
      if (metadata.hasOwnProperty('as_manager')) {
        userhasaccess = this.getValueAsBoolean(metadata.as_manager);
      }

      if (this.$store.state.user.user.type == 1 || this.$store.state.user.user.type == 5 || userhasaccess) {
        return true;
      }

      return false;
    },
    token() {
      return this.$store.state.token;
    },
    clientid() {
      return this.$store.state.clientid;
    },
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
    origin() {
      const groups = this.geofences[this.$store.state.clientid].filter(
        group =>
          group.name === "Carpool Origin" ||
          group.name === "Carpool Origin - Destination" ||
          group.name === "Carpool Origin without Key Cabinet"
      );
      let geofences = [];

      groups.forEach(group => {
        group.geofences.forEach(geofence => {
          geofences.push(geofence);
        });
      });

      geofences = geofences.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      return geofences[0];
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getOrigin() {
      if (this.geofences[this.$store.state.clientid]) {
        const groups = this.geofences[this.$store.state.clientid].filter(
          group =>
            group.name === "Carpool Origin" ||
            group.name === "Carpool Origin - Destination" ||
            group.name === "Carpool Origin without Key Cabinet"
        );
        const geofences = [];

        // eslint-disable-next-line no-unused-vars
        groups.forEach((group, i) => {
          // eslint-disable-next-line no-unused-vars
          group.geofences.forEach((geofence, i) => {
            geofences.push(geofence);
          });
        });
        return geofences.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      }
    },
    books() {
      const books = this.$store.getters["books"];
      return books.map(book => {
        const schedules = book.schedules;

        const recurringKeys = schedules
          .filter(s => s.detail.recurring.toString() == '0' && s.detail.recurring_key)
          .map(s => s.detail.recurring_key);

        const filtered = schedules.filter(s => {
          if (s.detail.recurring.toString() != '1') return true;

          const hash = md5(String(s.detail.id));
          return !recurringKeys.some(key => key.includes(hash));
        });

        return {
          ...book,
          schedules: filtered
        };
      });
    },
    timezones() {
      return this.$store.getters["getTimezones"];
    },
    user() {
      const { user = {} } = this.$store.getters["getUserData"];
      return user;
    },
    timezoneDate() {
      const currentTimezone = this.timezones.find(
        timezone => timezone.name === this.user.timezone
      );
      if (!currentTimezone) return "";
      const currentDate = momentTz
        .tz(currentTimezone.type)
        .format("YYYY-MM-DD HH:mm:ss");
      return currentDate;
    },
    userTimezone() {
      let selectedUser = this.user;
      if (this.bookingOtherUser) {
        selectedUser = this.dataAllUsers.find(
          user => user.id == this.selectedOtherUser
        );
      }
      const currentTimezone = this.timezones.find(
        timezone => timezone.name == selectedUser.timezone
      );
      if (!currentTimezone) return moment.tz.guess();
      return currentTimezone.type;
    },
    getVehicles() {
      return this.$store.getters["getVehicles"];
    },
    listVehicles() {
      return this.$store.getters["getVehicles"];
    },
    getMaxSeatCount() {
      if (
        this.page == "form" ||
        this.pages == "dialog" ||
        this.page == "booking"
      ) {
        let metadata = {};
        if (this.isVehicle) {
          let vehicleData = null;
          if (this.booking.isGreen) {
            vehicleData = this.listVehicles.find(
              vehicle => vehicle.id == this.booking.vehicle
            );
          } else {
            vehicleData = this.listVehicles.find(
              vehicle => vehicle.id == this.booking.vehicle
            );
          }

          if (this.booking.isGreen) {
            metadata = get(vehicleData, "metadata", {});
          } else {
            metadata = get(vehicleData, "metadata", {});
          }
        } else {
          const assetData = this.booking.assetOptions.find(
            asset => asset.id == this.booking.asset
          );
          try {
            metadata = JSON.parse(assetData.metadata);
            // eslint-disable-next-line no-empty
          } catch (e) {}
        }
        if (metadata.hasOwnProperty("seat_count")) {
          if (!isEmpty(metadata.seat_count)) {
            let limit = parseInt(metadata.seat_count);
            let array = [];
            for (let i = 1; i <= limit; i++) {
              array.push(i);
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.optionPassenger = array;
            return limit;
          } else {
            let array = [];
            for (let i = 1; i <= 5; i++) {
              array.push(i);
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.optionPassenger = array;
            return 5;
          }
        }
      } else {
        return 0;
      }

      return 0;
    },
    isShowMarker() {
      const { marker } = this.map;
      const { lat = 0, lng = 0 } = marker;
      return lat && lng;
    },
    selectedAssetTypeObj() {
      return this.assetTypes.find(a => a.id === this.selectedAssetType.id);
    },
    selectedAssetTypeName() {
      return get(this.selectedAssetTypeObj, "name", "");
    },
    textMore() {
      const text = this.isVehicle
        ? "More Available Vehicles"
        : `More Available ${this.selectedGroupName}`;
      return text;
    },
    isVehicle() {
      return (
        this.selectedAssetTypeObj &&
        this.selectedAssetTypeObj.is_vehicle === "1"
      );
    },
    isElectricVehicle() {
      return (
        this.isDarwin &&
        this.isVehicle &&
        this.selectedAssetTypeObj.name === "Electric Vehicle"
      );
    },
    selectedGroup() {
      if (!this.selectedVehicleGroup) return null;
      const vehGroupId = this.isAdmin
        ? this.selectedVehicleGroup.id
        : this.selectedVehicleGroup.group_id;
      return this.isAdmin
        ? this.vehicleGroups.find(vg => vg.id === vehGroupId)
        : this.vehicleGroups.find(vg => vg.group_id === vehGroupId);
    },
    selectedGroupName() {
      if (!this.selectedGroup) return "";
      const group_name = this.isAdmin
        ? get(this.selectedGroup, "name", "")
        : get(this.selectedGroup, "group_name", "");
      return group_name;
    },
    isLoadingCalendar() {
      return this.search && this.calendar.loading;
    },
    isFinishLoadingCalendar() {
      return this.search && this.calendar.loading === false;
    },
    isShowLineCalendar() {
      return (
        this.calendar.page === "line" &&
        (this.isLoadingCalendar || this.isFinishLoadingCalendar)
      );
    },
    isShowCategoryCalendar() {
      return this.calendar.page === "category";
    },
    isYarra() {
      return this.$store.state.clientid === "HCQSWYNLHF6A";
    },
    isVictrack() {
      return this.$store.state.clientid === "E4IKWG0LDBM8";
    },
    isAdmin() {
      return this.user.type == "1" ||
        this.user.type == 1 ||
        this.user.type == '3' ||
        this.user.type == 3 ||
        this.user.type == '5' ||
        this.user.type == 5;
    },
    vehicleGroupsAll() {
      if (this.isAdmin || this.bookingOtherUser) {
        return this.vehicleGroupsUsersAdmin.filter(
          group =>
            get(group, "metadata.asset_type") == this.selectedAssetType.id
        );
      }
      return this.vehicleGroupsUsers.filter(
        group => get(group, "metadata.asset_type") == this.selectedAssetType.id
      );
    },
    vehicleGroups() {
      let vehicleGroups = this.vehicleGroupsAll.filter(group => {
        const noBookingRequired = this.getValueAsBoolean(get(group, "metadata.no_booking_required", false));
        const isSpecial = this.getValueAsBoolean(get(group, "metadata.is_special", false));
        return !noBookingRequired && !isSpecial;
      });
      if (this.bookingOtherUser) {
        if (this.selectedOtherUser) {
          const selectedOtherUser = this.dataAllUsers.find(
            user => user.id == this.selectedOtherUser
          );
          if (selectedOtherUser) {
            if (selectedOtherUser.type == 1 || selectedOtherUser.type == 3 || selectedOtherUser.type == 5) return vehicleGroups;
            vehicleGroups = vehicleGroups.filter(vg =>
              vg.users.find(u => u.user_id == this.selectedOtherUser)
            );
            vehicleGroups = vehicleGroups.map(vg => {
              vg.group_id = vg.id;
              vg.group_name = vg.name;
              return vg;
            });
          } else {
            return [];
          }
        } else {
          return [];
        }
      }
      return vehicleGroups.filter((grp) => {
        if (this.origin_id != '') {
            return grp.members.some(
              member => member.detail.origin_id == parseInt(this.origin_id)
            );
        }
        return false;
      })
    },
    isWollongong() {
      return this.$store.state.clientid == 'A506MF91OINZ';
    },
    isElectricWollongong() {
      return this.isWollongong && this.selectedAssetTypeName.toLowerCase().includes('electric');
    },
    startDateFormatted() {
      return moment(this.booking.date).format("DD MMM YYYY");
    },
    endDateFormatted() {
      return moment(this.booking.end_date).format("DD MMM YYYY");
    },
    dateRanges() {
      const dates = [];
      const currentDate = moment(this.timezoneDate);
      const selectedDate = this.dateToday;
      let startDate = moment(selectedDate)
        .add(-3, 'days')
        .format('YYYY-MM-DD');
      let endDate = moment(selectedDate)
        .add(3, 'days')
        .format('YYYY-MM-DD');

      if (moment(selectedDate).diff(currentDate, 'days') < 3 && moment(selectedDate).isAfter(currentDate)) {
        startDate = currentDate.format('YYYY-MM-DD');
        endDate = moment(selectedDate)
        .add(6, 'days')
        .format('YYYY-MM-DD');
      }
      
      if (startDate && endDate) {
        while (startDate <= endDate) {
          dates.push(startDate);
          startDate = moment(startDate)
            .add(1, 'days')
            .format('YYYY-MM-DD');
        }
      }

      return dates;
    },
    isWSP() {
      return this.$store.state.clientid == 'H1O5G7P0N3JA';
    },
    isIntimap() {
      return this.$store.state.clientid == 'DSSTWWLLIHH7';
    },
    isAllowRecurring() {
       if (this.$store.state.user.company.metadata.hasOwnProperty('recurring_booking')) {
        return this.getValueAsBoolean(this.$store.state.user.company.metadata.recurring_booking);
       }
       return true;
    },
    filteredAccessories() {
      if (this.origin_id && this.selectedVehicleGroup) {
        return this.vehicleGroups.reduce((arr, val) => {
          if (val.id != this.selectedVehicleGroup.id) return arr;
          val.members.forEach(member => {
            const accessories = get(member, 'detail.metadata.accessories', []);
            if (accessories.length) {
              const originId = get(member, 'detail.origin_id', '');
              if (originId == this.origin_id) {
                accessories.forEach(accessory => {
                  if (!arr.includes(accessory)) {
                    arr.push(accessory);
                  }
                });
              }
            }
          });
          return uniq(arr);
        }, []).sort((a, b) => {
          return a.localeCompare(b);
        });
      }
      return [];
    }
  },
  methods: {
    getLimitTimeRange() {
      const result = [0, 23];

      if (!this.selectedEvent || !this.booking || !this.booking.date) return result;

      const currentDate = this.booking.date;
      const categoryId = this.selectedEvent.category;

      let workingStart = '00:00';
      let workingEnd = '23:59';
      if (this.isTypeVehicle) {
        const vehicle = this.getVehicles.find(v => v.id === categoryId);
        if (vehicle) {
          const wt = this.getWorkingTime(vehicle, 'metadata.working_time');
          if (wt.start && wt.end) {
            workingStart = wt.start;
            workingEnd = wt.end;
          }
        }
      } else {
        const asset = this.dataAssets.find(a => a.id === categoryId);
        if (asset) {
          try {
            const meta = typeof asset.metadata === 'string' ? JSON.parse(asset.metadata) : asset.metadata;
            const wt = this.getWorkingTime(meta, 'working_time');
            if (wt.start && wt.end) {
              workingStart = wt.start;
              workingEnd = wt.end;
            }
          } catch (e) {}
        }
      }

      let timezone = this.userTimezone;
      if ((this.isIntimap || this.isWSP) && this.origin_id) {
        const origin = this.getOrigin.find(o => o.Id === this.origin_id);
        const tz = get(origin, 'metadata.timezone.timeZoneId');
        if (tz) timezone = tz;
      }

      const now = momentTz().tz(timezone).subtract(15, 'minutes');
      const nowDateStr = now.format('YYYY-MM-DD');

      if (currentDate === nowDateStr && isEmpty(this.dataEdit)) {
        const nowTime = now.format('HH:mm');
        if (moment(nowTime, 'HH:mm').isAfter(moment(workingStart, 'HH:mm'))) {
          workingStart = nowTime;
        }
      }

      const currentBook = this.books.find(b => b.date === currentDate);
      if (currentBook && currentBook.schedules && currentBook.schedules.length) {
        const schedules = currentBook.schedules
          .filter(s => {
            const assetId = s.detail.vehicle_id ? s.detail.vehicle_id : s.detail.asset_id;
            if (parseInt(assetId) !== parseInt(categoryId)) return false;
            if (!isEmpty(this.dataEdit)) {
              const editId = get(this.dataEdit, 'id');
              const schedId = get(s, 'detail.id');
              if (editId && schedId && parseInt(editId) === parseInt(schedId)) return false;
            }
            return true;
          })
          .map(s => ({
            start: s.start,
            end: s.end
          }))
          .sort((a, b) => moment(a.start, 'HH:mm').valueOf() - moment(b.start, 'HH:mm').valueOf());

        const selStart = this.create_start_time && this.create_start_time !== 'Invalid date' ? this.create_start_time : null;
        const selEnd = this.create_end_time && this.create_end_time !== 'Invalid date' ? this.create_end_time : null;

        let prevEnd = workingStart;
        let nextStart = workingEnd;

        if (schedules.length) {
          const referenceStart = selStart || workingStart;
          const referenceEnd = selEnd || workingEnd;
          const refStartMoment = moment(referenceStart, 'HH:mm');
          const refEndMoment = moment(referenceEnd, 'HH:mm');

          schedules.forEach(s => {
            const sStart = moment(s.start, 'HH:mm');
            const sEnd = moment(s.end, 'HH:mm');

            // Wholly before the selection: it can only raise the floor.
            if (sEnd.isSameOrBefore(refStartMoment)) {
              if (sEnd.isAfter(moment(prevEnd, 'HH:mm'))) prevEnd = s.end;
              return;
            }

            // Wholly after the selection: it can only lower the ceiling.
            if (sStart.isSameOrAfter(refEndMoment)) {
              if (sStart.isBefore(moment(nextStart, 'HH:mm'))) nextStart = s.start;
              return;
            }

            // Anything left overlaps the selection, and the two tests above
            // used to be the whole story: a booking sitting wholly inside the
            // selected window answered neither of them, so the gap came back as
            // the entire working day and 08:30-15:30 could be picked straight
            // over an existing 09:30-12:00. INT-004972.
            if (sStart.isAfter(refStartMoment)) {
              // The clash opens after the selection does, so the selection has
              // to finish before it.
              if (sStart.isBefore(moment(nextStart, 'HH:mm'))) nextStart = s.start;
            } else if (sEnd.isAfter(moment(prevEnd, 'HH:mm'))) {
              // The clash already covers the selected start, so the floor moves
              // past the end of it.
              prevEnd = s.end;
            }
          });
        }

        let minStartMoment = moment.max(moment(prevEnd, 'HH:mm'), moment(workingStart, 'HH:mm'));
        let maxEndMoment = moment.min(moment(nextStart, 'HH:mm'), moment(workingEnd, 'HH:mm'));

        // A selection that already straddles a booking can push the floor past
        // the ceiling. Offering no selectable hour at all strands the user with
        // no way to correct the time, so hand back the working day and let the
        // clash check on submit be the thing that refuses.
        if (minStartMoment.isSameOrAfter(maxEndMoment)) {
          minStartMoment = moment(workingStart, 'HH:mm');
          maxEndMoment = moment(workingEnd, 'HH:mm');
        }

        const minStartHour = minStartMoment.hour() + (minStartMoment.minute() >= 30 ? 1 : 0);
        const maxEndHour = maxEndMoment.hour() + (maxEndMoment.minute() >= 30 ? 1 : 0);

        result[0] = Math.max(0, Math.min(23, minStartHour));
        result[1] = Math.max(0, Math.min(23, maxEndHour));
      } else {
        const workingStartMoment = moment(workingStart, 'HH:mm');
        const workingEndMoment = moment(workingEnd, 'HH:mm');
        
        const minStartHour = workingStartMoment.hour() + (workingStartMoment.minute() >= 30 ? 1 : 0);
        const maxEndHour = workingEndMoment.hour() + (workingEndMoment.minute() >= 30 ? 1 : 0);

        result[0] = Math.max(0, Math.min(23, minStartHour));
        result[1] = Math.max(0, Math.min(23, maxEndHour));
      }

      if (this.create_start_time && moment(this.create_start_time, 'HH:mm').isBefore(moment(workingStart, 'HH:mm')) && isEmpty(this.dataEdit)) {
        this.create_start_time = workingStart;
        this.start_time = workingStart;
      }
      if (this.create_end_time && moment(this.create_end_time, 'HH:mm').isAfter(moment(workingEnd, 'HH:mm'))) {
        this.create_end_time = workingEnd;
        this.end_time = workingEnd;
      }

      return result;
    },
    getPassengerList(data) {
      if (data.book_metadata && data.book_metadata.hasOwnProperty("passenger_list")) {
        let passengerList = data.book_metadata.passenger_list;
        if (typeof passengerList === "string") {
          try {
            passengerList = JSON.parse(passengerList);
          } catch (e) {
            passengerList = [];
          }
        } 
        return passengerList;
      } else {
        return [];
      }
    },
    handleSecondWorkOrder() {
      this.isSecondWorkOrder = !this.isSecondWorkOrder;
      if (this.isSecondWorkOrder) {
        this.workOrder2 = {};
        this.workOrders2 = [];
        this.searchWorkOrder2 = '';
        this.fetchWorkOrders2();
      }
    },
    handleCheckAllFbt() {
      if (this.checkAllFbt) {
        this.fbtSelectedDates = this.fbtDates;
      } else {
        this.fbtSelectedDates = [];
      }
    },
    loadVehicleGroupsUsersAdmin() {
      if (!this.dataVehicleGroups.length) return;

      const vehiclesById = new Map(this.getVehicles.map(v => [v.id.toString(), v]));
      const usersById = new Map(this.dataAllUsers.map(u => [u.id.toString(), u]));

      this.vehicleGroupsUsersAdmin = this.dataVehicleGroups.map(group => {
        const clonedGroup = { ...group };

        const memberIds = (clonedGroup.group_member_id || []).map(id => id.toString());
        const userIds = (clonedGroup.group_user_id || []).map(id => id.toString());

        clonedGroup.members = memberIds
          .map(id => vehiclesById.get(id))
          .filter(Boolean)
          .map(vehicle => ({ detail: vehicle }));

        clonedGroup.users = userIds
          .map(id => usersById.get(id))
          .filter(Boolean)
          .map(user => ({
            user_id: user.id,
            name: user.name,
            email: user.email,
            type: user.type
          }));

        return clonedGroup;
      });
    },
    loadVehicleGroupsUsers() {
      if (!this.dataVehicleGroups.length) return;

      const vehiclesById = new Map(this.getVehicles.map(v => [v.id.toString(), v]));
      const usersById = new Map(this.dataAllUsers.map(u => [u.id.toString(), u]));

      this.vehicleGroupsUsers = this.dataVehicleGroupsUser.map(group => {
        const clonedGroup = { ...group };

        const vehicleGroup = this.dataVehicleGroups.find(
          v => v.id == clonedGroup.group_id
        );

        if (vehicleGroup) {
          const memberIds = (vehicleGroup.group_member_id || []).map(id => id.toString());
          const userIds = (vehicleGroup.group_user_id || []).map(id => id.toString());

          clonedGroup.members = memberIds
            .map(id => vehiclesById.get(id))
            .filter(Boolean)
            .map(vehicle => ({ detail: vehicle }));

          clonedGroup.users = userIds
            .map(id => usersById.get(id))
            .filter(Boolean)
            .map(user => ({
              user_id: user.id,
              name: user.name,
              email: user.email,
              type: user.type
            }));
        } else {
          clonedGroup.members = [];
          clonedGroup.users = [];
        }

        return clonedGroup;
      });
    },
    fetchWorkOrders(search) {
      this.isLoadingWorkOrder = true;
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_work_order",
          $postData: {
            clientid: this.$store.state.clientid,
            query: search,
            limit: 50,
            offset: 0,
          }
        })
        .then(response => {
          this.workOrders = response.data.data;
        })
        .finally(() => {
          this.isLoadingWorkOrder = false;
        });
    },
    fetchWorkOrders2(search) {
      this.isLoadingWorkOrder2 = true;
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_work_order",
          $postData: {
            clientid: this.$store.state.clientid,
            query: search,
            limit: 50,
            offset: 0,
          }
        })
        .then(response => {
          this.workOrders2 = response.data.data;
        })
        .finally(() => {
          this.isLoadingWorkOrder2 = false;
        });
    },
    getWorkOrderText(item) {
      if (!item || !item.code) return "";
      return item.code;
    },
    handleChangeEndAfter() {
      if (this.booking.recurring_end < 1) {
        this.booking.recurring_end = 1;
      }
    },
    handleClickCalendar(ref) {
      setTimeout(() => {
        var vPicker = this.$refs[ref].$el;
        var parentPicker = vPicker.parentElement;
        var isPickerVisible = parentPicker.style.display != 'none';

        this.radios = "endBy";

        if (isPickerVisible) {
          var currentParentPickerLeft = parentPicker.style.left.replace('px', '');
          var correctionCurrentParentPickerLeft = parseInt(currentParentPickerLeft) - 350;
          parentPicker.style.left = correctionCurrentParentPickerLeft + 'px';
        
          var myInterval = setInterval(() => {
            var vPicker = this.$refs[ref].$el;
            var parentPicker = vPicker.parentElement;
            var isPickerVisible = parentPicker.style.display != 'none';

            if (!isPickerVisible) {
              var currentParentPickerLeft = parentPicker.style.left.replace('px', '');
              var correctionCurrentParentPickerLeft = parseInt(currentParentPickerLeft) + 350;
              parentPicker.style.left = correctionCurrentParentPickerLeft + 'px';
              clearInterval(myInterval);
              return;
            }
          }, 100);
        }
      }, 5e2)
    },
    initEditData(book_id) {
      if (!isUndefined(book_id)) {
        if (this.isLoadingAssetGroups) {
          setTimeout(() => {
            this.initEditData(book_id); 
          }, 1e3);
          return;
        }
        const payload = {
          id: book_id
        };
        if (this.isIntimap || this.isWSP) {
          payload.use_timezone_depot = 1;
        }
        this.$store
          .dispatch("API_CALL", {
            $method: "get_book_by_id",
            $postData: payload
          })
          .then(response => {
            this.overlay = false;
            this.dataEdit = response.data.data;
            if (this.dataEdit.recurring == 1) {
              const currentTimezoneDate = moment(this.timezoneDate);
              const isPastDate = moment(this.dataEdit.start_datetime).isBefore(currentTimezoneDate);
              if (isPastDate) {
                for (let i = 0; i < this.dataEdit.booking_recurring.length; i++) {
                  const recurringDate = moment(this.dataEdit.booking_recurring[i].start_datetime);
                  if (recurringDate.isAfter(currentTimezoneDate)) {
                    this.dataEdit = this.dataEdit.booking_recurring[i];
                    break;
                  }
                }
              }
            }
            if (!isEmpty(this.dataEdit) || !isNull(this.dataEdit)) {
              let metadata = JSON.parse(this.dataEdit.metadata);
              let book_detail_edit = get(metadata, "booking_detail", "");
              let costCode = get(metadata, "cost_code", "");
              let workOrder = get(metadata, "work_order", "");
              let purposeOfTrip = get(metadata, "purpose_of_trip", "");
              let isFBT = get(metadata, "fbt", 0);
              let fbtSelectedDates = get(metadata, "fbt_selected_dates", []);
              let originalEndTime = get(metadata, "original_end_time", "");
              let secondWorkOrder = get(metadata, "second_work_order", "");
              let startTimeSecondOrder = get(metadata, "start_second_work_order", "");
              let endTimeSecondOrder = get(metadata, "end_second_work_order", "");
              let passengerList = get(metadata, "passenger_list", []);
              if (typeof passengerList === "string") {
                try {
                  passengerList = JSON.parse(passengerList);
                } catch (e) {
                  passengerList = [];
                }
              }
              let clientName = get(metadata, "client_name", "");
              let recurring_info = get(metadata, "recurring_info", []);
              this.selectedVariousLocation = get(metadata, "various_location", "");
              if (this.hasStructuredVariousDestination) {
                this.variousDestinationList = get(metadata, "various_destination", []);
              } else {
                this.variousDestination = get(metadata, "various_destination", "");
              }
              if (!isEmpty(book_detail_edit)) {
                this.handleSearchDestination(metadata.address, this).then(() => {
                  this.costCode = costCode;
                  this.workOrder = {
                    code: workOrder,
                    description: workOrder
                  };
                  this.workOrders.push({
                    code: workOrder,
                    description: workOrder
                  });
                  this.purposeOfTrip = purposeOfTrip;
                  this.passengerList = passengerList;
                  if (originalEndTime) {
                    this.isSecondWorkOrder = true;
                    this.workOrder2 = {
                      code: secondWorkOrder,
                      description: secondWorkOrder
                    };
                    this.dataEdit.end_datetime = originalEndTime;
                    this.create_start_time2 = startTimeSecondOrder;
                    this.create_end_time2 = endTimeSecondOrder;
                  }
                  this.clientName = clientName;
                  this.selectedAssetType = this.assetTypes.find(
                    a => a.id === book_detail_edit.asset_type
                  );
                  this.selectedVehicleGroup = this.vehicleGroupsUsersAdmin.find(
                    a => a.id === book_detail_edit.group_id
                  );
                  this.selectedVehicleGroup.group_id = this.selectedVehicleGroup.id;
                  this.selectedVehicleGroup.group_name = this.selectedVehicleGroup.name;

                  this.isFirstEdit = true;
                  let isRecurring = false;

                  if (!isEmpty(recurring_info)) {
                    isRecurring = true;
                    this.booking.recurring = recurring_info.crontab;
                    if (recurring_info.hasOwnProperty("end_after")) {
                      this.radios = "endAfter";
                      this.booking.recurring_end = recurring_info.end_after;
                    } else {
                      this.radios = "endBy";
                      this.booking.recurring_endBy = recurring_info.end_by;
                    }
                  } else {
                    isRecurring = false;
                  }
                  this.origin_id = this.dataEdit.start_geofence_id;
                  this.optionPassengerCount = parseInt(
                    this.dataEdit.book_user.passenger_count
                  );
                  this.dateToday = moment(this.dataEdit.start_datetime).format(
                    "YYYY-MM-DD"
                  );
                  if (!this.hasStructuredVariousDestination || !this.variousDestinationList.length) {
                    let filterPop = this.dataPopular.find(
                      a => a.address === metadata.address
                    );
                    if (!isUndefined(filterPop) && !isEmpty(filterPop)) {
                      this.selectedPopId = filterPop.id;
                    } else {
                      let addressData = null;
                      if (metadata.address_id) {
                        addressData = this.destination.locations.find(
                          a => parseInt(a.id) === parseInt(metadata.address_id)
                        );
                      } else {
                        addressData = this.destination.locations.find(
                          a => a.address.includes(metadata.address)
                        );
                      }
                      if (addressData) {
                        this.destination.selected = addressData;
                        this.destination.search = metadata.address;
                      } else {
                        this.destination.search = metadata.address;
                        this.destination.selected = {address: metadata.address, latitude: null, longitude: null};
                        this.destination.locations.push({address: metadata.address, latitude: null, longitude: null})
                      }
                    }
                  }
                  let datetime = moment(this.dataEdit.start_datetime).format(
                    "YYYY-MM-DD HH:mm"
                  );
                  let date = moment(this.dataEdit.start_datetime).format(
                    "YYYY-MM-DD"
                  );
                  let endDate = moment(this.dataEdit.end_datetime).format(
                    "YYYY-MM-DD"
                  );
                  let time = moment(this.dataEdit.start_datetime).format("HH:mm");
                  let parse = {
                    day: parseInt(moment(date).format("D")),
                    hour: parseInt(moment(datetime).format("H")),
                    minute: parseInt(
                      moment(this.dataEdit.start_datetime).minute()
                    ),
                    month: parseInt(moment(date).format("MM")),
                    year: parseInt(moment(date).format("YYYY"))
                  };
                  if (
                    !isEmpty(this.origin_id) &&
                    !isEmpty(this.selectedVehicleGroup)
                  ) {
                    this.paramDraw = {
                      description: 'from_api',
                      category: this.dataEdit.vehicle_id,
                      date: date,
                      end_date: endDate,
                      day: parse.day,
                      hour: parse.hour,
                      minute: parse.minute,
                      month: parse.month,
                      time: time,
                      year: parse.year
                    };

                    this.busyMouse = true;

                    this.$nextTick(() => {
                      this.handleClickSearch();
                      this.$vuetify.goTo(750);
                      setTimeout(() => {
                        const loadEditedCalendar = () => {
                          const filter = this.books.find(book => this.paramDraw.date === book.date);
                          if (isUndefined(filter) && this.dataEdit) {
                            return setTimeout(() => {
                              loadEditedCalendar();
                            }, 1e3);
                          }

                          let prevSchedule = null;
                          let nextSchedule = null;
                          let timeRange = [];

                          const vehicleId = this.dataEdit.vehicle_id;
                          const startTime = moment(this.dataEdit.start_datetime);
                          const endTime = moment(this.dataEdit.end_datetime);
                          const currentDate = this.paramDraw.date;
                          const now = moment(this.timezoneDate);

                          const prevBooks = this.books.filter(function (book) {
                            return book.schedules.some(function (schedule) {
                              const end = moment(book.date + ' ' + schedule.end);
                              return (
                                end.isSameOrBefore(startTime) &&
                                schedule.detail &&
                                schedule.detail.vehicle_id == vehicleId
                              );
                            });
                          });

                          if (prevBooks.length) {
                            const lastBook = prevBooks[prevBooks.length - 1];
                            let selected = null;
                            let shortestDiff = Infinity;

                            for (let i = 0; i < lastBook.schedules.length; i++) {
                              const schedule = lastBook.schedules[i];
                              const end = moment(lastBook.date + ' ' + schedule.end);
                              if (
                                end.isSameOrBefore(startTime) &&
                                schedule.detail &&
                                schedule.detail.vehicle_id == vehicleId
                              ) {
                                const diff = startTime.diff(moment(schedule.detail.end_datetime));
                                if (diff >= 0 && diff < shortestDiff) {
                                  selected = schedule;
                                  shortestDiff = diff;
                                }
                              }
                            }

                            if (selected) {
                              prevSchedule = selected;
                              if (moment(prevSchedule.end, 'YYYY-MM-DD') != currentDate) {
                                timeRange[0] = 0
                              } else {
                                timeRange[0] = moment(prevSchedule.end, 'HH:mm').hour()
                              }
                            }
                          }

                          const nextBooks = this.books.filter(function (book) {
                            return book.schedules.some(function (schedule) {
                              const start = moment(book.date + ' ' + schedule.start);
                              return (
                                start.isAfter(endTime) &&
                                schedule.detail &&
                                schedule.detail.vehicle_id == vehicleId
                              );
                            });
                          });

                          if (nextBooks.length) {
                            const lastBook = nextBooks[nextBooks.length - 1];
                            let selected = null;
                            let shortestDiff = Infinity;

                            for (let i = 0; i < lastBook.schedules.length; i++) {
                              const schedule = lastBook.schedules[i];
                              const start = moment(lastBook.date + ' ' + schedule.start);
                              if (
                                start.isAfter(endTime) &&
                                schedule.detail &&
                                schedule.detail.vehicle_id == vehicleId
                              ) {
                                const diff = moment(schedule.detail.start_datetime).diff(endTime);
                                if (diff >= 0 && diff < shortestDiff) {
                                  selected = schedule;
                                  shortestDiff = diff;
                                }
                              }
                            }

                            if (selected) {
                              nextSchedule = selected;
                              if (moment(nextSchedule.start, 'YYYY-MM-DD') != currentDate) {
                                timeRange[1] = 23;
                              } else {
                                timeRange[1] = moment(nextSchedule.start, 'HH:mm').hour();
                              }
                            }
                          }

                          if (!timeRange.length) {
                            timeRange = [0, 23];
                          } else {
                            // Fill in only the bound no neighbouring booking
                            // supplied. The old `timeRange[0] = 0` ran whenever
                            // an upper bound existed, which threw away the lower
                            // bound the previous booking had just set and let the
                            // start be dragged back over that booking.
                            if (typeof timeRange[0] == 'undefined') timeRange[0] = 0;
                            if (typeof timeRange[1] == 'undefined') timeRange[1] = 23;
                          }

                          if (now.isSame(currentDate, 'day')) {
                            const currentHour = now.hour();
                            if (timeRange[0] < currentHour) {
                              timeRange[0] = currentHour;
                            }
                          }

                          this.startTime(this.paramDraw, timeRange);
                          setTimeout(() => {
                            this.endEventSelected({ day: { date } }, false);
                            this.$nextTick(() => {
                              const eventElements = this.$refs.calendars.$el.getElementsByClassName(
                                "v-event-timed"
                              );
                              eventElements.forEach(element => {
                                if (element.classList.contains("grey")) {
                                  element.click();
                                  setTimeout(() => {
                                    this.busyMouse = false;
                                    this.isRecurring = isRecurring;
                                    this.isFBT = isFBT == 1 || isFBT == '1' || isFBT == 'true' || isFBT == true ? true : false;
                                    this.fbtSelectedDates = fbtSelectedDates;
                                  }, 1e3);
                                }
                              });
                            });
                          }, 1e3);
                        }
                        loadEditedCalendar();
                      }, 1e3);
                    });
                  }
                });
              }
            }
          });
      }
    },
    getValueAsBoolean(value) {
      return value == 1 || value == '1' || value == 'true' || value == true ? 1 : 0;
    },
    listenStartTime() {
      clearTimeout(this.listenStartTimeTimeout);
      this.listenStartTimeTimeout = setTimeout(() => {
        this.listenStartTimeHandling();
      }, 100);
    },
    listenStartTimeHandling() {
      this.saveDisabled = false;
      
      // Reset FBT selected dates when booking dates change (only if not in edit mode)
      if (this.isFBT && !this.isFirstEdit) {
        this.fbtSelectedDates = [];
        this.checkAllFbt = false;
        this.isFBT = false;
      }
      
      let startSelectedDate = `${this.booking.date} ${this.create_start_time} `;
      const endSelectedDate = `${this.booking.end_date} ${this.create_end_time}`;

      if( this.create_end_time == "Invalid date" || 
          this.create_start_time == "Invalid date" ) {
        this.saveDisabled = true;
        this.handleClickBack(true);
      } else if (isEmpty(this.create_end_time) || isEmpty(this.create_start_time)) {
        this.saveDisabled = true;
      } else if (typeof this.create_end_time == "object") {
        if (this.create_end_time.includes("mm") || this.create_end_time.includes("HH")) {
          this.saveDisabled = true;
        }
      }

      const currentBook = this.books.find(book => book.date == this.selectedEvent.date);

      let isError = false;

      if (!currentBook) return;
      if (!currentBook.schedules) return;

      for (let i = 0; i < currentBook.schedules.length; i += 1) {
        const schedule = currentBook.schedules[i];
        const assetId = schedule.detail.vehicle_id ? schedule.detail.vehicle_id : schedule.detail.asset_id;
        const isSameVehicle = parseInt(assetId) == parseInt(this.selectedEvent.category);
        if (isSameVehicle) {
          let calStart = moment(`${this.selectedEvent.date} ${schedule.start}`).valueOf();
          let calEnd = moment(`${this.selectedEvent.date} ${schedule.end}`).valueOf();
          let userStart = moment(startSelectedDate).valueOf();
          let userEnd = moment(endSelectedDate).valueOf();

          if (isEmpty(this.dataEdit)) {
            if (calStart < userEnd && calEnd > userStart) {
              isError = true;
              break;
            }
          }
        }
      }

      if (isError && this.selectedOpen) {
        if (this.last_create_start_time) this.create_start_time = this.last_create_start_time;
        if (this.last_create_end_time) this.create_end_time = this.last_create_end_time;

        this.$swal({
          icon: "error",
          title: "Not Allowed",
          text: "Vehicle has been booked at this time"
        }).then(() => {
          this.last_create_start_time = "";
          this.last_create_end_time = "";
          this.handleClickBack(true);
        });

        return;
      }

      const selectedDateTime = `${this.booking.date} ${
        this.create_start_time
      }`;
      const selectedDate = `${this.booking.date}`;
      const endselectedDateTime = `${this.booking.end_date} ${
        this.create_end_time
      }`;
      const endselectedDate = `${this.booking.end_date}`;
      let parse = {
        day: parseInt(moment(selectedDate).format("D")),
        hour: parseInt(moment(selectedDateTime).format("H")),
        minute: parseInt(moment(selectedDateTime).minute()),
        month: parseInt(moment(selectedDate).format("MM")),
        year: parseInt(moment(selectedDate).format("YYYY"))
      };
      let starttoTime = new Date(
        parse.year,
        parse.month - 1,
        parse.day,
        parse.hour,
        parse.minute
      ).getTime();
      let parseEnd = {
        day: parseInt(moment(endselectedDate).format("D")),
        hour: parseInt(moment(endselectedDateTime).format("H")),
        minute: parseInt(moment(endselectedDateTime).minute()),
        month: parseInt(moment(endselectedDate).format("MM")),
        year: parseInt(moment(endselectedDate).format("YYYY"))
      };
      let endtoTime = new Date(
        parseEnd.year,
        parseEnd.month - 1,
        parseEnd.day,
        parseEnd.hour,
        parseEnd.minute
      ).getTime();
      this.start_time = this.create_start_time;
      this.end_time = this.create_end_time;
      this.selectedEvent.start = starttoTime;
      this.selectedEvent.end = endtoTime;
      this.selectedEvent.details.start = this.start_time;
      this.selectedEvent.details.end = this.end_time;

      if (!this.dragEvent) {
        this.timeoutDrag = setTimeout(() => {
          this.validateTime();
        }, 100);
      }
    },
    handleDay(date) {
      if (date == null) return;
      const dateFormatted = moment(date).format("D MMM YYYY");
      return dateFormatted;
    },
    inWorkingDay(dateBooking) {
      let formattedDay = moment(dateBooking).format("d");
      if (!this.userWorkingDay) return false;
      const userWorkingDay = typeof this.userWorkingDay.includes === "function" ? this.userWorkingDay : [];
      return userWorkingDay.includes(parseInt(formattedDay));
    },
    isWithinWorkingTime(
      workingStartTime,
      workingEndTime,
      user_booking_start,
      user_booking_end
    ) {
      let bookingStart = moment(user_booking_start).format("HH:mm");
      let bookingEnd = moment(user_booking_end).format("HH:mm");
      workingStartTime = moment(workingStartTime, "HH:mm");
      workingEndTime = moment(workingEndTime, "HH:mm");
      bookingStart = moment(bookingStart, "HH:mm");
      bookingEnd = moment(bookingEnd, "HH:mm");
      
      if ((this.booking.date != this.booking.end_date) && workingEndTime) return false; 

      return (
        bookingStart.isSameOrAfter(workingStartTime) &&
        bookingEnd.isSameOrBefore(workingEndTime)
      );
    },
    handleColorInfo(event) {
      let name = "";
      if (event.color == "warning") {
        name = "Waiting For Approval";
      } else if (event.color == "green") {
        name = "My Booking";
      } else if (event.color == "blue") {
        name = "Ride Sharing (Rider)";
      } else if (event.color == "cyan") {
        name = "Ride Sharing (Owner)";
      } else if (event.color == "light-green") {
        name = "Other User Booking";
      }
      return name;
    },
    handleDeviceName(item) {
      const keyword = this.isVehicle ? "name" : "number";
      let name = get(item, keyword, "");
      if (isEmpty(name)) {
        let vehicleMetadata = get(item, 'vehicle_metadata', '');
        if (typeof vehicleMetadata === 'string') {
          try {
            vehicleMetadata = JSON.parse(vehicleMetadata);
          } catch (e) {
            vehicleMetadata = {};
          }
        }
        if (vehicleMetadata && vehicleMetadata.hasOwnProperty('device_name')) {
          name = vehicleMetadata.device_name;
        } else {
          name = "";
        }
      }
      return name;
    },
    handleDeviceModel(item) {
      let name = ''
      let vehicleMetadata = get(item, 'vehicle_metadata', '');
      if (typeof vehicleMetadata === 'string') {
        try {
          vehicleMetadata = JSON.parse(vehicleMetadata);
        } catch (e) {
          vehicleMetadata = {};
        }
      }
      if (vehicleMetadata && vehicleMetadata.hasOwnProperty('device_model')) {
        name = vehicleMetadata.device_model;
      } else {
        name = "";
      }
      if (isEmpty(name)) {
        name = get(item, "device_model", "");
        name = name.replace(/[^\w\s]/gi, "");
      }
      return name;
    },
    handleDeviceMake(item) {
      let name = ''
      let vehicleMetadata = get(item, 'vehicle_metadata', '');
      if (typeof vehicleMetadata === 'string') {
        try {
          vehicleMetadata = JSON.parse(vehicleMetadata);
        } catch (e) {
          vehicleMetadata = {};
        }
      }
      if (vehicleMetadata && vehicleMetadata.hasOwnProperty('device_make')) {
        name = vehicleMetadata.device_make;
      } else {
        name = "";
      }
      if (isEmpty(name)) {
        name = get(item, "device_make", "");
      }
      return name;
    },
    updateListAssetGroup() {
      if (!this.isVehicle) {
        if (this.vehicleGroups.length) {
          this.selectedVehicleGroup = this.vehicleGroups[0];
        } else {
          this.selectedVehicleGroup = "";
        }
        this.clearSelected();
      } else {
        this.selectedVehicleGroup = "";
      }
      this.calendar.loading = false;
      this.heightCalendar = 0;
      this.isShowCalendar = false;
      this.$vuetify.goTo(0);
    },
    setAlertState(type, text, state = false) {
      this.alertType = type;
      this.alertText = text;
      this.alertState = state;
      setTimeout(() => {
        this.alertState = false;
      }, 5e3);
    },
    moreVehicle(day, date) {
      this.categoryDays = 1;
      this.categories = this.categoriesAll;
      this.focus = date;
      this.isMore = false;
      this.isBack = true;
      this.calendarComponent = null;
      this.$nextTick(() => {
        this.calendarComponent = 'v-calendar';
      });
      this.filteredEvents = this.events.filter((event) => {
        if (this.isMore) {
          return this.categoriesFour.includes(event.category);
        }
        return true;
      });
      this.createBlockCode();
    },
    // eslint-disable-next-line no-unused-vars
    defaultCalendar(day, date) {
      this.$nextTick(() => {
        if (this.selectedView.value === 'day') {
          this.categoryDays = 1;
        } else {
          this.isMore = true;
          this.isBack = false;
          this.focus = this.calendar.start;
          this.categoryDays = 7;
          this.categories = this.categoriesFour;
        }
        if (isEmpty(this.dataEdit)) this.handleClickBack(true);
      });
    },
    getUrl(method) {
      return `${process.env.VUE_APP_API_URL}/${method}`;
    },
    getAssetTypes() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_asset_types",
          $postData: {
            booking: 1,
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.assetTypes = response.data.data;
          if (this.assetTypes.length == 1) {
            this.selectedAssetType = this.assetTypes[0];
          }
        });
    },
    getDataAssets() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_assets",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.dataAssets = response.data.data;
        });
    },
    getDataWorkOrder() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_work_order",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.workOrders = response.data.data;
        });
    },
    clearSelected() {
      this.popDisabled = false;
      this.selectedPopId = "";
      this.destDisabled = false;
      this.varDisabled = false;
      this.selectedPopularData = "";
    },
    getDataPopular() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_popular_addresses",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.dataPopular = response.data.data;
        });
    },
    getDataVehicleGroups() {
      if (this.isLoadingAssetGroups) return;
      this.isLoadingAssetGroups = true;
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_asset_groups_booking",
          $postData: {
            clientid: this.$store.state.clientid,
            show_detail: 0
          }
        })
        .then(response => {
          this.dataVehicleGroups = response.data.data;
          this.isLoadingAssetGroups = false;
        });
    },
    getDataVehicleAccessories() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_vehicle_accessory",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.dataVehicleAccessories = response.data.data;
        });
    },
    getDataUsers() {
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_all",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          const responseData = get(response, "data.data", []);
          this.dataAllUsers = responseData;
          this.dataAllUser = this.dataAllUsers.filter((user) => {
            const isNotSameUser = user.id != this.user.id;
            const isNotAdminForUser = this.isAdmin ? true : user.type == 2;
            return isNotSameUser && isNotAdminForUser;
          });
        });
    },
    getDataVehicleGroupsUser() {
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_asset_groups_user",
          $postData: {
            user_id: this.user.id
          }
        })
        .then(response => {
          this.dataVehicleGroupsUser = response.data.data;
        });
    },
    getTimezoneDepot(id) {
      const origin = this.getOrigin.find(o => o.Id.toString() == id.toString());
      if (origin) {
        const timezone = get(origin, 'metadata.timezone', {});
        if (timezone.hasOwnProperty('timeZoneId')) {
          const originTimezone = this.timezones.find(tz => {
            if (typeof tz.type == 'string') {
              return tz.type == timezone.timeZoneId;
            } else if (typeof tz.type == 'object') {
              return tz.type.includes(timezone.timeZoneId);
            }
          });
          if (originTimezone) return originTimezone.name;
        }
      }
      return null;
    },
    getVehicleServices(start_date = null, end_date = null) {
      const payload = {
        clientid: this.$store.state.clientid,
        start_date,
        end_date
      };
      if (this.isIntimap || this.isWSP) {
        const timezone = this.getTimezoneDepot(this.origin_id);
        if (timezone) {
          payload.timezone = timezone;
        }
      }
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_vehicle_services",
          $postData: payload
        })
        .then(response => {
          this.vehicleServices = response.data.data;
        });
    },
    endEventSelected(e, showEvent = true) {
      if (e.hasOwnProperty('eventParsed')) {
        const diff = moment(
          `${e.eventParsed.end.date} ${e.eventParsed.end.time}`
        ).diff(
          `${e.eventParsed.start.date} ${e.eventParsed.start.time}`,
          "hours"
        );
        if ((diff > 24 || e.eventParsed.end.date !== e.eventParsed.start.date) && !this.isOvernightBooking) {
          this.$swal({
            icon: "error",
            title: "Not Allowed",
            text:
              "Cannot create book for more than 1 day, Please use Recurring booking or make multiple booking"
          });
          this.handleClickBack(true);
        } else {
          const eventElements = this.$refs.calendars.$el.getElementsByClassName(
            "v-event-timed"
          );
          if (this.isOvernightBooking && (e.eventParsed.end.date != e.eventParsed.start.date)) {
            this.booking.end_date = e.eventParsed.end.date;
          }
          eventElements.forEach(element => {
            const style = window.getComputedStyle(element);
            const backgroundColor = style.backgroundColor;
            if (element.classList.contains("grey") || backgroundColor == 'rgba(0, 0, 0, 0.7)') {
              element.click();
            }
          });

        }
      } else {
        this.booking.date = e.day.date;
        if (!isEmpty(this.dataEdit)) {
          if (!this.isInitDataEdit) {
            this.isInitDataEdit = true;
            const end_date = moment(this.dataEdit.end_datetime).format("YYYY-MM-DD");
            if (this.booking.date != end_date) {
              this.booking.end_date = end_date;
            }
          }
        }
        this.dragEvent = null;
        this.createEvent = null;
        this.createStart = null;
        this.createEnd = null;
        this.extendOriginal = null;
        if (e && showEvent) this.showEvent(e);
      }
    },
    getCategory(category) {
      const vehInfo = this.getVehicles.find(vehicle => vehicle.id === category);
      let showCat = `${vehInfo.device_make} - ${vehInfo.device_plate}`;
      return showCat;
    },
    showEvent({ nativeEvent, event, eventParsed }) {
      if (event.color == "blue") {
        this.dialog.open = true;
        this.dialog.color = event.color;
        this.dialog.data = event.details;
        this.selectedOpen = false;

        if (this.isVehicle) {
          this.page = "booking";
          let metadata = {};
          let vehicle_seat = "";
          const vehInfo = this.getVehicles.find(
            vehicle => vehicle.id === this.dialog.data.detail.vehicle_id
          );
          metadata = vehInfo.metadata;
          if (metadata.hasOwnProperty("seat_count")) {
            let parse_count = metadata.seat_count;
            if (!isEmpty(parse_count)) {
              vehicle_seat = parseInt(metadata.seat_count);
            } else {
              vehicle_seat = 5;
            }
          }
          const passengers = [];
          this.dialog.data.detail.passenger.forEach((passenger, i) => {
            passengers.push(parseInt(passenger.passenger_count));
          });
          let sumPassenger = sum(passengers);
          this.availableSeat = vehicle_seat - sumPassenger;
          if (this.availableSeat > 0) {
            let array = [];
            for (let i = 1; i <= this.availableSeat; i++) {
              array.push(i);
            }
            this.optionsSharePassenger = array;
          } else {
            this.disableShareRide = true;
          }
        }
      } else if (event.color == "green") {
        this.dialog.color = event.color;
        this.dialog.open = true;
        this.dialog.data = event.details;
        this.selectedOpen = false;

        if (this.isVehicle) {
          this.page = "booking";
          let metadata = {};
          let vehicle_seat = "";
          const vehInfo = this.getVehicles.find(
            vehicle => vehicle.id === this.dialog.data.detail.vehicle_id
          );
          metadata = vehInfo.metadata;
          if (metadata.hasOwnProperty("seat_count")) {
            let parse_count = metadata.seat_count;
            if (!isEmpty(parse_count)) {
              vehicle_seat = parseInt(metadata.seat_count);
            } else {
              vehicle_seat = 5;
            }
          }
          const passengers = [];
          // eslint-disable-next-line no-unused-vars
          this.dialog.data.detail.passenger.forEach((passenger, i) => {
            passengers.push(parseInt(passenger.passenger_count));
          });
          let sumPassenger = sum(passengers);
          this.availableSeat = vehicle_seat - sumPassenger;
          if (this.availableSeat > 0) {
            let array = [];
            for (let i = 1; i <= this.availableSeat; i++) {
              array.push(i);
            }
            this.optionsSharePassenger = array;
          } else {
            this.disableShareRide = true;
          }
        }
      } else if (event.color == "warning") {
        this.dialog.color = event.color;
        this.dialog.open = true;
        this.dialog.data = event.details;

        this.selectedOpen = false;

        if (this.isVehicle) {
          this.page = "booking";
          let metadata = {};
          let vehicle_seat = "";
          const vehInfo = this.getVehicles.find(
            vehicle => vehicle.id === this.dialog.data.detail.vehicle_id
          );
          metadata = vehInfo.metadata;
          if (metadata.hasOwnProperty("seat_count")) {
            let parse_count = parseInt(metadata.seat_count);
            if (!isEmpty(parse_count)) {
              vehicle_seat = parseInt(metadata.seat_count);
            } else {
              vehicle_seat = 5;
            }
          }
          const passengers = [];
          // eslint-disable-next-line no-unused-vars
          this.dialog.data.detail.passenger.forEach((passenger, i) => {
            passengers.push(parseInt(passenger.passenger_count));
          });
          let sumPassenger = sum(passengers);
          this.availableSeat = vehicle_seat - sumPassenger;
          if (this.availableSeat > 0) {
            let array = [];
            for (let i = 1; i <= this.availableSeat; i++) {
              array.push(i);
            }
            this.optionsSharePassenger = array;
          } else {
            this.disableShareRide = true;
          }
        }
      } else if (event.color == "cyan") {
        this.dialog.open = true;
        this.dialog.color = event.color;
        this.dialog.data = event.details;
        this.selectedOpen = false;

        if (this.isVehicle) {
          this.page = "booking";
          let metadata = {};
          let vehicle_seat = "";
          const vehInfo = this.getVehicles.find(
            vehicle => vehicle.id === this.dialog.data.detail.vehicle_id
          );
          metadata = vehInfo.metadata;
          if (metadata.hasOwnProperty("seat_count")) {
            let parse_count = metadata.seat_count;
            if (!isEmpty(parse_count)) {
              vehicle_seat = parseInt(metadata.seat_count);
            } else {
              vehicle_seat = 5;
            }
          }
          const passengers = [];
          // eslint-disable-next-line no-unused-vars
          this.dialog.data.detail.passenger.forEach((passenger, i) => {
            passengers.push(parseInt(passenger.passenger_count));
          });
          let sumPassenger = sum(passengers);
          this.availableSeat = vehicle_seat - sumPassenger;
          if (this.availableSeat > 0) {
            let array = [];
            for (let i = 1; i <= this.availableSeat; i++) {
              array.push(i);
            }
            this.optionsSharePassenger = array;
          } else {
            this.disableShareRide = true;
          }
        }
      } else if (event.color == "light-green") {
        this.dialog.open = true;
        this.dialog.color = event.color;
        this.dialog.data = event.details;
        this.selectedOpen = false;

        if (this.isVehicle) {
          this.page = "booking";
          let metadata = {};
          let vehicle_seat = "";
          const vehInfo = this.getVehicles.find(
            vehicle => vehicle.id === this.dialog.data.detail.vehicle_id
          );
          metadata = vehInfo.metadata;
          if (metadata.hasOwnProperty("seat_count")) {
            let parse_count = metadata.seat_count;
            if (!isEmpty(parse_count)) {
              vehicle_seat = parseInt(metadata.seat_count);
            } else {
              vehicle_seat = 5;
            }
          }
          const passengers = [];
          // eslint-disable-next-line no-unused-vars
          this.dialog.data.detail.passenger.forEach((passenger, i) => {
            passengers.push(parseInt(passenger.passenger_count));
          });
          let sumPassenger = sum(passengers);
          this.availableSeat = vehicle_seat - sumPassenger;
          if (this.availableSeat > 0) {
            let array = [];
            for (let i = 1; i <= this.availableSeat; i++) {
              array.push(i);
            }
            this.optionsSharePassenger = array;
          } else {
            this.disableShareRide = true;
          }
        }
      } else if (event.color == "purple") {
        this.dialog.color = event.color;
        this.dialog.open = true;
        this.dialog.data = event.details;
        this.selectedOpen = false;
      } else if (event.color == "pink") {
        this.dialog.color = event.color;
        this.dialog.open = true;
        this.dialog.data = event.details;
        this.selectedOpen = false;
      } else if (event.color == "#914f07") {
        this.dialog.color = event.color;
        this.dialog.open = true;
        this.dialog.data = event.details;
        this.selectedOpen = false;
      } else {
        const open = () => {
          event.date = eventParsed.start.date;

          this.selectedEvent = event;
          this.selectedElement = nativeEvent.target;

          this.isRecurring = false;

          setTimeout(() => {
            let isError = false;
            const currentBook = this.books.find(book => book.date == this.selectedEvent.date);

            const startSelectedDate = `${this.selectedEvent.date} ${this.create_start_time}`;
            const endSelectedDate = `${this.selectedEvent.date} ${this.create_end_time}`

            for (let i = 0; i < currentBook.schedules.length; i += 1) {
              const schedule = currentBook.schedules[i];
              const assetId = schedule.detail.vehicle_id ? schedule.detail.vehicle_id : schedule.detail.asset_id;
              const isSameVehicle = parseInt(assetId) == parseInt(this.selectedEvent.category);
              if (isSameVehicle) {
                let calStart = moment(`${this.selectedEvent.date} ${schedule.start}`).valueOf();
                let calEnd = moment(`${this.selectedEvent.date} ${schedule.end}`).valueOf();
                let userStart = moment(startSelectedDate).valueOf();
                let userEnd = moment(endSelectedDate).valueOf();

                if (isEmpty(this.dataEdit)) {
                  if (calStart < userEnd && calEnd > userStart) {
                    isError = true;
                    break;
                  }
                }
              }
            }

            if (isError) {
              if (this.last_create_start_time) this.create_start_time = this.last_create_start_time;
              if (this.last_create_end_time) this.create_end_time = this.last_create_end_time;

              this.$swal({
                icon: "error",
                title: "Not Allowed",
                text: "Vehicle has been booked at this time"
              });

              this.last_create_start_time = "";
              this.last_create_end_time = "";

              this.handleClickBack(true);

              return;
            }

            this.selectedOpen = true;
          }, 10);
        };

        if (this.selectedOpen) {
          this.selectedOpen = false;
          setTimeout(open, 10);
        } else {
          open();
        }
      }

      nativeEvent.stopPropagation();
    },
    startDrag({ event, timed }) {
      clearTimeout(this.timeoutDrag);

      if (event.hasOwnProperty("id")) {
        this.keepSilent = true;
        this.handleSilent = setTimeout(() => {
          this.keepSilent = false;
        }, 1e3);
        return;
      }

      if (event && timed) {
        this.dragEvent = event;
        this.dragTime = null;
        this.extendOriginal = null;
      }
    },
    startTime(tms, timeRange = null) {
      if (this.busyMouse && !tms.hasOwnProperty('description')) return;

      this.isPickPastTime = false;

      const mouse = this.toTime(tms);
      let filter = this.books.find(book => tms.date === book.date);
      let avail = false;
      let filterService = null;
      if (!isUndefined(filter)) {
        if (!isEmpty(filter.header.available)) {
          avail = true;
          filterService = filter.header.available.filter(
            veh => veh.is_service === true
          );
        } else {
          avail = false;
        }
      }

      let nowDate = moment().subtract(15, 'minutes');
      nowDate = moment(nowDate).toDate().getTime();

      let mouseDate = moment(this.roundTime(mouse))
      mouseDate = moment(mouseDate).toDate().getTime();

      const vehicle = this.getVehicles.find(
        vehicle => vehicle.id === tms.category
      );
      const workingTime = this.getWorkingTime(vehicle, "metadata.working_time");
      const startWorkingTime = get(workingTime, "start", "");
      const endWorkingTime = get(workingTime, "end", "");

      if ((nowDate <= mouseDate) || !isEmpty(this.dataEdit)) {
        if (avail && isEmpty(filterService)) {
          if (this.dragEvent && this.dragTime === null) {
            const start = this.dragEvent.start;
            this.dragTime = mouse - start;
          } else {
            if (this.keepSilent) return;
            this.createStart = this.roundTime(mouse);
            const mouseRounded = this.roundTime(mouse, false);
            const min = Math.min(mouseRounded, this.createStart);
            let max = Math.max(mouseRounded, this.createStart);
            this.createEnd = max;

            if (min === max) {
              max = moment(min).add(30, 'minutes').valueOf();
            }
            
            const detail_start = moment(min).format("HH:mm");
            const range_start = moment(min).format("HH");
            const detail_end = moment(max).format("HH:mm");

            if ((startWorkingTime && startWorkingTime != '') && (endWorkingTime && endWorkingTime != '')) {
              const startWorking = moment(startWorkingTime, 'HH:mm').format('HH');
              const endWorking = moment(endWorkingTime, 'HH:mm').format('HH');
              this.time_range = [parseInt(startWorking), parseInt(endWorking)];
              this.time_range_end = [parseInt(startWorking), parseInt(endWorking)];
            } else if (timeRange) {
              this.time_range = timeRange;
              this.time_range_end = timeRange;
            } else {
              this.time_range = [parseInt(range_start), 23];
              this.time_range_end = [parseInt(range_start), 23];
              if (this.booking.hasOwnProperty('end_date')) {
                if (this.booking.date != this.booking.end_date) {
                  this.time_range_end = [0, 23];
                }
              }
            }
            if (!isEmpty(filter.schedules)) {
              const distance = filter.schedules.reduce((arr, val) => {
                if (val.type == 'done') {
                  if (val.hasOwnProperty('distance')) arr += parseInt(val.distance);
                }
                return arr;
              }, 0);
              if (this.isElectricVehicle && distance >= 100) {
                this.$swal({
                  icon: "error",
                  title: "Over Limit",
                  text: "This EV cannot be booked as it exceeds the daily 100KM limit. Please choose another vehicle or try booking on a different day."
                });
              }
              filter.schedules.forEach(fil => {
                let calStart = moment(`${tms.date} ${fil.start}`).valueOf();
                let calEnd = moment(`${tms.hasOwnProperty('end_date') ? tms.end_date : tms.date} ${fil.end}`).valueOf();
                let userStart = moment(
                  `${tms.hasOwnProperty('end_date') ? tms.end_date : tms.date} ${detail_start}`
                ).valueOf();
                let userEnd = moment(`${tms.hasOwnProperty('end_date') ? tms.end_date : tms.date} ${detail_end}`).valueOf();
                if (!isEmpty(this.dataEdit)) {
                  const assetId = fil.detail.vehicle_id ? fil.detail.vehicle_id : fil.detail.asset_id;
                  const scheduleStart = fil.detail.start_datetime;
                  const scheduleEnd = fil.detail.end_datetime;
                  calStart = moment(scheduleStart).valueOf();
                  calEnd = moment(scheduleEnd).valueOf();

                  const dataEditStart = this.dataEdit.start_datetime;
                  const dataEditEnd = this.dataEdit.end_datetime;
                  userStart = moment(dataEditStart).valueOf();
                  userEnd = moment(dataEditEnd).valueOf();

                  const isSameVehicle = parseInt(assetId) == parseInt(tms.category);

                  if ((calStart < userEnd && calEnd > userStart) && isSameVehicle) {
                    this.$swal({
                      icon: "error",
                      title: "Not Allowed",
                      text: "Vehicle has been booked at this time"
                    });
                  }

                  let datetime = moment(this.dataEdit.end_datetime).format(
                    "YYYY-MM-DD HH:mm"
                  );
                  let date = moment(this.dataEdit.end_datetime).format(
                    "YYYY-MM-DD"
                  );
                  let time = moment(this.dataEdit.end_datetime).format("HH:mm");
                  let scrolltime = moment(this.dataEdit.start_datetime).format(
                    "HH:mm"
                  );
                  if (this.$refs.calendars) {
                    this.$refs.calendars.scrollToTime(scrolltime);
                  }
                  let parse = {
                    day: parseInt(moment(date).format("D")),
                    hour: parseInt(moment(datetime).format("H")),
                    minute: parseInt(
                      moment(this.dataEdit.end_datetime).minute()
                    ),
                    month: parseInt(moment(date).format("MM")),
                    year: parseInt(moment(date).format("YYYY"))
                  };
                  let endtoTime = new Date(
                    parse.year,
                    parse.month - 1,
                    parse.day,
                    parse.hour,
                    parse.minute
                  ).getTime();
                  // edit, has schedules
                  this.createEvent = {
                    name: "Edit Booking",
                    color: "grey",
                    start: this.createStart,
                    end: endtoTime,
                    timed: true,
                    category: tms.category,
                    details: {
                      start: detail_start,
                      end: time,
                      detail: {
                        recurring: "0"
                      }
                    }
                  };
                  this.start_time = detail_start;
                  this.end_time = time;
                  this.create_start_time = detail_start;
                  this.create_end_time = time;
                  this.passengerCount = this.dataEdit.book_user.passenger_count;
                } else {
                  const assetId = fil.detail.vehicle_id ? fil.detail.vehicle_id : fil.detail.asset_id;
                  const isSameVehicle = parseInt(assetId) == parseInt(tms.category);
                  if ((calStart < userEnd && calEnd > userStart) && isSameVehicle) {
                    this.$swal({
                      icon: "error",
                      title: "Not Allowed",
                      text: "Vehicle has been booked at this time"
                    });
                    this.handleClickBack(true);
                  } else {
                    this.createEvent = {
                      name: "Create Booking",
                      color: "grey",
                      start: this.createStart,
                      end: this.createEnd,
                      timed: true,
                      category: tms.category,
                      details: {
                        start: detail_start,
                        end: detail_end,
                        detail: {
                          recurring: "0"
                        }
                      }
                    };
                    this.start_time = detail_start;
                    this.end_time = detail_end;
                    this.create_start_time = detail_start;
                    this.create_end_time = detail_end;
                    this.passengerCount = 1;
                  }
                }
              });
            } else if (isEmpty(filter.schedules)) {
              if (!isEmpty(this.dataEdit)) {
                let datetime = moment(this.dataEdit.end_datetime).format(
                  "YYYY-MM-DD HH:mm"
                );
                let date = moment(this.dataEdit.end_datetime).format(
                  "YYYY-MM-DD"
                );
                let time = moment(this.dataEdit.end_datetime).format("HH:mm");
                let scrolltime = moment(this.dataEdit.start_datetime).format(
                  "HH:mm"
                );
                if (this.$refs.calendars) {
                  this.$refs.calendars.scrollToTime(scrolltime);
                }
                let parse = {
                  day: parseInt(moment(date).format("D")),
                  hour: parseInt(moment(datetime).format("H")),
                  minute: parseInt(moment(this.dataEdit.end_datetime).minute()),
                  month: parseInt(moment(date).format("MM")),
                  year: parseInt(moment(date).format("YYYY"))
                };
                let endtoTime = new Date(
                  parse.year,
                  parse.month - 1,
                  parse.day,
                  parse.hour,
                  parse.minute
                ).getTime();
                this.createEvent = {
                  name: "Edit Booking",
                  color: "grey",
                  start: this.createStart,
                  end: endtoTime,
                  timed: true,
                  category: tms.category,
                  details: {
                    start: detail_start,
                    end: time,
                    detail: {
                      recurring: "0"
                    }
                  }
                };
                this.start_time = detail_start;
                this.end_time = time;
                this.create_start_time = detail_start;
                this.create_end_time = time;
                this.passengerCount = this.dataEdit.book_user.passenger_count;
              } // create
              else {
                this.createEvent = null;
                this.createEvent = {
                  name: "Create Booking",
                  color: "grey",
                  start: this.createStart,
                  end: this.createEnd,
                  timed: true,
                  category: tms.category,
                  details: {
                    start: detail_start,
                    end: detail_end,
                    detail: {
                      recurring: "0"
                    }
                  }
                };
                this.start_time = detail_start;
                this.end_time = detail_end;
                this.create_start_time = detail_start;
                this.create_end_time = detail_end;
                this.passengerCount = 1;
              }
            }
            if (!isEmpty(this.createEvent)) {
              const isCreatedOpen = this.events.find(evt => evt.color == 'grey');
              if (!isCreatedOpen) this.events.push(this.createEvent);
              let createBook = this.events.filter(
                event =>
                  event.name == "Create Booking" || event.name == "Edit Booking"
              );
              if (!isNull(createBook) && !isEmpty(createBook)) {
                this.keepSilent = true;
              }
              this.pages = "dialog";
              this.dialogs.data = tms;
              this.booking.date = tms.date;
              let triggerDrag = false;
              if (tms.hasOwnProperty('end_date')) {
                this.booking.end_date = tms.end_date;
              } else {
                if (tms.date != this.booking.end_date) {
                  this.booking.end_date = tms.date;
                  triggerDrag = true;
                } else {
                  triggerDrag = true;
                }
              }

              this.booking.asset = tms.category;
              this.createEvent.category = tms.category;

              if (this.isTypeVehicle) {
                let showDesc = this.getVehicles.find(
                  vehicle => vehicle.id === tms.category
                );
                
                // Check if vehicle is found before accessing its properties
                if (!showDesc) {
                  this.dragTime = null;
                  this.dragEvent = null;
                  this.createEvent = null;
                  this.createStart = null;
                  this.createEnd = null;
                  this.extendOriginal = null;
                  this.handleClickBack(true);
                  return;
                }
                
                let vehDesc = `${showDesc.device_make.replace(
                  /[^\w\s]/gi,
                  ""
                )} ${showDesc.device_model.replace(
                  /[^\w\s]/gi,
                  ""
                )} ${showDesc.device_plate.replace(/[^\w\s]/gi, "")}`;
                this.selectedVehBook = vehDesc;
                this.booking.vehicle = tms.category;
              } else {
                let assets = this.dataAssets.find(
                  asset => asset.id === tms.category
                );
                
                // Check if asset is found before accessing its properties
                if (!assets) {
                  this.dragTime = null;
                  this.dragEvent = null;
                  this.createEvent = null;
                  this.createStart = null;
                  this.createEnd = null;
                  this.extendOriginal = null;
                  this.handleClickBack(true);
                  return;
                }
                
                this.selectedVehBook = `Number - ${get(assets, "number", "")}`;
              }

              if (triggerDrag && this.$refs.calendars.$el) {
                this.$nextTick(() => {
                  try {
                    const eventElements = this.$refs.calendars.$el.getElementsByClassName(
                      "v-event-timed"
                    );

                    if (eventElements && eventElements.length > 0) {
                      let greyElementFound = false;
                      eventElements.forEach((element, index) => {
                        const style = window.getComputedStyle(element);
                        const backgroundColor = style.backgroundColor;
                        const hasGreyClass = element.classList.contains("grey");
                        if (hasGreyClass || backgroundColor == 'rgba(0, 0, 0, 0.7)') {
                          greyElementFound = true;
                        }
                      });
                      
                      // If no grey element was found, reset drag state
                      if (!greyElementFound) {
                        this.dragTime = null;
                        this.dragEvent = null;
                        this.createEvent = null;
                        this.createStart = null;
                        this.createEnd = null;
                        this.extendOriginal = null;
                        this.handleClickBack(true);
                      } else {
                        this.events = this.events.filter(event => event.color != 'grey');
                        this.events.push(this.createEvent);
                        this.$forceUpdate();
                      }
                    } else {
                      // No event elements found, reset drag state
                      this.dragTime = null;
                      this.dragEvent = null;
                      this.createEvent = null;
                      this.createStart = null;
                      this.createEnd = null;
                      this.extendOriginal = null;
                      this.handleClickBack(true);
                    }
                  } catch (e) {
                    this.dragTime = null;
                    this.dragEvent = null;
                    this.createEvent = null;
                    this.createStart = null;
                    this.createEnd = null;
                    this.extendOriginal = null;
                    this.handleClickBack(true);
                  }
                });
              }
            }
          }
        } else if (avail && !isEmpty(filterService)) {
          this.createStart = this.roundTime(mouse);
          const mouseRounded = this.roundTime(mouse, false);
          const min = Math.min(mouseRounded, this.createStart);
          let max = Math.max(mouseRounded, this.createStart);
          this.createEnd = max;
          
          // Ensure minimum duration of 30 minutes if start and end are the same
          if (min === max) {
            max = moment(min).add(30, 'minutes').valueOf();
          }
          
          const detail_start = moment(min).format("HH:mm");
          const detail_end = moment(max).format("HH:mm");

          filterService.forEach(dt => {
            const dataService = this.vehicleServices.find(
              service => service.id == dt.service_detail.id
            );
            let dateService = moment(`${dataService.start_date}`).format(
              "YYYY-MM-DD HH:mm"
            );
            let dateServiceEnd = moment(dataService.end_date).format(
              "YYYY-MM-DD HH:mm"
            );
            const tmsStartDate = moment(`${tms.date} ${detail_start}`).valueOf();
            const tmsEndDate = moment(`${tms.date} ${detail_end}`).valueOf();
            dateService = moment(dateService).valueOf();
            dateServiceEnd = moment(dateServiceEnd).valueOf();

            if (
              dt.service_detail.vehicle_id === tms.category &&
              (
                (tmsStartDate >= dateService && tmsStartDate <= dateServiceEnd) ||
                (tmsEndDate >= dateService && tmsEndDate <= dateServiceEnd) ||
                (tmsStartDate <= dateService && tmsEndDate >= dateServiceEnd) ||
                (tmsStartDate >= dateService && tmsEndDate <= dateServiceEnd)
              )
            ) {
              this.$swal({
                icon: "error",
                title: "Not Allowed",
                text: "Vehicle is under maintenance service"
              }).then(res => {
                if (res.isConfirmed) {
                  this.keepSilent = false;
                }
              });
            } else {
              if (this.dragEvent && this.dragTime === null) {
                const start = this.dragEvent.start;
                this.dragTime = mouse - start;
              } else {
                if (this.keepSilent) return;
                this.createStart = this.roundTime(mouse);
                const mouseRounded = this.roundTime(mouse, false);
                const min = Math.min(mouseRounded, this.createStart);
                let max = Math.max(mouseRounded, this.createStart);
                this.createEnd = max;
                
                // Ensure minimum duration of 30 minutes if start and end are the same
                if (min === max) {
                  max = moment(min).add(30, 'minutes').valueOf();
                }
                
                const detail_start = moment(min).format("HH:mm");
                const range_start = moment(min).format("HH");
                const detail_end = moment(max).format("HH:mm");

                if (startWorkingTime && endWorkingTime) {
                  const startWorking = moment(startWorkingTime, 'HH:mm').format('HH');
                  const endWorking = moment(endWorkingTime, 'HH:mm').format('HH');
                  this.time_range = [parseInt(startWorking), parseInt(endWorking)];
                  this.time_range_end = [parseInt(startWorking), parseInt(endWorking)];
                } else if (timeRange) {
                  this.time_range = timeRange;
                  this.time_range_end = timeRange;
                } else {
                  this.time_range = [parseInt(range_start), 23];
                  this.time_range_end = [parseInt(range_start), 23];
                  if (this.booking.hasOwnProperty('end_date')) {
                    if (this.booking.date != this.booking.end_date) {
                      this.time_range_end = [0, 23];
                    }
                  }
                }

                if (!isEmpty(filter.schedules)) {
                  const distance = filter.schedules.reduce((arr, val) => {
                    if (val.type == 'done') {
                      if (val.hasOwnProperty('distance')) arr += parseInt(val.distance);
                    }
                    return arr;
                  }, 0);
                  if (this.isElectricVehicle && distance >= 100) {
                    this.$swal({
                      icon: "error",
                      title: "Over Limit",
                      text: "This EV cannot be booked as it exceeds the daily 100KM limit. Please choose another vehicle or try booking on a different day."
                    });
                  }
                  filter.schedules.forEach(fil => {
                    let calStart = moment(`${tms.date} ${fil.start}`).valueOf();
                    let calEnd = moment(`${tms.hasOwnProperty('end_date') ? tms.end_date : tms.date} ${fil.end}`).valueOf();
                    let userStart = moment(
                      `${tms.hasOwnProperty('end_date') ? tms.end_date : tms.date} ${detail_start}`
                    ).valueOf();
                    let userEnd = moment(`${tms.hasOwnProperty('end_date') ? tms.end_date : tms.date} ${detail_end}`).valueOf();
                    if (!isEmpty(this.dataEdit)) {
                      let datetime = moment(this.dataEdit.end_datetime).format(
                        "YYYY-MM-DD HH:mm"
                      );
                      let date = moment(this.dataEdit.end_datetime).format(
                        "YYYY-MM-DD"
                      );
                      let time = moment(this.dataEdit.end_datetime).format(
                        "HH:mm"
                      );
                      let scrolltime = moment(
                        this.dataEdit.start_datetime
                      ).format("HH:mm");
                      if (this.$refs.calendars) {
                        this.$refs.calendars.scrollToTime(scrolltime);
                      }
                      let parse = {
                        day: parseInt(moment(date).format("D")),
                        hour: parseInt(moment(datetime).format("H")),
                        minute: parseInt(
                          moment(this.dataEdit.end_datetime).minute()
                        ),
                        month: parseInt(moment(date).format("MM")),
                        year: parseInt(moment(date).format("YYYY"))
                      };
                      let endtoTime = new Date(
                        parse.year,
                        parse.month - 1,
                        parse.day,
                        parse.hour,
                        parse.minute
                      ).getTime();
                      // edit, has schedules
                      this.createEvent = {
                        name: "Edit Booking",
                        color: "grey",
                        start: this.createStart,
                        end: endtoTime,
                        timed: true,
                        category: tms.category,
                        details: {
                          start: detail_start,
                          end: time,
                          detail: {
                            recurring: "0"
                          }
                        }
                      };
                      this.start_time = detail_start;
                      this.end_time = time;
                      this.create_start_time = detail_start;
                      this.create_end_time = time;
                      this.passengerCount = this.dataEdit.book_user.passenger_count;
                    } else {
                      const assetId = fil.detail.vehicle_id ? fil.detail.vehicle_id : fil.detail.asset_id;
                      const isSameVehicle = parseInt(assetId) == parseInt(tms.category);
                      if ((calStart < userEnd && calEnd > userStart) && isSameVehicle) {
                        this.$swal({
                          icon: "error",
                          title: "Not Allowed",
                          text: "Vehicle has been booked at this time"
                        });
                        this.handleClickBack(true);
                      } else {
                        this.createEvent = {
                          name: "Create Booking",
                          color: "grey",
                          start: this.createStart,
                          end: this.createEnd,
                          timed: true,
                          category: tms.category,
                          details: {
                            start: detail_start,
                            end: detail_end,
                            detail: {
                              recurring: "0"
                            }
                          }
                        };
                        this.start_time = detail_start;
                        this.end_time = detail_end;
                        this.create_start_time = detail_start;
                        this.create_end_time = detail_end;
                        this.passengerCount = 1;
                      }
                    }
                  });
                } else if (isEmpty(filter.schedules)) {
                  if (!isEmpty(this.dataEdit)) {
                    let datetime = moment(this.dataEdit.end_datetime).format(
                      "YYYY-MM-DD HH:mm"
                    );
                    let date = moment(this.dataEdit.end_datetime).format(
                      "YYYY-MM-DD"
                    );
                    let time = moment(this.dataEdit.end_datetime).format(
                      "HH:mm"
                    );
                    let scrolltime = moment(
                      this.dataEdit.start_datetime
                    ).format("HH:mm");
                    if (this.$refs.calendars) {
                      this.$refs.calendars.scrollToTime(scrolltime);
                    }
                    let parse = {
                      day: parseInt(moment(date).format("D")),
                      hour: parseInt(moment(datetime).format("H")),
                      minute: parseInt(
                        moment(this.dataEdit.end_datetime).minute()
                      ),
                      month: parseInt(moment(date).format("MM")),
                      year: parseInt(moment(date).format("YYYY"))
                    };
                    let endtoTime = new Date(
                      parse.year,
                      parse.month - 1,
                      parse.day,
                      parse.hour,
                      parse.minute
                    ).getTime();
                    this.createEvent = {
                      name: "Edit Booking",
                      color: "grey",
                      start: this.createStart,
                      end: endtoTime,
                      timed: true,
                      category: tms.category,
                      details: {
                        start: detail_start,
                        end: time,
                        detail: {
                          recurring: "0"
                        }
                      }
                    };
                    this.start_time = detail_start;
                    this.end_time = time;
                    this.create_start_time = detail_start;
                    this.create_end_time = time;
                    this.passengerCount = this.dataEdit.book_user.passenger_count;
                  } else {
                    this.createEvent = {
                      name: "Create Booking",
                      color: "grey",
                      start: this.createStart,
                      end: this.createEnd,
                      timed: true,
                      category: tms.category,
                      details: {
                        start: detail_start,
                        end: detail_end,
                        detail: {
                          recurring: "0"
                        }
                      }
                    };
                    this.start_time = detail_start;
                    this.end_time = detail_end;
                    this.create_start_time = detail_start;
                    this.create_end_time = detail_end;
                    this.passengerCount = 1;
                  }
                }
                if (!isEmpty(this.createEvent)) {
                  const isCreatedOpen = this.events.find(evt => evt.color == 'grey');
                  if (!isCreatedOpen) this.events.push(this.createEvent);
                  let createBook = this.events.filter(
                    event =>
                      event.name == "Create Booking" ||
                      event.name == "Edit Booking"
                  );
                  if (!isNull(createBook) && !isEmpty(createBook)) {
                    this.keepSilent = true;
                  }
                  this.pages = "dialog";
                  this.dialogs.data = tms;
                  this.booking.date = tms.date;
                  if (tms.hasOwnProperty('end_date')) this.booking.end_date = tms.end_date;
                  this.booking.asset = tms.category;
                  this.booking.end_date = tms.hasOwnProperty('end_date') ? tms.end_date : tms.date;
                  this.createEvent.category = tms.category;
                  this.events = this.events.filter(event => event.color != 'grey');
                  this.events.push(this.createEvent);
                  this.$forceUpdate();
                  if (this.isTypeVehicle) {
                    let showDesc = this.getVehicles.find(
                      vehicle => vehicle.id === tms.category
                    );
                    let vehDesc = `${showDesc.device_make.replace(
                      /[^\w\s]/gi,
                      ""
                    )} ${showDesc.device_model.replace(
                      /[^\w\s]/gi,
                      ""
                    )} ${showDesc.device_plate.replace(/[^\w\s]/gi, "")}`;
                    this.selectedVehBook = vehDesc;
                    this.booking.vehicle = tms.category;
                  } else {
                    let assets = this.dataAssets.find(
                      asset => asset.id === tms.category
                    );
                    this.selectedVehBook = `Number - ${get(
                      assets,
                      "number",
                      ""
                    )}`;
                  }
                }
              }
            }
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Not Allowed",
            text: "Vehicle is not available on this date"
          });
        }
      } else {
        this.isPickPastTime = true;
      }
    },
    extendBottom(event) {
      if (Object.prototype.hasOwnProperty.call(event, "id")) {
        this.keepSilent = true;
        this.handleSilent = setTimeout(() => {
          this.keepSilent = false;
        }, 1e3);
        return;
      }

      this.createEvent = event;
      this.createStart = event.start;
      this.createEnd = event.end;
      this.extendOriginal = event.end;
    },
    hoverTooSeeTime({ category }) {
      this.hoverCategory = category;
      this.isHover = true;
    },
    removeHover() {
      this.isHover = false;
    },
    validateTime() {
      if (!isEmpty(this.swal)) return;

      if (this.selectedEvent.color == '#2c3e50') {
        this.swal = this.$swal({
          icon: "warning",
          title: "Vehicle Services",
          text: "You cannot book this time, reason: " + this.selectedEvent.details.note
        });
        this.dragTime = null;
        this.dragEvent = null;
        this.createEvent = null;
        this.createStart = null;
        this.createEnd = null;
        this.extendOriginal = null;
        this.handleClickBack(true);
        return;
      }

      const vehicle = this.getVehicles.find(vehicle => vehicle.id === this.selectedEvent.category);

      if (this.selectedEvent && this.selectedEvent.details) {
        if (isNaN(this.selectedEvent.end) || this.selectedEvent.end == null || this.selectedEvent.end == undefined) {
          const endEvent = `${this.selectedEvent.date} ${this.selectedEvent.details.end}`;
          this.selectedEvent.end = moment(endEvent, "YYYY-MM-DD HH:mm").valueOf();
        }
      }

      this.booking.date = moment(this.selectedEvent.start).format("YYYY-MM-DD");
      this.booking.end_date = moment(this.selectedEvent.end).format("YYYY-MM-DD");

      if (vehicle) {
        if (this.isVictrack) {
          if (this.isHaveNoLimitAccess(vehicle)) {
            if (isEmpty(this.swal)) {
              this.swal = this.$swal({
                icon: "warning",
                title: "Attention",
                text: "You already have unlimited access to this vehicle"
              });
            }

            this.dragTime = null;
            this.dragEvent = null;
            this.createEvent = null;
            this.createStart = null;
            this.createEnd = null;
            this.extendOriginal = null;
            this.handleClickBack(true);
            return;
          }
        }

        let workingDay = get(vehicle, "metadata.working_day", []);
        let workingTime = this.getWorkingTime(vehicle, "metadata.working_time");

        let inWorkingDay = true;
        let isNotAvailable = false;

        if (workingDay.length) {
          if (typeof workingDay != 'object') workingDay = []
          inWorkingDay = workingDay.includes(
            moment(this.selectedEvent.date).format("d")
          );
        }

        if (
          ((workingTime.hasOwnProperty('start') && workingTime.start && workingTime.start != '') &&
          (workingTime.hasOwnProperty('end') && workingTime.end && workingTime.end != '')) || workingDay.length
        ) {
          if (
            (workingTime.start != '' &&
            workingTime.end != '' &&
            (!this.isWithinWorkingTime(
              workingTime.start,
              workingTime.end,
              moment(`${this.selectedEvent.date} ${this.selectedEvent.details.start}`),
              moment(`${this.selectedEvent.date} ${this.selectedEvent.details.end}`)
            ) && inWorkingDay)) || !inWorkingDay
          ) {
            isNotAvailable = true;
          }
        }

        let timezone = this.userTimezone;
        let currentDateTime = momentTz().tz(timezone).subtract(15, 'minutes').valueOf();

        if (this.isIntimap || this.isWSP) {
          if (this.origin_id) {
            const origin = this.getOrigin.find(
              o => o.Id === this.origin_id
            );
            if (!isEmpty(origin)) {
              const tz = get(origin, 'metadata.timezone.timeZoneId');
              if (tz) {
                timezone = tz;
                currentDateTime = momentTz().tz(timezone).subtract(15, 'minutes').valueOf();
              }
            }
          }
        }

        const eventStartDateTime = moment.tz(
          `${this.selectedEvent.date} ${this.selectedEvent.details.start}`,
          'YYYY-MM-DD HH:mm',
          timezone
        ).valueOf();
        const eventEndDateTime = moment.tz(
          `${this.selectedEvent.date} ${this.selectedEvent.details.end}`,
          'YYYY-MM-DD HH:mm',
          timezone
        ).valueOf();
        let pastTime = currentDateTime > eventStartDateTime;

        const workingStartTime = moment(workingTime.start, "HH:mm")
        const workingEndTime = moment(workingTime.end, "HH:mm")
        const eventStartTime = moment(this.selectedEvent.details.start, "HH:mm")
        const eventEndTime = moment(this.selectedEvent.details.end, "HH:mm")

        if (!isEmpty(this.dataEdit) && pastTime && (currentDateTime <= eventEndDateTime)) {
          pastTime = false;
        }

        if ((isNotAvailable || pastTime) && isEmpty(this.dataEdit)) {
          let text = (workingTime.start && workingTime.end)
            ? "Only Available Between " +
              moment(workingTime.start, "HH:mm").format("hh:mm A") +
              " - " +
              moment(workingTime.end, "HH:mm").format("hh:mm A")
            : "Vehicle is not available at this time";

          if (!inWorkingDay) {
            text = "Only Available On " + workingDay.map(day => moment().day(day).format("dddd")).join(", ");
          }

          if (!pastTime) {
            if (workingStartTime.isAfter(eventStartTime)) {
              const diffWorkingStart = workingStartTime.diff(eventStartTime, 'minutes')
              this.start_time = workingStartTime.format("HH:mm");
              this.create_start_time = this.start_time
              this.selectedEvent.start = workingStartTime.valueOf();
              this.selectedEvent.details.start = this.start_time;
              this.end_time = moment(eventEndTime).add(diffWorkingStart, 'minutes').format("HH:mm");
              this.create_end_time = this.end_time
              this.selectedEvent.end = moment(eventEndTime).add(diffWorkingStart, 'minutes').valueOf();
              this.selectedEvent.details.end = this.end_time;
            }

            if (workingEndTime.isBefore(eventEndTime)) {
              const diffWorkingEnd = eventEndTime.diff(workingEndTime, 'minutes')
              this.end_time = workingEndTime.format("HH:mm");
              this.create_end_time = this.end_time;
              this.selectedEvent.end = workingEndTime.valueOf();
              this.selectedEvent.details.end = this.end_time;
              this.start_time = moment(eventStartTime).subtract(diffWorkingEnd, 'minutes').format("HH:mm");
              this.create_start_time = this.start_time;
              this.selectedEvent.start = moment(eventStartTime).subtract(diffWorkingEnd, 'minutes').valueOf();
              this.selectedEvent.details.start = this.start_time;
            }

            if (this.booking.date != this.booking.end_date) this.selectedEvent.end = moment(`${this.booking.date} ${this.selectedEvent.details.end}`).valueOf();
          }

          if (!inWorkingDay || pastTime) {
            if (pastTime) {
              if (!this.selectedEvent && this.dialog && this.dialog.color != 'grey') {
                this.isPickPastTime = true;
                return;
              }
              text = "Cannot Pick Past Time";
            }
            this.handleClickBack(true);
          }

          if (isEmpty(this.swal)) {
            this.swal = this.$swal({
              icon: "error",
              title: "Vehicle Not Available",
              text
            });
          }
        }
      }

      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.createEnd = null;
      this.extendOriginal = null;
    },
    mouseMove(tms) {
      if (this.busyMouse) return false;

      const mouse = this.toTime(tms);

      let startWorking = "";
      let endWorking = "";

      if (this.dragEvent && this.dragTime !== null) {
        this.dragEvent.category = this.hoverCategory;
        if (this.isTypeVehicle) {
          let showDesc = this.getVehicles.find(
            vehicle => vehicle.id === this.hoverCategory
          );

          const workingTime = this.getWorkingTime(showDesc, "metadata.working_time");
          const startWorkingTime = get(workingTime, "start", "");
          const endWorkingTime = get(workingTime, "end", "");

          if ((startWorkingTime && startWorkingTime != '') && (endWorkingTime && endWorkingTime != '')) {
            startWorking = moment(startWorkingTime, 'HH:mm').format('HH');
            endWorking = moment(endWorkingTime, 'HH:mm').format('HH');
          }

          let vehDesc = `${showDesc.device_make.replace(
            /[^\w\s]/gi,
            ""
          )} ${showDesc.device_model.replace(
            /[^\w\s]/gi,
            ""
          )} ${showDesc.device_plate.replace(/[^\w\s]/gi, "")}`;
          this.selectedVehBook = vehDesc;
          // if(!isEmpty(this.dataEdit)){
          this.booking.vehicle = this.dragEvent.category;
          // }
        } else {
          let assets = this.dataAssets.find(
            asset => asset.id === this.hoverCategory
          );
          this.selectedVehBook = `Number - ${get(assets, "number", "")}`;
        }
        const start = this.dragEvent.start;
        const end = this.dragEvent.end;
        const duration = end - start;
        const newStartTime = mouse - this.dragTime;
        const newStart = this.roundTime(newStartTime);
        const newEnd = newStart + duration;
        this.dragEvent.start = newStart;
        this.dragEvent.end = newEnd;
        const mouseRounded = this.roundTime(newStart, false);
        const min = Math.min(mouseRounded, newStart);
        const max = Math.max(mouseRounded, newEnd);
        this.start_time = moment(min).format("HH:mm");
        this.end_time = moment(max).format("HH:mm");
        this.create_start_time = this.start_time;
        this.create_end_time = this.end_time;
        this.dragEvent.details.start = moment(min).format("HH:mm");
        this.dragEvent.details.end = moment(max).format("HH:mm");
        if (startWorking && endWorking) {
          this.time_range = [parseInt(startWorking), parseInt(endWorking)];
          this.time_range_end = [parseInt(startWorking), parseInt(endWorking)];
        } else if (this.dragEvent) {
          this.time_range = [parseInt(this.dragEvent.details.start), 23];
          this.time_range_end = [parseInt(this.dragEvent.details.start), 23];
        }
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false);
        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);
        this.start_time = moment(min).format("HH:mm");
        this.end_time = moment(max).format("HH:mm");
        this.create_start_time = this.start_time;
        this.create_end_time = this.end_time;
        this.createEvent.start = min;
        this.createEvent.end = max;
        this.createEvent.details.start = moment(min).format("HH:mm");
        this.createEvent.details.end = moment(max).format("HH:mm");
      }
    },
    endDrag() {
      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.createEnd = null;
      this.extendOriginal = null;

      setTimeout(() => {
        this.validateTime();
      }, 1e2);
    },
    cancelDrag() {
      if (this.createEvent) {
        this.keepSilent = true;
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal;
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }
      this.keepSilent = false;
    },
    roundTime(time, down = true) {
      const roundTo = this.minuteInterval; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },
    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute
      ).getTime();
    },
    getEventColor(event) {
      const rgb = parseInt(event.color.substring(1), 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = (rgb >> 0) & 0xff;

      return event === this.dragEvent
        ? `rgba(${r}, ${g}, ${b}, 0.7)`
        : event === this.createEvent
        ? `rgba(${r}, ${g}, ${b}, 0.7)`
        : event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    rndElement(arr) {
      return arr[this.rnd(0, arr.length - 1)];
    },
    dates(start) {
      this.arraytest.push(start);
      let addDay = 0;
      if (this.booking.recurring === "Daily") {
        addDay = 1;
      } else if (this.booking.recurring === "Weekly") {
        addDay = 7;
      }
      const diffForNext = moment(this.booking.end_date).diff(
        this.booking.date,
        "days"
      );
      let add1day = moment(start)
        .add(addDay, "days")
        .format("YYYY-MM-DD");

      let add1month = moment(start)
        .add(1, "M")
        .format("YYYY-MM-DD");
      if (this.booking.recurring !== "Monthly") {
        let nextNumber = moment(add1day)
          .add(diffForNext, "days")
          .format("YYYY-MM-DD");
        if (moment(nextNumber).unix() < moment(this.max).unix()) {
          this.dates(nextNumber);
        }
      } else if (this.booking.recurring === "Monthly") {
        let nextNumber = moment(add1month)
          .add(diffForNext, "days")
          .format("YYYY-MM-DD");
        if (moment(nextNumber).unix() < moment(this.max).unix()) {
          this.dates(nextNumber);
        }
      }
    },
    submitJoin(dialog) {
      if (this.$refs.join_booking.validate()) {
        if (this.submitBooking) return;
        this.submitBooking = true;
        this.getMaxSeatCount == 0
          ? (this.passengerCount = 0)
          : this.passengerCount;
        let data = "";
        let destination = {};
        let metadata = {};
        if (!isEmpty(this.destination.selected["address"])) {
          metadata = {
            address: this.destination.selected["address"]
          };
        } else if (!isEmpty(this.selectedPopularData)) {
          metadata = {
            address: this.selectedPopularData.address
          };
        }
        
        if (this.sharePassengerList.length > 0) {
          metadata.passenger_list = this.sharePassengerList;
        }
        if (this.destination.selected.hasOwnProperty("id")) {
          destination["type"] = "address";
          destination["geofence_id"] = this.destination.selected["id"];
          destination["latitude"] = this.destination.selected["latitude"];
          destination["longitude"] = this.destination.selected["longitude"];
        } else if (!isEmpty(this.selectedPopularData)) {
          if (!isUndefined(this.selectedPopularData)) {
            destination["type"] = "popular";
            destination["latitude"] = this.selectedPopularData.latitude;
            destination["longitude"] = this.selectedPopularData.longitude;
          }
        } else {
          destination["type"] = "address";
          destination["latitude"] = this.destination.selected["lat"];
          destination["longitude"] = this.destination.selected["lng"];
        }
        if (dialog.detail.recurring == "1") {
          try {
            dialog.detail.metadata = JSON.parse(dialog.detail.metadata);
          } catch (e) {}

          metadata.recurring_info = {
            crontab: dialog.detail.metadata.recurring_info.crontab,
            end_after: dialog.detail.metadata.recurring_info.end_after
          };
        }
        if (this.isVehicle) {
          if (destination.type == "geofence") {
            data = {
              user_id: this.$store.state.user.user.id,
              parent_id: dialog.detail.id,
              passenger_count: this.selectedSharePassenger,
              vehicle_id: dialog.detail.vehicle_id,
              total_seat: 5,
              start_datetime: dialog.detail.start_datetime,
              send_email: 1,
              end_datetime: dialog.detail.end_datetime,
              shared: this.sharedVehicle,
              metadata: metadata,
              start_geofence_id: dialog.detail.start_geofence_id,
              end_longitude: destination.longitude,
              end_latitude: destination.latitude,
              join_request: 1
            };
          } else if (
            destination.type == "address" ||
            destination.type == "popular"
          ) {
            data = {
              user_id: this.$store.state.user.user.id,
              parent_id: dialog.detail.id,
              passenger_count: this.selectedSharePassenger,
              vehicle_id: dialog.detail.vehicle_id,
              total_seat: 5,
              start_datetime: dialog.detail.start_datetime,
              send_email: 1,
              end_datetime: dialog.detail.end_datetime,
              shared: this.sharedVehicle,
              metadata: metadata,
              start_geofence_id: dialog.detail.start_geofence_id,
              end_longitude: destination.longitude,
              end_latitude: destination.latitude,
              join_request: 1
            };
          } else if (!isUndefined(this.selectedPopularData)) {
            if (destination.type == "popular") {
              destination["type"] = "popular";
              destination["latitude"] = this.selectedPopularData.latitude;
              destination["longitude"] = this.selectedPopularData.longitude;
            }
          }
        } else {
          if (destination.type == "geofence") {
            data = {
              user_id: this.$store.state.user.user.id,
              parent_id: dialog.detail.id,
              passenger_count: this.selectedSharePassenger,
              total_seat: 5,
              start_datetime: dialog.detail.start_datetime,
              send_email: 1,
              end_datetime: dialog.detail.end_datetime,
              shared: this.sharedVehicle,
              start_geofence_id: dialog.detail.start_geofence_id,
              end_geofence_id: dialog.detail.end_geofence_id,
              asset_id: dialog.detail.asset,
              join_request: 1
            };
          } else if (destination.type == "address") {
            data = {
              user_id: this.$store.state.user.user.id,
              parent_id: dialog.detail.id,
              passenger_count: this.selectedSharePassenger,
              total_seat: 5,
              start_datetime: dialog.detail.start_datetime,
              send_email: 1,
              end_datetime: dialog.detail.end_datetime,
              shared: this.sharedVehicle,
              metadata: metadata,
              start_geofence_id: dialog.detail.start_geofence_id,
              end_longitude: destination.longitude,
              end_latitude: destination.latitude,
              asset_id: dialog.detail.asset,
              join_request: 1
            };
          }
        }
        metadata.booking_detail = {
          asset_type: this.selectedAssetType.id,
          group_id: this.isAdmin
            ? this.selectedVehicleGroup.id
            : this.selectedVehicleGroup.group_id
        };
        if (this.isIntimap || this.isWSP) {
          const timezone = this.getTimezoneDepot(this.origin_id);
          if (timezone) {
            data.depot_timezone = timezone;
          }
        }
        this.$store
          .dispatch("API_CALL", {
            $method: "create_book",
            $postData: {
              data: data
            }
          })
          .then(response => {
            this.submitBooking = false;
            if (response.data.code == 200) {
              this.$swal({
                icon: "success",
                title: response.data.data.message,
                html: `<span style="font-family:"Roboto", sans-serif;">Your request to share the ride with <b>${
                  dialog.detail.passenger[0].first_name
                } ${dialog.detail.passenger[0].last_name}</b></span> was sent`
              });
              this.dialog.open = false;
              this.showNewPass = false;
              this.handleClickSearch();
            } else {
              this.$swal({
                icon: "error",
                title: response.data.data.message
              });
              this.dialog.open = false;
              this.showNewPass = false;
              this.handleClickSearch();
            }
          });
      }
    },
    isSharedDialog(dialog) {
      if (!dialog) return;
      let find_join = dialog.passenger.find(
        p => p.user_id == this.$store.state.user.user.id
      );
      if (dialog.shared == 1 && isEmpty(find_join)) {
        this.is_already_join = true;
        this.isShared = true;
        return true;
      } else {
        this.isShared = false;
        return false;
      }
    },
    handleSearchDestination: async (q, vm, target = 'destination') => {
      if (vm[target].loading) return;

      vm[target].loading = true;

      let baseUrl = process.env.VUE_APP_CARPOOLING_URL.replace('carpooling', '');
      baseUrl = baseUrl.replace('_dev', '');
      const filterAu = process.env.VUE_APP_WEB != "fleetpooling";
      const queryAddress = qs.stringify({ query: q, key: '70hrLH@SZ&pa2g', filter_au: filterAu });
      const url = `${baseUrl}index.php/public_api/search_address_carpool?${queryAddress}`
      return vm.$http
        .get(url)
        .then(response => {
          if (response) {
            const { data } = response;
            let addressFormatted = [];
            let streetFormatted = [];

            if (data.hasOwnProperty("address")) {
              addressFormatted = data.address.map(p => {
                if (p.hasOwnProperty("id")) {
                  let streetType =
                    p.street_type === "Street" ? "St" : p.street_type;
                  let number =
                    p.number_last !== null
                      ? `${p.number_first}-${p.number_last}`
                      : p.number_first;

                  p.address = `${number} ${p.street_name} ${streetType}, ${
                    p.locality_name
                  }, ${p.state_name}, ${p.postcode}`;
                }
                return p;
              });
            }

            if (data.hasOwnProperty("street")) {
              streetFormatted = data.street.map(s => {
                if (s.hasOwnProperty("id")) {
                  s.address = `${s.street_name}, ${s.locality_name}, ${
                    s.state_name
                  }, ${s.postcode}`;
                }
                return s;
              });
            }

            if (Array.isArray(data)) {
              addressFormatted = data.map(p => ({
                longitude: p.lng,
                latitude: p.lat,
                address: p.address
              }));
            }

            vm[target].locations = [
              ...addressFormatted,
              ...streetFormatted
            ];
          }
        })
        .then(() => (vm[target].loading = false));
    },
    handleFocusDestination() {
      if (this.destination.search === "" || this.destination.search === null) {
        this.destination.locations = [];
      }
    },
    removeVariousDestination(index) {
      this.variousDestinationList.splice(index, 1);
    },
    pushServicesData() {
      if (this.vehicleServices.length) {
        for (let i = 0; i < this.vehicleServices.length; i++) {
          const service = this.vehicleServices[i];
          if (this.categoriesAll.includes(service.vehicle_id)) {
            this.events.push({
              id: service.id,
              name: service.note,
              title: service.note,
              start: new Date(service.start_date).getTime(),
              end: new Date(service.end_date).getTime(),
              timed: true,
              category: service.vehicle_id,
              color: '#2c3e50',
              details: service
            });
          }
        }
      }
    },
    handleClickSearch() {
      if (this.isBusySearch) return;
      this.isFirstEdit = false;
      this.isBusySearch = true;
      this.completelyNoData = true;
      this.isMore = false;
      this.keepSilent = false;
      this.categoryDays = 7;
      this.events = [];
      this.calendar.page = "line";
      this.page = "booking";
      let isValid = this.$refs.form.validate();
      let filterUser = null;
      let licenseUser = null;
      let dataUsers = this.dataAllUsers;
      if (!isEmpty(dataUsers)) {
        if (!this.bookingOtherUser) {
          filterUser = dataUsers.find(
            fil => fil.id === this.$store.state.user.user.id
          );
          licenseUser = get(
            filterUser.metadata,
            "driver_license.expiry_date",
            ""
          );
        } else {
          filterUser = dataUsers.find(
            fil => fil.id === this.selectedOtherUser
          );
          licenseUser = get(
            filterUser.metadata,
            "driver_license.expiry_date",
            ""
          );
        }
        let formatExpiry = moment(licenseUser).format("D MMM YYYY");
        let soon = false;
        let valid = false;
        let expired = false;
        //myke
        if (
          isNull(this.destination.search) &&
          isEmpty(this.selectedPopularData) &&
          !this.isTypeVehicle &&
          isValid
        ) {
          const currentDate = moment(this.timezoneDate);
          const selectedDate = this.dateToday;
          let startDate = moment(selectedDate)
            .add(-3, "days")
            .format("YYYY-MM-DD");
          let endDate = moment(selectedDate)
            .add(3, "days")
            .format("YYYY-MM-DD");

          if (moment(selectedDate).diff(currentDate, "days") < 3 && moment(selectedDate).isAfter(currentDate)) {
            startDate = currentDate.format("YYYY-MM-DD");
            endDate = moment(selectedDate)
              .add(6, "days")
              .format("YYYY-MM-DD");
          }

          let destination = {};

          destination["type"] = "address";
          destination["latitude"] = "";
          destination["longitude"] = "";

          const vehGroupId = this.isAdmin
            ? this.selectedVehicleGroup.id
            : this.selectedVehicleGroup.group_id;

          const payload = {
            token: this.token,
            clientid: this.clientid,
            origin: this.origin_id,
            start_date: startDate,
            end_date: endDate,
            group_id: vehGroupId,
            destination
          };

          if (this.bookingOtherUser) {
            (payload.book_for_other = 1),
              (payload.book_for_user_id = this.selectedOtherUser);
          }

          this.search = true;
          this.calendar.loading = true;


          this.getVehicleServices(payload.start_date, payload.end_date)
          
          if (this.isWSP || this.isIntimap) {
            payload.accessories = this.selectedAccessory.map(item => item);
          }

          if (this.dataEdit && this.dataEdit.hasOwnProperty('id')) {
            payload.edit_id = this.dataEdit.id;
          }

          if (this.isIntimap || this.isWSP) {
            const timezone = this.getTimezoneDepot(this.origin_id);
            if (timezone) {
              payload.timezone = timezone;
            }
          }

          if (!isEmpty(this.dataEdit)) {
            payload.edit_id = this.dataEdit.id;
          }

          this.$store.commit("CLEAR_BOOKS");
          this.$store.dispatch("LOAD_BOOKS", payload).then(() => {
            this.calendar.start = payload.start_date;
            this.startCalendar = payload.start_date;
            this.calendar.end = payload.end_date;
            this.calendar.loading = false;
            this.createLineAndCounterCalendar();
            const $vm = this;
            if (this.selectedView.value == 'day') {
              this.moreVehicle(null, this.dateToday)
            } else {
              setTimeout(() => {
                if (isEmpty(this.dataEdit)) {
                  $vm.handleClickBack(true);
                }
              }, 1e3);
            }
            this.categories = [];
          });
          isValid = false;
          this.destinationRequired = true;
          this.destination.locations = [];
          this.destination.selected = {};
        }
        //destination address or popular
        if (isValid && (!isEmpty(this.destination.selected) || this.isHideSearchAddress || this.selectedVariousLocation)) {
          if (!isEmpty(licenseUser)) {
            let now = moment().format("YYYY-MM-DD");
            const isValidLicense = moment(licenseUser).diff(now, "days");
            if (isValidLicense > 30) {
              valid = true;
            } else if (isValidLicense < 30 && isValidLicense > 0) {
              soon = true;
            } else if (isValidLicense < 0) {
              expired = true;
            }
          }
          const currentDate = moment(this.timezoneDate);
          const selectedDate = this.dateToday;
          let startDate = moment(selectedDate)
            .add(-3, "days")
            .format("YYYY-MM-DD");
          let endDate = moment(selectedDate)
            .add(3, "days")
            .format("YYYY-MM-DD");

          if (moment(selectedDate).diff(currentDate, "days") < 3 && moment(selectedDate).isAfter(currentDate)) {
            startDate = currentDate.format("YYYY-MM-DD");
            endDate = moment(selectedDate)
              .add(6, "days")
              .format("YYYY-MM-DD");
          }

          let destination = {};

          if (!this.isHideSearchAddress && !this.selectedVariousLocation) {
            if (this.destination.selected.hasOwnProperty("Id")) {
              destination["type"] = "geofence";
              destination["geofence_id"] = this.destination.selected["Id"];
            } else {
              destination["type"] = "address";
              destination["latitude"] = this.destination.selected["lat"];
              destination["longitude"] = this.destination.selected["lng"];
            }
          }

          const vehGroupId = this.isAdmin
            ? this.selectedVehicleGroup.id
            : this.selectedVehicleGroup.group_id;

          const payload = {
            token: this.token,
            clientid: this.clientid,
            origin: this.origin_id,
            start_date: startDate,
            end_date: endDate,
            group_id: vehGroupId,
            destination
          };

          if (this.bookingOtherUser) {
            (payload.book_for_other = 1),
              (payload.book_for_user_id = this.selectedOtherUser);
          }

          this.search = true;
          this.calendar.loading = true;

          this.$store.commit("CLEAR_BOOKS");
          if (soon || valid) {
            if (soon) {
              if (!this.bookingOtherUser) {
                this.$swal({
                  icon: "warning",
                  title: "Attention!",
                  text: `Your driver licence will expire soon on ${formatExpiry}`
                });
              } else {
                this.$swal({
                  icon: "warning",
                  title: "Attention!",
                  text: `The selected user's driver licence will expire soon on ${formatExpiry}`
                });
              }
            }

            if (this.isWSP || this.isIntimap) {
              payload.accessories = this.selectedAccessory.map(item => item);
            }

            if (this.dataEdit && this.dataEdit.hasOwnProperty('id')) {
              payload.edit_id = this.dataEdit.id;
            }

            if (this.isIntimap || this.isWSP) {
              const timezone = this.getTimezoneDepot(this.origin_id);
              if (timezone) {
                payload.timezone = timezone;
              }
            }

            this.getVehicleServices(payload.start_date, payload.end_date)
            this.$store.dispatch("LOAD_BOOKS", payload).then(() => {
              this.calendar.start = payload.start_date;
              this.startCalendar = payload.start_date;
              this.calendar.end = payload.end_date;
              this.calendar.loading = false;
              this.createLineAndCounterCalendar();
              const $vm = this;
              if (this.selectedView.value == 'day') {
                this.moreVehicle(null, this.dateToday)
              } else {
                setTimeout(() => {
                  if (isEmpty(this.dataEdit)) {
                    $vm.handleClickBack(true);
                  }
                }, 1e3);
              }
              this.categories = [];
              destination = {};
            });
          } else if (expired && this.isVehicle) {
            if (!this.bookingOtherUser) {
              const clientId = this.$store.state.clientid;
              let textEmail = "";
              if (clientId === "HCQSWYNLHF6A") {
                textEmail = "Please email your updated license information to: <br> fleet@yarracity.vic.gov.au";
              } else if (this.isDarwin) {
                textEmail = "Please email a copy of your licence to <b> HR.Services@darwin.nt.gov.au";
              }
              this.$swal({
                icon: "error",
                title: "Attention!",
                html: `Our record shows that your licence has expired on ${formatExpiry} and you cannot make a vehicle booking on the selected date. <br> <br> ${textEmail}`
              });
            } else {
              this.$swal({
                icon: "error",
                title: "Attention!",
                html: `User <b>${
                  filterUser.username
                } </b> driving licence is expired on ${formatExpiry}. You can not book for this user.`
              });
            }
            this.calendar.loading = false;
            this.heightCalendar = 0;
            this.isShowCalendar = false;
            this.$vuetify.goTo(0);
          } else {
            if (!this.bookingOtherUser) {
              this.$swal({
                icon: "error",
                title: "Attention!",
                text: `You do not have driving licence, please fill in your driving licence information on My Profile page.`
              });
              this.calendar.loading = false;
              this.$router.push({ path: "/my_profile" });
            } else {
              this.$swal({
                icon: "error",
                title: "Attention!",
                html: `User <b>${
                  filterUser.username
                } </b> do not have driving licence. You can not book for this user.`
              });
              this.heightCalendar = 0;
              this.isShowCalendar = false;
              this.$vuetify.goTo(0);
              this.calendar.loading = false;
            }
          }
        } else if (isValid && (!isEmpty(this.selectedPopularData) || this.isHideBookingDestination)) {
          if (!isEmpty(licenseUser)) {
            let now = moment().format("YYYY-MM-DD");
            const isValidLicense = moment(licenseUser).diff(now, "days");
            if (isValidLicense >= 30) {
              valid = true;
            } else if (isValidLicense < 30 && isValidLicense > 0) {
              soon = true;
            } else if (isValidLicense < 0) {
              expired = true;
            }
          }
          const currentDate = moment(this.timezoneDate);
          const selectedDate = this.dateToday;
          let startDate = moment(selectedDate)
            .add(-3, "days")
            .format("YYYY-MM-DD");
          let endDate = moment(selectedDate)
            .add(3, "days")
            .format("YYYY-MM-DD");

          if (moment(selectedDate).diff(currentDate, "days") < 3 && moment(selectedDate).isAfter(currentDate)) {
            startDate = currentDate.format("YYYY-MM-DD");
            endDate = moment(selectedDate)
              .add(6, "days")
              .format("YYYY-MM-DD");
          }
          let destination = {};
          if (!isUndefined(this.selectedPopularData)) {
            destination["type"] = "popular";
            destination["latitude"] = this.selectedPopularData.latitude;
            destination["longitude"] = this.selectedPopularData.longitude;
          }
          const vehGroupId = this.isAdmin
            ? this.selectedVehicleGroup.id
            : this.selectedVehicleGroup.group_id;
          const payload = {
            token: this.token,
            clientid: this.clientid,
            origin: this.origin_id,
            start_date: startDate,
            end_date: endDate,
            group_id: vehGroupId,
            destination
          };
          if (this.bookingOtherUser) {
            (payload.book_for_other = 1),
              (payload.book_for_user_id = this.selectedOtherUser);
          }
          this.search = true;
          this.calendar.loading = true;

          if (!isEmpty(this.dataEdit)) {
            payload.id = this.dataEdit.id;
          }
          this.$store.commit("CLEAR_BOOKS");
          if (soon || valid) {
            if (soon) {
              if (!this.bookingOtherUser) {
                this.$swal({
                  icon: "warning",
                  title: "Attention!",
                  text: `Your driver licence will expire soon on ${formatExpiry}`
                });
              } else {
                this.$swal({
                  icon: "warning",
                  title: "Attention!",
                  text: `The selected user's driver licence will expire soon on ${formatExpiry}`
                });
              }
            }

            if (this.isWSP || this.isIntimap) {
              payload.accessories = this.selectedAccessory.map(item => item);
            }

            if (this.dataEdit && this.dataEdit.hasOwnProperty('id')) {
              payload.edit_id = this.dataEdit.id;
            }

            if (this.isIntimap || this.isWSP) {
              const timezone = this.getTimezoneDepot(this.origin_id);
              if (timezone) {
                payload.timezone = timezone;
              }
            }

            this.getVehicleServices(payload.start_date, payload.end_date)
            this.$store.dispatch("LOAD_BOOKS", payload).then(() => {
              this.calendar.start = payload.start_date;
              this.startCalendar = payload.start_date;
              this.calendar.end = payload.end_date;
              this.calendar.loading = false;
              this.createLineAndCounterCalendar();
              const $vm = this;
              if (this.selectedView.value == 'day') {
                this.moreVehicle(null, this.dateToday)
              } else {
                setTimeout(() => {
                  if (isEmpty(this.dataEdit)) {
                    $vm.handleClickBack(true);
                  }
                }, 1e3);
              }
              this.categories = [];
              destination = {};
            });
          } else if (expired) {
            if (!this.bookingOtherUser) {
              const clientId = this.$store.state.clientid;
              let textEmail = "";
              if (clientId === "HCQSWYNLHF6A") {
                textEmail = "Please email your updated license information to: <br> fleet@yarracity.vic.gov.au";
              } else if (this.isDarwin) {
                textEmail = "Please email a copy of your licence to <b> HR.Services@darwin.nt.gov.au";
              }
              this.$swal({
                icon: "error",
                title: "Attention!",
                html: `Our record shows that your licence has expired on ${formatExpiry} and you cannot make a vehicle booking on the selected date. <br> <br> ${textEmail}`
              });
            } else {
              this.$swal({
                icon: "error",
                title: "Attention!",
                html: `User <b>${
                  filterUser.username
                } </b> driving licence is expired on ${formatExpiry}. You can not book for this user.`
              });
            }
            this.calendar.loading = false;
            this.heightCalendar = 0;
            this.isShowCalendar = false;
            this.$vuetify.goTo(0);
          } else {
            if (!this.bookingOtherUser) {
              this.$swal({
                icon: "error",
                title: "Attention!",
                text: `You do not have driving licence, please fill in your driving licence information on My Profile page.`
              });
              this.calendar.loading = false;
              this.$router.push({ path: "/my_profile" });
            } else {
              this.$swal({
                icon: "error",
                title: "Attention!",
                html: `User <b>${
                  filterUser.username
                } </b> do not have driving licence. You can not book for this user.`
              });
              this.heightCalendar = 0;
              this.isShowCalendar = false;
              this.$vuetify.goTo(0);
              this.calendar.loading = false;
            }
          }
        } else if (
          isValid &&
          isEmpty(this.destination.selected) &&
          isEmpty(this.selectedPopularData) &&
          !this.isHideBookingDestination &&
          !this.isHideSearchAddress &&
          !this.selectedVariousLocation
        ) {
          this.setAlertState("error", "Please select Destination.", true);
          this.calendar.page = "";
        }
      }
      this.isBusySearch = false;
    },
    createBlockCode() {
      document.querySelectorAll('.block-code').forEach(el => el.remove());

      const waitUntilBlockCodeReady = () => {
        this.$nextTick(() => {
          const vm = this;

          if (!vm.$refs.calendars || !vm.$refs.calendars.$el) {
            return setTimeout(waitUntilBlockCodeReady, 1500);
          }

          // Wait for calendar to fully render before querying DOM elements
          setTimeout(() => {
            const daysToText = {
              'Sunday': '0',
              'Monday': '1',
              'Tuesday': '2',
              'Wednesday': '3',
              'Thursday': '4',
              'Friday': '5',
              'Saturday': '6',
            };

            // Force DOM update by querying elements multiple times
            const headers = vm.$refs.calendars.$el.querySelectorAll('.v-calendar-daily_head-day');
            const containers = document.querySelectorAll('.v-calendar-daily__day');
            
            // Double check if elements are ready
            if (headers.length === 0 || containers.length === 0) {
              return setTimeout(waitUntilBlockCodeReady, 1000);
            }

            // Process the calendar elements
            headers.forEach((header, indexHeader) => {
              const dateEl = header.querySelector('.v-calendar-daily_head-day-label > div:first-child');
              const date = dateEl ? dateEl.innerText : '';
              const day = moment(date, 'D MMM YYYY').format('dddd');
              const currentDay = daysToText[day];
              const container = containers[indexHeader];

              const headersDay = header.querySelectorAll('.v-calendar-category__column-header');
              const columnsDay = container.querySelectorAll('.v-calendar-category__column');
              const intervalsDay = container.querySelectorAll('.v-calendar-daily__day-interval');

              const showCategories = [];
              const elCategories = vm.$refs.calendars.$el.querySelectorAll('.name-category');
              const currentCategories = elCategories.length ? Array.from(elCategories).map(el => el.id.replace('category-', '').toString()) : [];

              for (let i = 0; i < currentCategories.length; i++) {
                const category = currentCategories[i];
                const categoryId = typeof category === 'object' ? category.id : category;
                const vehicle = vm.getVehicles.find(vehicle => vehicle.id === categoryId);

                if (!vehicle) continue;

                const workingDay = get(vehicle, 'metadata.working_day', []);
                if (workingDay.length && !workingDay.includes(currentDay)) {
                  if (headersDay[i]) headersDay[i].style.display = 'none';
                  if (columnsDay[i]) columnsDay[i].style.display = 'none';
                  continue;
                }

                if (!showCategories.includes(categoryId)) showCategories.push(categoryId);
              }

              intervalsDay.forEach((intervalDay, intervalIndex) => {
                intervalDay.style.position = 'relative';
                const width = intervalDay.offsetWidth / showCategories.length;
                const height = intervalDay.offsetHeight / 60;

                showCategories.forEach((categoryId, categoryIndex) => {
                  const vehicle = vm.getVehicles.find(v => v.id === categoryId);
                  const workingTime = vm.getWorkingTime(vehicle, 'metadata.working_time');

                  if (!workingTime.start || !workingTime.end) return;

                  const startWorkingTime = moment(workingTime.start, 'HH:mm');
                  const endWorkingTime = moment(workingTime.end, 'HH:mm');

                  for (let i = 0; i < 60; i++) {
                    const hour = String(intervalIndex).padStart(2, '0');
                    const minute = String(i).padStart(2, '0');
                    const currentMinute = moment(`${hour}:${minute}`, 'HH:mm');

                    const isOutsideWorkingTime = currentMinute.isBefore(startWorkingTime) || currentMinute.isAfter(endWorkingTime);

                    if (!isOutsideWorkingTime) continue;

                    const codeId = btoa(`selector${categoryId}${currentDay}${currentMinute.format('HH:mm')}${width}${height}`).replace(/[^0-9a-z]/gi, '');
                    if (intervalDay.querySelector(`#${codeId}`)) {
                      intervalDay.querySelector(`#${codeId}`).remove();
                    }

                    const overlay = document.createElement('div');
                    overlay.id = codeId + `${vehicle.device_name.replace(/[^0-9a-z]/gi, '')}`;
                    overlay.classList.add('block-code');
                    overlay.style.position = 'absolute';
                    overlay.style.width = `${width}px`;
                    overlay.style.height = `${height}px`;
                    overlay.style.top = `${height * i}px`;
                    overlay.style.left = `${width * categoryIndex}px`;
                    overlay.style.background = '#bdc3c7';
                    overlay.style.zIndex = '1';

                    overlay.addEventListener('mouseover', () => {
                      if (vm.dragEvent) {
                        const startDragEvent = moment(`${vm.dragEvent.date} ${vm.dragEvent.details.start}`, 'YYYY-MM-DD HH:mm');
                        const endDragEvent = moment(`${vm.dragEvent.date} ${vm.dragEvent.details.end}`, 'YYYY-MM-DD HH:mm');

                        vm.start_time = startDragEvent.format('HH:mm');
                        vm.create_start_time = vm.start_time;
                        vm.selectedEvent.start = startDragEvent.valueOf();
                        vm.selectedEvent.details.start = vm.start_time;

                        vm.end_time = endDragEvent.format('HH:mm');
                        vm.create_end_time = vm.end_time;
                        vm.selectedEvent.end = endDragEvent.valueOf();
                        vm.selectedEvent.details.end = vm.end_time;

                        vm.dragEvent = null;
                        vm.dragTime = null;
                        vm.createEvent = null;
                        vm.createStart = null;
                        vm.createEnd = null;
                        vm.extendOriginal = null;
                      }
                    });

                    intervalDay.appendChild(overlay);
                  }
                });
              });
            });
          }, 1000);
        });
      };

      waitUntilBlockCodeReady();
    },
    createLineAndCounterCalendar(isCancel = false) {
      this.$nextTick(() => {
        const waitUntilCalendarsLoaded = () => {
          if (this.$refs.calendars) {
            const daysToText = {
              'Sunday': '0',
              'Monday': '1',
              'Tuesday': '2',
              'Wednesday': '3',
              'Thursday': '4',
              'Friday': '5',
              'Saturday': '6'
            };
            this.createBlockCode();
            const el = this.$refs.calendars.$el.querySelectorAll(
              ".v-calendar-daily_head-day-label"
            );
            el.forEach((header, index) => {
              if (header.style.display != "none") {
                const date = header.querySelector("div:first-child").innerText ? header.querySelector("div:first-child").innerText : "";
                const dayHeader = moment(date).format("dddd");
                const dateTodayFormatted = moment(this.dateToday).format(
                  "D MMM YYYY"
                );

                if (dayHeader === "Sunday" || dayHeader === "Saturday") {
                  const elementIdx = index + 2;
                  const dateBodyElement =
                    header.parentNode.parentNode.nextElementSibling;
                  dateBodyElement.querySelector(
                    `.v-calendar-daily__day:nth-child(${elementIdx})`
                  ).style.background = "#fff0f0";
                  header.parentNode.style.background = "#fff0f0";
                }
                if (dateTodayFormatted == date) {
                  const elementIdx = index + 2;
                  const dateBodyElement =
                    header.parentNode.parentNode.nextElementSibling;
                  dateBodyElement.querySelector(
                    `.v-calendar-daily__day:nth-child(${elementIdx})`
                  ).style.background = "#d1d2ff";
                  header.parentNode.style.background = "#d1d2ff";
                }
              }
            });
          } else {
            setTimeout(() => {
              waitUntilCalendarsLoaded();
            }, 1e3);
          }
        };

        waitUntilCalendarsLoaded();

        const calendar = this.$refs.calendar;
        const days = calendar.$children[0].$el.getElementsByClassName(
          "v-calendar-daily__day"
        );
        const headers = calendar.$children[0].$el.getElementsByClassName(
          "v-calendar-daily_head-day"
        );

        const formattedData = this.books.reduce((arr, value) => {
          if (!arr.hasOwnProperty(value.date)) arr[value.date] = {};
          if (value.schedules.length) {
            // eslint-disable-next-line no-unused-vars
            value.schedules.forEach((schedule, i) => {
              const key =
                schedule.detail.asset_id == null
                  ? schedule.detail.vehicle_id
                  : schedule.detail.asset_id;
              if (!arr[value.date].hasOwnProperty(key))
                arr[value.date][key] = [];
              arr[value.date][key].push(schedule);
            });
          }
          const keys = Object.keys(value.available_at_periode);
          if (keys.length) {
            // eslint-disable-next-line no-unused-vars
            keys.forEach((key, i) => {
              for (let j = 0; j < value.available_at_periode[key].length; j++) {
                if (arr[value.date].hasOwnProperty(key)) {
                  arr[value.date][key].push(value.available_at_periode[key][j]);
                }
              }
            });
          }
          return arr;
        }, {});
        this.books.forEach((item, i) => {
          this.createCounterCalendar(headers[i], item, isCancel);
          if (formattedData.hasOwnProperty(item.date)) {
            const keys = Object.keys(formattedData[item.date]);
            let idx = 1;
            keys.forEach(key => {
              const lines = formattedData[item.date][key].sort((a, b) => {
                let startA = a.start;
                if (a.hasOwnProperty("detail")) {
                  startA = `${item.date} ${a.start}`;
                }
                let startB = b.start;
                if (b.hasOwnProperty("detail")) {
                  startB = `${item.date} ${b.start}`;
                }
                const dateA = new Date(startA);
                const dateB = new Date(startB);
                return dateA - dateB;
              });
              if (this.isVehicle) {
                this.booking.vehicleOptions = [key];
                if (this.booking.vehicleOptions.length) {
                  this.booking.vehicle = key;
                }
              }
              lines.forEach(line => {
                if (line.hasOwnProperty("detail")) {
                  this.createScheduleCalendar(days[i], line, idx);
                } else {
                  this.createSchedulePeriod(days[i], line, idx, item);
                }
              });
              idx++;
            });
          }
        });
        const self = this;
        setTimeout(() => {
          self.pushServicesData();
        }, 1e3);
      });
    },
    createCounterCalendar(header, status, isCancel = false) {
      if (isUndefined(header)) return;
      const countContainer = document.createElement("div");
      countContainer.className = "m-count-container";
      const vehicleDesc = document.createElement("div");
      let vehDesc = "";
      let showDesc = "";
      if (this.isVehicle) {
        showDesc = this.getVehicles.find(
          vehicle => vehicle.type_id === this.selectedAssetType.id
        );
        if (!showDesc) return;
        vehDesc = showDesc.device_model.replace(/[^\w\s]/gi, "");
        this.selectedVehicleModel = vehDesc;
      } else {
        vehDesc = this.selectedAssetTypeName;
      }
      if (!isNull(vehDesc)) {
        vehicleDesc.innerHTML = `<center>${vehDesc}</center>`;
      }
      if (status.available > 0 && !isEmpty(status.header.available)) {
        this.heightCalendar = 800;
        if (!isCancel) this.$vuetify.goTo(this.target, this.scrollOptions);
        this.isShowCalendar = true;
        this.alertState = false;
        this.$nextTick(() => {
          if (isEmpty(this.dataEdit)) {
            const startTime = this.userStartWorkingTime ? this.userStartWorkingTime : '06:00';
            if (this.$refs.calendars) {
              this.$refs.calendars.scrollToTime(startTime);
            }
          }
        });
        const pt = document.createElement("div");
        pt.className = "m-count m-count-available";
        pt.innerHTML = status.available;
        if (!isEmpty(status.header.available)) {
          if (this.completelyNoData) this.completelyNoData = false;
          // const prependList = ['457', '459', '483'];
          const prependList = [];
          const key = this.isVehicle ? "id" : "id";
          let result = status.header.available
            .map(value => value[key])
            .filter((item, index, self) => self.indexOf(item) === index)
            .sort((a, b) => +a - +b);
          result = result.filter(item => !prependList.includes(item));
          this.categoriesAll = [...prependList, ...result];
          this.calendarKey += 1;
          const isService = status.header.available.filter(
            avail => avail.is_service == true
          );
          if (!isEmpty(isService)) {
            this.$nextTick(() => {
              const el = this.$refs.calendars.$el.querySelectorAll(
                ".v-calendar-daily_head-day"
              );
              el.forEach((header, index) => {
                if (header.style.display != "none") {
                  const elDate = header.getElementsByClassName(
                    "v-calendar-daily_head-day-label"
                  )[0];
                  const dateLabel = elDate.querySelector("div:first-child")
                    .innerText ? elDate.querySelector("div:first-child").innerText : "";
                  const formatLabel = moment(dateLabel).format("YYYY-MM-DD");
                  const formatServiceDate = moment(
                    isService[0].service_detail.start_date
                  ).format("YYYY-MM-DD");
                  const formatServiceDateEnd = moment(
                    isService[0].service_detail.end_date
                  ).format("YYYY-MM-DD");
                  if (formatLabel === formatServiceDate) {
                    const elCat = header.getElementsByClassName(
                      "v-calendar-category__columns"
                    )[0];
                    const catLabel = elCat.getElementsByClassName(
                      `v-calendar-category__column-header`
                    );
                    catLabel.forEach((header2, index2) => {
                      const bodyElements = catLabel[index2].querySelector(
                        `.name-category`
                      ).innerText ? catLabel[index2].querySelector(
                        `.name-category`
                      ).innerText : "";
                      const vehName = isService[0].device_name;
                      if (bodyElements === vehName) {
                        const elementIdx = index + 2;
                        header2.style.background = "#FFB085";
                        const bodyElement = header.parentNode.parentNode.querySelector(
                          `.v-calendar-daily__day:nth-child(${elementIdx})`
                        );
                        const body = bodyElement.querySelector(
                          "div:last-child"
                        );
                        const cat = body.getElementsByClassName(
                          "v-calendar-category__column"
                        );
                        cat[index2].style.background = "#FFB085";
                      }
                    });
                  } else if (formatLabel === formatServiceDateEnd) {
                    const elCat = header.getElementsByClassName(
                      "v-calendar-category__columns"
                    )[0];
                    const catLabel = elCat.getElementsByClassName(
                      `v-calendar-category__column-header`
                    );
                    catLabel.forEach((header2, index2) => {
                      const bodyElements = catLabel[index2].querySelector(
                        `.name-category`
                      ).innerText ? catLabel[index2].querySelector(
                        `.name-category`
                      ).innerText : "";
                      const vehName = isService[0].device_name;
                      if (bodyElements === vehName) {
                        const elementIdx = index + 2;
                        header2.style.background = "#FFB085";
                        const bodyElement = header.parentNode.parentNode.querySelector(
                          `.v-calendar-daily__day:nth-child(${elementIdx})`
                        );
                        const body = bodyElement.querySelector(
                          "div:last-child"
                        );
                        const cat = body.getElementsByClassName(
                          "v-calendar-category__column"
                        );
                        cat[index2].style.background = "#FFB085";
                      }
                    });
                  }
                }
              });
            });
          }
          if (this.categoriesAll.length > 3 && this.selectedView.value != 'day') {
            this.isMore = true;
            this.categories = this.categoriesAll.slice(0, 4);
            this.categoriesFour = this.categoriesAll.slice(0, 4);
          } else {
            this.categories = this.categoriesAll;
            this.categoriesFour = this.categoriesAll;
          }

          pt.onclick = () => {
            // this.page = "form";
            this.status = status;
            this.disabledSelection = false;
            this.handleInitBookingData();
          };
          countContainer.appendChild(pt);
        }
      } else if (
        !isEmpty(status.header.available) &&
        !isEmpty(status.schedules)
      ) {
        this.heightCalendar = 800;
        if (this.completelyNoData) this.completelyNoData = false;
        if (!isCancel) this.$vuetify.goTo(this.target, this.scrollOptions);
        this.isShowCalendar = true;
        this.alertState = false;
        const pt = document.createElement("div");
        pt.className = "m-count m-count-available";
        pt.innerHTML = status.available;
        if (!isEmpty(status.header.available)) {
          // const prependList = ['457', '459', '483'];
          const prependList = [];
          const key = this.isVehicle ? "id" : "id";
          let result = status.header.available
            .map(value => value[key])
            .filter((item, index, self) => self.indexOf(item) === index)
            .sort((a, b) => +a - +b);
          result = result.filter(item => !prependList.includes(item));
          this.categoriesAll = [...prependList, ...result];
          this.calendarKey += 1;
          if (this.categoriesAll.length > 4) {
            this.isMore = true;
            this.categories = this.categoriesAll.slice(0, 4);
            this.categoriesFour = this.categoriesAll.slice(0, 4);
          } else {
            this.categories = this.categoriesAll;
            this.categoriesFour = this.categoriesAll;
          }

          pt.onclick = () => {
            // this.page = "form";
            this.status = status;
            this.disabledSelection = false;
            this.handleInitBookingData();
          };
          countContainer.appendChild(pt);
        }
      } else if (
        status.available == 0 &&
        isEmpty(status.schedules) &&
        this.completelyNoData
      ) {
        this.heightCalendar = 0;
        this.categories = [];
        this.isShowCalendar = false;
        this.setAlertState(
          "error",
          "There is no available vehicle. Please select another group",
          true
        );
      } else if (status.available == 1 && isEmpty(status.schedules)) {
        this.heightCalendar = 0;
        this.isShowCalendar = false;
        this.categories = [];
        this.setAlertState(
          "error",
          "There is no available vehicle. Please select another group",
          true
        );
      }
      // header.appendChild(countContainer);
      // header.appendChild(vehicleDesc);
    },
    getSchedulePosition(schedule) {
      const startHour = parseInt(schedule.start.split(":")[0], 10);
      const startMin = parseInt(schedule.start.split(":")[1], 10);
      const endHour = parseInt(schedule.end.split(":")[0], 10);
      const endMin = parseInt(schedule.end.split(":")[1], 10);

      const startIdx = startHour + (startMin > 0 ? startMin / 60 : 0);
      const endIdx = endHour + (endMin > 0 ? endMin / 60 : 0);
      const top = 48 * startIdx;
      const height = 48 * (endIdx - startIdx);
      return { top, height };
    },
    createScheduleCalendar(day, schedule, i) {
      const isEdit = !isEmpty(this.dataEdit);
      const isSameStartDate = this.dataEdit.start_datetime == schedule.detail.start_datetime;
      const isSameEndDate = this.dataEdit.end_datetime == schedule.detail.end_datetime;
      const currentEdited = isEdit && isSameStartDate && isSameEndDate;
      if (!currentEdited) {
        if (this.isVehicle) {
          if (schedule.detail.status == "1") {
            this.events.push({
              id: schedule.detail.id,
              name: "Need Action",
              color: "warning",
              start: new Date(schedule.detail.start_datetime).getTime(),
              end: new Date(schedule.detail.end_datetime).getTime(),
              category: schedule.detail.vehicle_id,
              timed: true,
              details: schedule
            });
          } else {
            let currentPassenger = schedule.detail.passenger.find(
              p => p.username == this.$store.state.user.user.username
            );
            if (
              schedule.detail.passenger.length == 1 &&
              !isUndefined(currentPassenger)
            ) {
              this.events.push({
                id: schedule.detail.id,
                name: "Approved",
                color: "green",
                start: new Date(schedule.detail.start_datetime).getTime(),
                end: new Date(schedule.detail.end_datetime).getTime(),
                category: schedule.detail.vehicle_id,
                timed: true,
                details: schedule
              });
            } else if (isUndefined(currentPassenger)) {
              this.events.push({
                id: schedule.detail.id,
                title: `Booked By ${schedule.detail.passenger[0].first_name}${
                  schedule.detail.passenger[0].last_name ? 
                    ` ${schedule.detail.passenger[0].last_name}` : ""
                }`,
                name: "Approved",
                color: "light-green",
                start: new Date(schedule.detail.start_datetime).getTime(),
                end: new Date(schedule.detail.end_datetime).getTime(),
                category: schedule.detail.vehicle_id,
                timed: true,
                details: schedule
              });
            } else if (
              schedule.detail.passenger.length > 1 &&
              !isUndefined(currentPassenger) &&
              currentPassenger.is_owner
            ) {
              this.events.push({
                id: schedule.detail.id,
                name: "Approved",
                color: "cyan",
                start: new Date(schedule.detail.start_datetime).getTime(),
                end: new Date(schedule.detail.end_datetime).getTime(),
                category: schedule.detail.vehicle_id,
                timed: true,
                details: schedule
              });
            } else {
              this.events.push({
                id: schedule.detail.id,
                name: "Approved",
                color: "blue",
                start: new Date(schedule.detail.start_datetime).getTime(),
                end: new Date(schedule.detail.end_datetime).getTime(),
                category: schedule.detail.vehicle_id,
                timed: true,
                details: schedule,
                draggable: false
              });
            }
          }
        } else {
          if (schedule.detail.status == "1") {
            this.events.push({
              id: schedule.detail.id,
              name: "Need Action",
              color: "warning",
              start: new Date(schedule.detail.start_datetime).getTime(),
              end: new Date(schedule.detail.end_datetime).getTime(),
              category: schedule.detail.asset_id,
              timed: true,
              details: schedule
            });
          } else {
            if (schedule.detail.passenger.length == 1) {
              const item = this.assetTypes.find(
                d => d.id == this.selectedAssetType.id
              );
              this.events.push({
                id: schedule.detail.id,
                name: "Approved",
                color: get(item, "metadata.calendar_color", "#914f07"),
                start: new Date(schedule.detail.start_datetime).getTime(),
                end: new Date(schedule.detail.end_datetime).getTime(),
                category: schedule.detail.asset_id,
                timed: true,
                details: schedule
              });
            }
          }
        }
      }
      if (isUndefined(day)) return;
      const dayContainer = document.createElement("div");
      dayContainer.className = "v-event-timed-container";
      const gap = 3;
      const typeClass = {
        booked: "info",
        done: "error"
      };
      const left = (i + 1) * gap + i * 8;
      const pos = this.getSchedulePosition(schedule);
      const line = document.createElement("div");
      line.className = `v-event-timed white--text m-schedule-time ${
        typeClass[schedule.type]
      }`;
      line.style.top = `${pos.top}px`;
      line.style.left = `${left}px`;
      line.style.height = `${pos.height}px`;

      line.onclick = () => {
        this.dialog.open = true;
        this.dialog.data = schedule;
        // eslint-disable-next-line no-console
        if (this.isVehicle) {
          let metadata = {};
          let vehicle_seat = "";
          const vehInfo = this.getVehicles.find(
            vehicle => vehicle.id === this.dialog.data.detail.vehicle_id
          );
          metadata = vehInfo.metadata;
          if (metadata.hasOwnProperty("seat_count")) {
            vehicle_seat = parseInt(metadata.seat_count);
          }
          const passengers = [];
          // eslint-disable-next-line no-unused-vars
          this.dialog.data.detail.passenger.forEach((passenger, i) => {
            passengers.push(parseInt(passenger.passenger_count));
          });
          let sumPassenger = sum(passengers);
          this.availableSeat = vehicle_seat - sumPassenger;
        }
      };
      dayContainer.appendChild(line);
      day.appendChild(dayContainer);
    },
    createSchedulePeriod(day, period, i, item) {
      if (isUndefined(day)) return;
      const mp = { ...period };
      const dayContainer = document.createElement("div");
      dayContainer.className = "v-event-timed-container";
      const gap = 3;
      // eslint-disable-next-line no-console
      mp.startHour = parseInt(moment(mp.start).format("H"));
      mp.endHour = parseInt(
        moment(mp.end)
          .subtract(1, "hours")
          .format("H")
      );
      mp.start = moment(mp.start).format("HH:mm");
      mp.end = moment(mp.end).format("HH:mm");
      const left = (i + 1) * gap + i * 8;
      const pos = this.getSchedulePosition(mp);
      const line = document.createElement("div");
      line.className = `v-event-timed white--text m-schedule-time success`;
      line.style.top = `${pos.top}px`;
      line.style.left = `${left}px`;
      line.style.height = `${pos.height}px`;
      dayContainer.appendChild(line);
      const getKeysPeriod = Object.keys(item.available_at_periode);
      const categoryVeh = this.getVehicles.find(
        vehicle => vehicle.id === getKeysPeriod[0]
      );

      this.events.push({
        id: item.schedules[0].detail.id,
        name: "Period",
        color: "green",
        start: new Date(period.start).getTime(),
        end: new Date(period.end).getTime(),
        category: categoryVeh.id,
        timed: true,
        isGreen: {
          item: item,
          period: mp
        }
      });

      line.onclick = () => {
        this.isPeriod = true;
        this.page = "form";
        this.disabledSelection = false;
        this.handleClickGreenBookingData(item, mp);
      };

      day.appendChild(dayContainer);
    },
    handleClickBack(isCancel = false) {
      if (this.selectedView.value == 'week' && !this.isMore) {
        this.selectedOpen = false;
        return;
      }

      this.selectedEvent = {};

      if (this.selectedView.value === 'day') {
        this.categoryDays = 1;
      } else {
        this.isMore = true;
        this.isBack = false;
        this.focus = this.calendar.start;
        this.categoryDays = 7;
        this.categories = this.categoriesFour;
      }

      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.createEnd = null;
      this.extendOriginal = null;
      this.selectedOpen = false;
      this.page = "booking";
      this.keepSilent = false;
      this.dialogs.open = false;
      this.events = [];
      this.isPeriod = false;
      this.calendar.page = "line";
      this.createLineAndCounterCalendar(isCancel);
      this.start_time = "";
      this.end_time = "";
      this.dataEdit.end_datetime = "";

      if (!isEmpty(this.dataEdit)) {
        window.location.href = `${process.env.VUE_APP_CARPOOLING_URL}/#/booking_list`;
      }

      this.calendarComponent = null
      this.$nextTick(() => {
        this.calendarKey += 1
        this.calendarComponent = 'v-calendar'
      })
    },
    // Two windows clash whenever they intersect at all: one starts before the
    // other ends and ends after the other starts. The checks in this file used
    // to ask only whether one of the new booking's own edges landed inside an
    // existing booking, so a window that swallowed a shorter booking whole --
    // 08:30-15:30 over an existing 09:30-12:00 -- matched nothing and looked
    // free. INT-004972.
    rangesOverlap(startA, endA, startB, endB) {
      return startA.isBefore(endB) && endA.isAfter(startB);
    },
    // Every schedule loaded for one vehicle or asset, deduplicated by booking
    // id: a booking that spans days is repeated under each date it covers.
    // Rejected bookings (status 3) no longer hold the vehicle, and the booking
    // being edited must not be counted as a clash with itself.
    getSchedulesForAsset(assetId, excludeId = null) {
      const collected = [];
      const seen = {};
      if (!assetId || !Array.isArray(this.books)) return collected;
      this.books.forEach(book => {
        const schedules = get(book, "schedules", []);
        if (!Array.isArray(schedules)) return;
        schedules.forEach(schedule => {
          const detail = get(schedule, "detail");
          if (!detail) return;
          const scheduleAssetId = detail.vehicle_id
            ? detail.vehicle_id
            : detail.asset_id;
          if (parseInt(scheduleAssetId) !== parseInt(assetId)) return;
          if (String(detail.status) === "3") return;
          if (
            excludeId &&
            detail.id &&
            parseInt(detail.id) === parseInt(excludeId)
          ) {
            return;
          }
          if (detail.id) {
            if (seen[detail.id]) return;
            seen[detail.id] = true;
          }
          collected.push(schedule);
        });
      });
      return collected;
    },
    // The first booking on this vehicle/asset that the given window runs into,
    // or null. Compares whole datetimes rather than times of day so overnight
    // bookings are read correctly.
    findClashingSchedule(assetId, startDateTime, endDateTime, excludeId = null) {
      if (!startDateTime || !endDateTime) return null;
      const start = moment(startDateTime);
      const end = moment(endDateTime);
      if (!start.isValid() || !end.isValid()) return null;
      const schedules = this.getSchedulesForAsset(assetId, excludeId);
      for (let i = 0; i < schedules.length; i += 1) {
        const detail = schedules[i].detail;
        const otherStart = moment(detail.start_datetime);
        const otherEnd = moment(detail.end_datetime);
        if (!otherStart.isValid() || !otherEnd.isValid()) continue;
        if (this.rangesOverlap(start, end, otherStart, otherEnd)) {
          return schedules[i];
        }
      }
      return null;
    },
    // The first booked service on this vehicle that the given window runs into.
    findClashingService(vehicleId, startDateTime, endDateTime) {
      if (!startDateTime || !endDateTime) return null;
      if (!Array.isArray(this.vehicleServices)) return null;
      const start = moment(startDateTime);
      const end = moment(endDateTime);
      if (!start.isValid() || !end.isValid()) return null;
      for (let i = 0; i < this.vehicleServices.length; i += 1) {
        const service = this.vehicleServices[i];
        if (
          vehicleId &&
          parseInt(service.vehicle_id) !== parseInt(vehicleId)
        ) {
          continue;
        }
        const serviceStart = moment(service.start_date);
        const serviceEnd = moment(service.end_date);
        if (!serviceStart.isValid() || !serviceEnd.isValid()) continue;
        if (this.rangesOverlap(start, end, serviceStart, serviceEnd)) {
          return service;
        }
      }
      return null;
    },
    clashedLabel(start, end) {
      const startMoment = moment(start);
      const endMoment = moment(end);
      if (!startMoment.isValid() || !endMoment.isValid()) return "";
      return `${startMoment.format("DD/MM/YYYY hh:mm A")} - ${endMoment.format(
        "DD/MM/YYYY hh:mm A"
      )}`;
    },
    getSecondWorkOrderWindow() {
      return {
        start: `${this.booking.date} ${this.create_start_time2}`,
        end: `${this.booking.end_date} ${this.create_end_time2}`
      };
    },
    getOverlappedBooking() {
      const secondWindow = this.getSecondWorkOrderWindow();
      // Reading the schedules rather than the calendar events keeps this to the
      // one vehicle being booked; `events` holds every category on screen plus
      // the grey placeholder for the booking being created.
      return this.findClashingSchedule(
        this.isTypeVehicle ? this.booking.vehicle : this.booking.asset,
        secondWindow.start,
        secondWindow.end,
        get(this.dataEdit, "id", null)
      );
    },
    getOverlappedService() {
      const secondWindow = this.getSecondWorkOrderWindow();
      // This used to build a result and never return it, so the caller's
      // service check could not fire at all.
      return this.findClashingService(
        this.booking.vehicle,
        secondWindow.start,
        secondWindow.end
      );
    },
    handleLicenseDialog() {
      if (this.$refs.create_booking.validate()) {

        const startBookingDate = moment(
          this.booking.date + " " + this.start_time,
          "YYYY-MM-DD HH:mm"
        );

        const endBookingDate = moment(
          this.booking.end_date + " " + this.end_time,
          "YYYY-MM-DD HH:mm"
        );

        if (endBookingDate.isBefore(startBookingDate)) {
          this.$swal({
            icon: "error",
            title: "Not Allowed",
            text: "End time must be greater than start time"
          });
          return;
        }

        if (this.isSecondWorkOrder) {
          const overlappedBooking = this.getOverlappedBooking();
          if (overlappedBooking) {
            this.$swal({
              icon: "error",
              title: "Not Allowed",
              text: "There is an overlapping booking with second work order. Please check the booking list."
            });
            return;
          }

          const overlappedService = this.getOverlappedService();
          if (overlappedService) {
            this.$swal({
              icon: "error",
              title: "Not Allowed",
              text: "There is an overlapping service with second work order. Please check the booking list."
            });
            return;
          }

          const startSecondWorkOrder = moment(
            this.booking.date + " " + this.create_start_time2,
            "YYYY-MM-DD HH:mm"
          );

          const endSecondWorkOrder = moment(
            this.booking.end_date + " " + this.create_end_time2,
            "YYYY-MM-DD HH:mm"
          );

          if (endSecondWorkOrder.isBefore(startSecondWorkOrder)) {
            this.$swal({
              icon: "error",
              title: "Not Allowed",
              text: "End time of second work order must be greater than start time"
            });
            return;
          }
        }

        if (this.isElectricVehicle && !this.bookingOtherUser) {
          this.videoConfirm = false;
          this.videoDialog = true;
        } else if (this.isVehicle && !this.bookingOtherUser) {
          this.licenseDialog = true;
        } else if (this.isElectricWollongong) {
          this.licenseDialog = true;
        } else {
          this.bookingOverview = true;
        }
      }
    },
    getRecurring(data) {
      let recurring = "";
      let recurring_info = get(data.metadata, "recurring_info", {});
      if (!isEmpty(recurring_info)) {
        if (recurring_info.hasOwnProperty("end_after")) {
          recurring = `${data.metadata.recurring_info.crontab}, ${
            data.metadata.recurring_info.end_after
          } occurance`;
        } else {
          recurring = `${data.metadata.recurring_info.crontab}`;
        }
      }
      return recurring;
    },
    getCostCode(data) {
      let costCode = get(data.metadata, "cost_code", "-");
      return costCode;
    },
    getWorkOrder(data) {
      let workOrder = get(data.metadata, "work_order", "-");
      return workOrder;
    },
    getSecondWorkOrder(data) {
      const originalEnd = get(data.metadata, "original_end_time", "");
      const second = get(data.metadata, "second_work_order", "");
      if (originalEnd && second) return second;
      return "-";
    },
    getSecondWorkOrderPeriod(data) {
      const start = get(data.metadata, "start_second_work_order", "");
      const end = get(data.metadata, "end_second_work_order", "");
      if (!start || !end) return "";
      const s = moment(start).format("HH:mm");
      const e = moment(end).format("HH:mm");
      return `${s} — ${e}`;
    },
    getPurposeOfTrip(data) {
      let purposeOfTrip = get(data.metadata, "purpose_of_trip", "-");
      return purposeOfTrip;
    },
    getClientName(data) {
      let clientName = get(data.metadata, "client_name", "-");
      return clientName;
    },
    getPeriodDisplay(dialogData) {
      // dialogData: { start: 'HH:mm', end: 'HH:mm', detail: { start_datetime, end_datetime, metadata } }
      try {
        const metadata = get(dialogData, 'detail.metadata', {});
        const originalEnd = get(metadata, 'original_end_time', '');
        if (originalEnd) {
          // When second work order exists, backend sets original_end_time as first WO end datetime
          const start = get(dialogData, 'detail.start_datetime', '');
          const s = start ? moment(start).format('HH:mm') : get(dialogData, 'start', '');
          const e = moment(originalEnd).format('HH:mm');
          if (s && e) return `${s} - ${e}`;
        }
      } catch (e) {}
      // fallback to default period already computed for the event
      return `${get(dialogData, 'start', '')} - ${get(dialogData, 'end', '')}`;
    },
    getDestination(data) {
      let destination = "";
      let stopFind = false;
      if (data.end_geofence_id != 0 && !isEmpty(data.end_geofence_id)) {
        this.geofences[this.$store.state.clientid].forEach(group => {
          if (stopFind === false) {
            const geofenceDestination = group.geofences.find(
              geofence =>
                parseInt(geofence.Id) === parseInt(data.end_geofence_id)
            );
            if (!isUndefined(geofenceDestination)) {
              destination = geofenceDestination.name;
              stopFind = true;
            }
          }
        });
      } else if (data.metadata) {
        if (typeof data.metadata === "string") {
          try {
            data.metadata = JSON.parse(data.metadata);
          } catch (e) {
            data.metadata = [];
          }

          if (data.metadata === null) data.metadata = [];
        }
        destination = getBookingDestinationText(data.metadata) ||
          `${data.start_longitude},${data.end_longitude}`;
      } else if (isNull(data.end_geofence_id)) {
        destination = JSON.parse(data.metadata);
      } else {
        destination = data.address;
      }
      return destination;
    },
    getCategoryNames(id) {
      if (!id) return "";
      if (!isEmpty(id) || !isNull(id)) {
        if (this.isVehicle) {
          const status = this.getVehicles.find(vehicle => vehicle.id === id);
          if (!status) {
            return ["", "", ""];
          }
          if (this.isDarwin) {
            const categories = []
            if (status.metadata.hasOwnProperty('plant_no')) categories.push(status.metadata.plant_no)
            return categories.concat([
              status.device_make,
              status.device_model.replace(/[^\w\s]/gi, ""),
              status.device_plate,
            ])
          }
          if (!status.metadata) status.metadata = {features: {}};
          const babySeat = status.metadata.features.hasOwnProperty("baby_seat")
            ? this.getValueAsBoolean(status.metadata.features.baby_seat)
            : 0;
          const childCapsule = status.metadata.features.hasOwnProperty("child_capsule")
            ? this.getValueAsBoolean(status.metadata.features.child_capsule)
            : 0;
          const roofRack = status.metadata.features.hasOwnProperty("roof_rack")
            ? this.getValueAsBoolean(status.metadata.features.roof_rack)
            : 0;
          return [
            status.device_name,
            status.device_make,
            status.device_model.replace(/[^\w\s]/gi, ""),
            roofRack,
            babySeat,
            childCapsule,
          ];
        } else {
          const status = this.dataAssets.find(asset => asset.id === id);
          if (!status) {
            return ["", "", ""];
          }
          return [
            status.number,
            status.number,
            status.number.replace(/[^\w\s]/gi, "")
          ];
        }
      }
    },
    getCategoryName(id) {
      if (this.isVehicle) {
        const status = this.status.header.booked.find(
          vehicle => vehicle.id === id
        );
        return [
          status.device_name,
          status.type_name,
          status.device_make,
          status.device_model.replace(/[^\w\s]/gi, "")
        ];
      } else {
        const status = this.status.header.booked.find(asset => asset.id === id);
        return [status.number, status.type];
      }
    },
    formatDate(date, format = "YYYY-MM-DD") {
      return moment(date).format(format);
    },
    next() {
      this.$nextTick(() => {
        this.$refs.category.next();
      });
    },
    handleClickDialogOutside() {
      this.dialog.open = false;
      this.showNewPass = false;
      this.disableShareRide = false;
    },
    isShowTable() {
      this.showNewPass = true;
      this.isShared = false;
    },
    handleInitBookingData(header = "available") {
      this.passengerCount = 0;
      this.booking.date = this.status.date;
      if (this.isVehicle) {
        this.booking.vehicleOptions = this.status.header[header];

        if (this.booking.vehicleOptions.length) {
          this.booking.vehicle = this.booking.vehicleOptions[0]["id"];
        }
      } else {
        this.booking.assetOptions = this.status.header[header];
        if (this.booking.assetOptions.length) {
          this.booking.asset = this.booking.assetOptions[0]["id"];
        }
      }
    },
    handleClickGreenBookingData(item, period) {
      this.booking.isGreen = true;
      this.booking.date = item.date;
      this.passengerCount = 0;
      this.time_range = [period.startHour, period.endHour];
    },
    handleClickCategory(category) {
      return;
      // eslint-disable-next-line no-unreachable
      this.page = "form";
      this.booking.disabledSelection = true;
      if (this.isVehicle) {
        this.booking.vehicle = category;
      } else {
        this.booking.asset = category;
      }
    },
    handleClickEvent(event) {
      this.dialog.open = true;
      this.dialog.data = event.schedule;
    },
    handleClickSave() {
      if (this.$refs.create_booking.validate()) {
        if (this.submitBooking) return;
        this.submitBooking = true;
        this.passengerCount = this.optionPassengerCount;
        if (isEmpty(this.start_time) || isEmpty(this.end_time)) {
          this.startTimeRequired = true;
          this.endTimeRequired = true;
        } else if (
          this.passengerCount > this.getMaxSeatCount &&
          this.isVehicle
        ) {
          this.passengerValidation = true;
        } else {
          let destination = {};
          let metadata = {};
          const destinationSelected = get(this.destination, "selected", {}) || {};

          if (destinationSelected.hasOwnProperty('address')) {
            metadata = {
              address: this.destination.selected["address"],
              address_id: this.destination.selected["id"]
            };
          } else if (!isEmpty(this.selectedPopularData)) {
            const addressPopular = get(this.selectedPopularData, "address", "");
            if (!isEmpty(addressPopular)) {
              metadata = {
                address: addressPopular
              };
            }
          }

          if (!isEmpty(destinationSelected)) {
            if (destinationSelected.hasOwnProperty("Id")) {
              destination["type"] = "geofence";
              destination["geofence_id"] = this.destination.selected["Id"];
            } else if (!isEmpty(this.selectedPopularData)) {
              if (!isUndefined(this.selectedPopularData)) {
                destination["type"] = "popular";
                destination["latitude"] = this.selectedPopularData.latitude;
                destination["longitude"] = this.selectedPopularData.longitude;
              }
            } else {
              destination["type"] = "address";
              destination["latitude"] = this.destination.selected["lat"];
              destination["longitude"] = this.destination.selected["lng"];
            }
          }

          let data = {};
          let dateTime = "";
          let sharedDefault = null;
          if (!this.isRecurring) {
            if (this.isSecondWorkOrder) {
              dateTime = `${this.booking.end_date} ${this.create_end_time2}`;
            } else {
              dateTime = `${this.booking.end_date} ${this.end_time}`;
            }
          } else {
            dateTime = `${moment(this.booking.end_date).format("YYYY-MM-DD")} ${
              this.end_time
            }`;
          }
          if (this.sharedVehicle) {
            sharedDefault = 1;
          }

          if (this.isVehicle) {
            if (this.videoConfirm) metadata.confirm_watched_video = true;
            if (destination.type == "geofence") {
              data = {
                user_id: this.$store.state.user.user.id,
                passenger_count: this.passengerCount,
                total_seat: 5,
                start_datetime: `${this.booking.date} ${this.start_time}`,
                end_datetime: dateTime,
                shared: sharedDefault,
                start_geofence_id: this.origin_id,
                end_geofence_id: destination.geofence_id,
                metadata: metadata,
                vehicle_id: this.booking.vehicle,
                send_email: 1
              };
            } else if (
              destination.type == "address" ||
              destination.type == "popular"
            ) {
              data = {
                user_id: this.$store.state.user.user.id,
                passenger_count: this.passengerCount,
                total_seat: 5,
                start_datetime: `${this.booking.date} ${this.start_time}`,
                end_datetime: dateTime,
                shared: sharedDefault,
                start_geofence_id: this.origin_id,
                end_longitude: destination.longitude,
                end_latitude: destination.latitude,
                metadata: metadata,
                vehicle_id: this.booking.vehicle,
                send_email: 1
              };
            } else {
              data = {
                user_id: this.$store.state.user.user.id,
                passenger_count: this.passengerCount,
                total_seat: 5,
                start_datetime: `${this.booking.date} ${this.start_time}`,
                end_datetime: dateTime,
                shared: sharedDefault,
                start_geofence_id: this.origin_id,
                metadata: metadata,
                vehicle_id: this.booking.vehicle,
                send_email: 1
              };
            }
          } else if (!this.isTypeVehicle) {
            metadata = {
              address: ""
            };
            data = {
              user_id: this.$store.state.user.user.id,
              passenger_count: this.passengerCount,
              total_seat: 5,
              start_datetime: `${this.booking.date} ${this.start_time}`,
              end_datetime: dateTime,
              shared: sharedDefault,
              start_geofence_id: this.origin_id,
              metadata: metadata,
              asset_id: this.booking.asset,
              send_email: 1
            };
          }
          if (this.isRecurring) {
            data.recurring = 1;
            if (this.radios == "endAfter") {
              metadata.recurring_info = {
                crontab: this.booking.recurring,
                end_after: this.booking.recurring_end
              };
            } else {
              metadata.recurring_info = {
                crontab: this.booking.recurring,
                end_by: this.booking.recurring_endBy
              };
            }
          }
          if (this.bookingOtherUser) {
            (data.book_for_other = 1),
              (data.book_for_user_id = this.selectedOtherUser);
          }
          metadata.booking_detail = {
            asset_type: this.selectedAssetType.id,
            group_id: this.isAdmin
              ? this.selectedVehicleGroup.id
              : this.selectedVehicleGroup.group_id
          };
          if (this.isIntimap || this.isWSP) {
            if (!this.isRecurring) {
              if (this.isSecondWorkOrder) {
                metadata.original_end_time = `${this.booking.end_date} ${this.end_time}`;
                metadata.second_work_order = this.workOrder2.code;
                metadata.start_second_work_order = this.booking.date + " " + this.create_start_time2;
                metadata.end_second_work_order = this.booking.end_date + " " + this.create_end_time2;
              }
            }
          }
          if (!isEmpty(this.dataEdit)) {
            data.id = this.dataEdit.id;
            data.user_id = this.dataEdit.book_user.user_id;
          }
          if (!isEmpty(this.costCode)) {
            metadata.cost_code = this.costCode;
          }
          if (!isEmpty(this.workOrder)) {
            metadata.work_order = this.workOrder.code;
          }
          if (!isEmpty(this.purposeOfTrip)) {
            metadata.purpose_of_trip = this.purposeOfTrip;
          }
          if (this.isFBT) {
            metadata.fbt = 1;
            metadata.fbt_selected_dates = this.fbtSelectedDates;
          }
          if (!isEmpty(this.clientName)) {
            metadata.client_name = this.clientName;
          }
          if (this.selectedVariousLocation) {
            metadata.various_location = "1";
            metadata.various_destination = this.hasStructuredVariousDestination
              ? this.variousDestinationList
              : this.variousDestination;
          }
          if (this.isIntimap || this.isWSP) {
            metadata.passenger_list = this.passengerList;
          }

          const selectedBook = this.books.filter(book => {
            return book.schedules.find(schedule => {
              const scheduleEndDate = moment(schedule.detail.end_datetime);
              const endDateTime = moment(data.end_datetime)
              return (
                schedule.detail.vehicle_id == data.vehicle_id &&
                scheduleEndDate.isSameOrBefore(endDateTime)
              );
            });
          });

          if (selectedBook.length) {
            const selectedLastBook = selectedBook[selectedBook.length - 1];
            const previousSchedule = selectedLastBook.schedules.filter(schedule => {
              const scheduleEndDate = moment(schedule.detail.end_datetime);
              const endDateTime = moment(data.end_datetime)
              return (
                scheduleEndDate.isSameOrBefore(endDateTime)
              );
            });

            if (previousSchedule.length) {
              let lastPreviousSchedule = {};
              let lastDiff = 0;

              for (let i = 0; i < previousSchedule.length; i += 1) {
                if (!lastPreviousSchedule.detail) {
                  lastPreviousSchedule = previousSchedule[i];
                  lastDiff = moment(data.start_datetime).diff(
                    moment(previousSchedule[i].detail.end_datetime),
                    "minutes"
                  );
                } else {
                  const diff = moment(data.start_datetime).diff(
                    moment(previousSchedule[i].detail.end_datetime),
                    "minutes"
                  );
                  if (diff < lastDiff) {
                    lastPreviousSchedule = previousSchedule[i];
                    lastDiff = diff;
                  }
                }
              }

              const diffFromPrevious = moment(data.start_datetime).diff(
                moment(lastPreviousSchedule.detail.end_datetime),
                "minutes"
              );

              // if (diffFromPrevious < 60 && this.isWollongong) {
              //   this.$swal({
              //     icon: "error",
              //     title: "Booking Unsuccessful",
              //     text: "There is a booking time clash or the 1 hour gap between each booking is not met."
              //   });
              //   this.dialog.open = false;
              //   this.showBookingOverview2 = false;
              //   this.bookingOverview = false;
              //   return;
              // }
            }
          }

          let responseCreate = null;

          if (this.isIntimap || this.isWSP) {
            const timezone = this.getTimezoneDepot(this.origin_id);
            if (timezone) {
              data.depot_timezone = timezone;
            }
            if (!this.isRecurring) {
              if (this.isSecondWorkOrder) {
                metadata.start_second_work_order = this.booking.date + " " + this.create_start_time2;
                metadata.end_second_work_order = this.booking.end_date + " " + this.create_end_time2;
              }
            }
          }

          if (this.isAdvanceBookingRequireApproval) {
            const hoursInAdvance = moment(data.start_datetime).diff(moment(), 'hours');
            if (hoursInAdvance > this.advanceBookingHoursThreshold) {
              data.need_approval = 1;
            }
          }

          // Until this landed the form ran no clash check of its own on submit:
          // the working-time, past-time and duration rules were the whole of it,
          // and the only thing standing between two bookings on one vehicle was
          // the backend's own check. A window that swallowed a shorter booking
          // whole got past both. INT-004972.
          const clashedSchedule = this.findClashingSchedule(
            data.vehicle_id ? data.vehicle_id : data.asset_id,
            data.start_datetime,
            data.end_datetime,
            get(this.dataEdit, "id", null)
          );
          if (clashedSchedule) {
            this.submitBooking = false;
            this.$swal({
              icon: "error",
              title: "Booking Time Clash",
              text: `This ${
                this.isTypeVehicle ? "vehicle" : "asset"
              } is already booked for ${this.clashedLabel(
                get(clashedSchedule, "detail.start_datetime"),
                get(clashedSchedule, "detail.end_datetime")
              )}. Please choose a time that does not overlap that booking.`
            });
            return;
          }

          if (this.isTypeVehicle) {
            const clashedService = this.findClashingService(
              data.vehicle_id,
              data.start_datetime,
              data.end_datetime
            );
            if (clashedService) {
              this.submitBooking = false;
              this.$swal({
                icon: "error",
                title: "Booking Time Clash",
                text: `This vehicle is booked in for service ${this.clashedLabel(
                  clashedService.start_date,
                  clashedService.end_date
                )}. Please choose a time that does not overlap that service.`
              });
              return;
            }
          }

          // Recurring bookings are exempt: every occurrence is its own
          // single-day booking, so they cannot run past the limit.
          if (
            !this.isRecurring &&
            this.exceedsMaxBookingDays(data.start_datetime, data.end_datetime)
          ) {
            this.submitBooking = false;
            this.$swal({
              icon: "error",
              title: "Booking is too long",
              text: `${this.maxBookingDurationLabel} Please create a new booking for the remaining time.`
            });
            return;
          }

          this.$store
            .dispatch("API_CALL", {
              $method: "create_book",
              $postData: {
                data: data
              }
            })
            .then(response => {
              responseCreate = response;
              this.submitBooking = false;
              if (response.data.code == 200) {
                if (!this.isAdmin && this.isRecurring) {
                  this.showBookingOverview2 = false;
                  this.$swal({
                    icon: "success",
                    title: response.data.data.message,
                    text: "Please wait for admin approval for this booking"
                  });
                  this.$router.push({ path: "/request" });
                } else if (!this.isAdmin && !this.isRecurring) {
                  if (get(response, 'data.data.need_approval', false)) {
                    this.$swal({
                      icon: "success",
                      title: response.data.data.message,
                      text: "Please wait for admin approval for this booking"
                    });
                    this.$router.push({ path: "/request" });
                  } else if (this.isRestrictedBooking) {
                    if (!this.inWorkingDay(data.start_datetime)) {
                      this.$swal({
                        icon: "success",
                        title: response.data.data.message,
                        text: "Please wait for admin approval for this booking"
                      });
                      this.$router.push({ path: "/request" });
                    } else {
                      if (
                        !this.isWithinWorkingTime(
                          this.userStartWorkingTime,
                          this.userEndWorkingTime,
                          data.start_datetime,
                          data.end_datetime
                        )
                      ) {
                        this.$swal({
                          icon: "success",
                          title: response.data.data.message,
                          text:
                            "Please wait for admin approval for this booking"
                        });
                        this.$router.push({ path: "/request" });
                      } else {
                        this.$swal({
                          icon: "success",
                          title: response.data.data.message
                        });
                        this.$router.push({ path: "/booking_list" });
                      }
                    }
                  } else {
                    this.$swal({
                      icon: "success",  
                      title: response.data.data.message
                    });
                    this.$router.push({ path: "/booking_list" });
                  }
                } else {
                  this.showBookingOverview2 = false;
                  this.$swal({
                    icon: "success",
                    title: response.data.data.message
                  });
                  this.$router.push({ path: "/booking_list" });
                }
              } else {
                this.dialog.open = false;
                this.showBookingOverview2 = false;
                this.bookingOverview = false;
                this.$swal({
                  icon: "error",
                  title: "Failed to create book",
                  text: response.data.data.message
                });
                if (!isEmpty(this.dataEdit)) {
                  if (response.data.data.message) {
                    if (response.data.data.message.length) {
                      if (response.data.data.message[0].indexOf('This car already booked') !== -1) {
                        return;
                      }
                    }
                  }
                  this.$router.push({ path: "/booking_list" }); 
                } else {
                  this.handleClickBack(true);
                }
              }
            })
            .catch(error => {
              this.submitBooking = false;
              if (responseCreate.data.code != 200) {
                this.$swal({
                  icon: "error",
                  title: `${error} E00122`
                });
              }
            });
        }
      } else {
        this.$swal({
          icon: "error",
          title: "E000123"
        });
      }
    },
    closeAndShow() {
      this.alertDefaultPwd = false;
      this.changeDefaultPwd = true;
    },
    closeAndClear() {
      this.$refs.form_change_password.reset();
      this.changeDefaultPwd = false;
    },
    updatePassword() {
      if (this.$refs.form_change_password.validate()) {
        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;
        const payloads1 = {
          password: this.newPassword,
          old_password: this.defaultPassword
        };

        this.$store.dispatch("UPDATE_USER_PASSWORD", payloads1).then(() => {
          this.$store.dispatch("SET_UPDATE");
          let responseUpdate = this.$store.getters.getSetUser;
          if (responseUpdate.error) {
            this.loadingUpdate = false;
            this.loader = this.loadingUpdate;
            this.$swal({
              icon: "error",
              title: responseUpdate.message
            }).then(res => {
              if (res.isConfirmed) {
                this.$store.commit("SET_DEFAULT_PASSWORD", true);
                this.changeDefaultPwd = true;
                this.$refs.form_change_password.reset();
              }
            });
          } else {
            let userMetadata = {
              driver_license: {
                conditions: this.$store.state.user.user.metadata.driver_license
                  .conditions,
                expiry_date: this.$store.state.user.user.metadata.driver_license
                  .expiry_date,
                issuing_state: this.$store.state.user.user.metadata
                  .driver_license.issuing_state,
                license_no: this.$store.state.user.user.metadata.driver_license
                  .license_no,
                license_type: this.$store.state.user.user.metadata
                  .driver_license.license_type
              },
              photo: this.$store.state.user.user.metadata.photo,
              default_password: false
            };

            const payloads2 = {
              metadata: userMetadata
            };

            this.$store.commit("SET_DEFAULT_PASSWORD", false);

            this.loadingUpdate = false;
            this.loader = this.loadingUpdate;

            this.$swal({
              icon: "success",
              title: responseUpdate.message
            });

            this.changeDefaultPwd = false;

            this.$store.dispatch("UPDATE_USER", payloads2);
          }
        });
      }
    },
    showBookingOverview() {
      this.videoConfirm = true;
      this.videoDialog = false;
      this.licenseDialog = false;
      this.bookingOverview = true;
    },
    getOriginName(originId) {
      if (originId == null) return;
      const clientId = this.$store.state.clientid;
      const geofenceGroups = this.geofences[clientId];
      if (geofenceGroups == null) return;
      for (const group of geofenceGroups) {
        for (const geofence of group.geofences) {
          if (geofence.Id === originId) {
              return geofence.name;
          }
        }
      }
      return;
    },
    getDestinationAddrs(destSelected, popularData) {
      if (!isEmpty(destSelected)) {
        return destSelected.address;
      } else if (!isEmpty(popularData)) {
        return popularData.address;
      }
    },
    getVehicleName(booking) {
      if (this.isVehicle) {
        const vehicleData = this.listVehicles.find(
          vehicle => vehicle.id == booking.vehicle
        );
        if (vehicleData == null) return;
        return `${vehicleData.device_make} ${vehicleData.device_model.replace(
          /[^\w\s]/gi,
          ""
        )}`;
      } else {
        const assetData = this.booking.assetOptions.find(
          asset => asset.id == booking.asset
        );
        if (assetData == null) return;
        return `${assetData.type} - ${assetData.number}`;
      }
    },
    getDate(date) {
      // return `${start.format("D")} \u2014 ${end.format("D")} ${start.format(
      //       "MMM YYYY"
      //     )}`;
      if (date == null) return;
      const start = moment(date, "YYYY-MM-DD");
      if (start == moment().format("YYYY-MM-DD")) {
        return "Today";
      } else {
        return `${start.format("dddd, MMMM Do YYYY")}`;
      }
    },
    getDuration() {
      if (this.start_time == null && this.end_time == null) return;
      return `${this.start_time} \u2014 ${this.end_time}`;
    },
    getCarParkLocation() {
      if (this.booking && this.booking.vehicle) {
        const vehicle = this.getVehicles.find((v) => v.id == this.booking.vehicle);
        if (vehicle) {
          return get(vehicle, 'metadata.parking_location', '');
        }
      }
      return '';
    },
    getKeCabinetLocation() {
      if (this.booking && this.booking.vehicle) {
        const vehicle = this.getVehicles.find((v) => v.id == this.booking.vehicle);
        if (vehicle) {
          return get(vehicle, 'cabinet_name', '');
        }
      }
      return '';
    },
    getUserManage() {
      if (
        isUndefined(this.$store.state.user.user.metadata.user_manage) ||
        isNull(this.$store.state.user.user.metadata.user_manage)
      ) {
        this.userManageData = [];
      } else {
        this.$store
          .dispatch("API_CALL", {
            $method: "get_all",
            $postData: {
              clientid: this.clientid
            }
          })
          .then(response => {
            let userManage = this.$store.state.user.user.metadata.user_manage;
            userManage.forEach(v => {
              this.userManageData = response.data.data.find(u => u.id == v);
            });
          });
      }
    },
    setManager() {
      if (
        isUndefined(this.$store.state.user.user.metadata.as_manager) ||
        isNull(this.$store.state.user.user.metadata.as_manager)
      ) {
        this.isManager = false;
      } else {
        this.isManager = this.$store.state.user.user.metadata.as_manager;
      }
    },
    closeAlertDefaultPwd() {
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      let userMetadata = {
        driver_license: {
          conditions: this.$store.state.user.user.metadata.driver_license
            .conditions,
          expiry_date: this.$store.state.user.user.metadata.driver_license
            .expiry_date,
          issuing_state: this.$store.state.user.user.metadata.driver_license
            .issuing_state,
          license_no: this.$store.state.user.user.metadata.driver_license
            .license_no,
          license_type: this.$store.state.user.user.metadata.driver_license
            .license_type
        },
        photo: this.$store.state.user.user.metadata.photo,
        default_password: false
      };

      const payloads2 = {
        metadata: userMetadata
      };

      this.$store.dispatch("UPDATE_USER", payloads2).then(() => {
        this.alertDefaultPwd = false;
      });
    },
    closeAlertChangePwd() {
      this.$refs.form_change_password.reset();
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      let userMetadata = {
        driver_license: {
          conditions: this.$store.state.user.user.metadata.driver_license
            .conditions,
          expiry_date: this.$store.state.user.user.metadata.driver_license
            .expiry_date,
          issuing_state: this.$store.state.user.user.metadata.driver_license
            .issuing_state,
          license_no: this.$store.state.user.user.metadata.driver_license
            .license_no,
          license_type: this.$store.state.user.user.metadata.driver_license
            .license_type
        },
        photo: this.$store.state.user.user.metadata.photo,
        default_password: false
      };

      const payloads2 = {
        metadata: userMetadata
      };

      this.$store.dispatch("UPDATE_USER", payloads2).then(() => {
        this.changeDefaultPwd = false;
      });
    },
    setInputAssetType($event) {
      this.selectedAssetType = $event;
    },
    setInputVehicleGroup($event) {
      this.selectedVehicleGroup = $event;
    },
    isHaveNoLimitAccess(vehicle) {
      const vehicleGroups = this.vehicleGroupsUsersAdmin.filter(group => group.members.find(member => member.detail.type_id == vehicle.type_id && member.detail.id == vehicle.id));
      const filteredNoLimitGroups = vehicleGroups.filter(group => group.metadata.hasOwnProperty('no_limit') && this.getValueAsBoolean(group.metadata.no_limit));
      if (filteredNoLimitGroups.length) {
        const noLimitGroup = filteredNoLimitGroups.find((group) => {
          if (this.bookingOtherUser) {
            return group.users.find(user => user.user_id == this.selectedOtherUser);
          } else {
            return group.users.find(user => user.user_id == this.$store.state.user.user.id);
          }
        });
        return !isUndefined(noLimitGroup);
      }
      return false;
    },
    // Whole days between the two dates, times ignored — the backend truncates
    // both ends to Y-m-d before subtracting. Counting the hours instead would
    // reject a booking the server accepts: 1 Aug 09:00 to 15 Aug 23:59 is 14.62
    // hours-wise but 14 days apart.
    exceedsMaxBookingDays(start, end) {
      const maxDays = this.maxBookingDays;
      if (!maxDays) return false;
      const startMoment = moment(start);
      const endMoment = moment(end);
      if (!startMoment.isValid() || !endMoment.isValid()) return false;
      return endMoment.startOf('day').diff(startMoment.startOf('day'), 'days') > maxDays;
    },
    // Vehicle and asset metadata can hold the literal strings "null" or
    // "undefined": VehicleManagement used to serialise an unset time as text.
    // Those are truthy, so the plain checks below concluded the vehicle had
    // working hours it could never satisfy — permanently unbookable, with
    // "Invalid date - Invalid date" in the dialog. Anything that will not parse
    // as a time is treated as not set, since a working time nothing can read is
    // not enforceable anyway. Formats are permissive because older rows predate
    // the current time picker.
    normaliseWorkingTime(value) {
      if (value === null || value === undefined) return '';
      const text = String(value).trim();
      if (text === '' || text === 'null' || text === 'undefined') return '';
      return moment(text, ['HH:mm', 'H:mm', 'HH:mm:ss'], true).isValid() ? text : '';
    },
    getWorkingTime(source, path) {
      const raw = get(source, path, {}) || {};
      return {
        start: this.normaliseWorkingTime(raw.start),
        end: this.normaliseWorkingTime(raw.end)
      };
    },
    getMinDate(type) {
      const dateRanges = this.dateRanges;
      if (type == "start") {
        return dateRanges[0];
      } else {
        return this.booking.date;
      }
    },
    getMaxDate(type) {
      if (type == 'end') {
        return moment(this.booking.date)
          .add(this.maxBookingDays, 'days')
          .format('YYYY-MM-DD');
      }
      const dateRanges = this.dateRanges;
      return dateRanges[dateRanges.length - 1];
    },
  }
};
</script>
<style lang="css" scoped>
.time__picker {
  border: 2px solid #d2d2d2;
  width: 100%;
  height: 55px;
  padding: 0.4em 1em;
  font-size: 1.2em;
  border-radius: 10%;
  border-radius: 4.5%;
}
.v-menu__content {
  margin-left: 20px;
}
.borderDestination {
  border: 0.5px solid #d2d2d2;
  border-radius: 10px;
}
</style>
<style lang="sass" scoped>
.m-count
  border-radius: 50%
  border: 2px #333 solid
  width: 30px
  height: 30px
  line-height: 28px
  text-align: center
  vertical-align: middle
  font-weight: bold
  cursor: pointer
  margin: 0 8px
  &-container
    display: flex
    flex-direction: row
    justify-content: center
    margin: 4px 0 8px 0
  &-available
    border-color: #bdbdbd
    color: #757575
  &-booked
    border-color: #42a5f5
    color: #1e88e5
  &-period
    border-color: #42f565
    color: #42f5bf
  &-done
    border-color: #ef5350
    color: #e53935
.m-schedule-time
  width: 8px
.td-icon
  max-width: 10px
  + td
    padding-left: 0px !important
    padding-right: 0px !important
.btn--calendar
    color: #424242
    border: #e0e0e0 1px solid
    .v-btn__content
      color: #424242 !important
.pointer
  cursor: pointer
.v-calendar .v-event-timed-container
  width: 250px
.text--event
  white-space: initial
  overflow: hidden
</style>
<style lang="scss">
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: "";
  }

  &:hover::after {
    display: block;
  }
}
</style>
<style>
.swal2-title {
  padding: 17px;
  display: block;
  margin: 22px;
  text-align: center;
  color: #61534e;
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-text {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-content {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
  text-align: center;
  color: #61534e;
}
.swal2-html {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-input {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-cancel {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-confirm {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.theme--light.v-calendar-daily .v-calendar-daily__day-interval:first-child {
  border-top: #e0e0e0 1px solid !important;
}

.second-work-order {
  border: 1px solid rgba(0, 0, 0, 0.50);
}
</style>
